import * as e from "react";
import { useState as t } from "react";
import * as n from "react-dom";
import { createPortal as r } from "react-dom";
import { Fragment as i, jsx as a, jsxs as o } from "react/jsx-runtime";
//#region src/components/ui/anchored-position.ts
var s = 8;
function c(t, { open: n, align: r = "start", gap: i = 4, width: a, estimatedHeight: o = 0, onAnchorMove: c = "update", onClose: l }) {
	let [u, d] = e.useState(null), f = e.useRef(l);
	return f.current = l, e.useLayoutEffect(() => {
		if (!n) {
			d(null);
			return;
		}
		let e = () => {
			let e = t.current;
			if (!e) return;
			let n = e.getBoundingClientRect(), c = a === "trigger" ? n.width : a, l = { position: "fixed" }, u = r === "end" && c !== void 0 ? n.right - c : n.left;
			c !== void 0 && (u = Math.min(u, window.innerWidth - c - s), l.width = c), l.left = Math.max(s, u);
			let f = n.bottom + i + o > window.innerHeight, p = n.top - i - o >= 0;
			o > 0 && f && p ? l.bottom = window.innerHeight - n.top + i : l.top = n.bottom + i, d(l);
		};
		e();
		let l = c === "close" ? () => f.current?.() : e;
		return window.addEventListener("scroll", l, !0), window.addEventListener("resize", l), () => {
			window.removeEventListener("scroll", l, !0), window.removeEventListener("resize", l);
		};
	}, [
		n,
		r,
		i,
		a,
		o,
		c,
		t
	]), u;
}
function l(e, ...t) {
	return e instanceof Node && t.some((t) => t.current?.contains(e) === !0);
}
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-compose-refs@1.1.5_@types+react@19.2.18_react@19.2.8/node_modules/@radix-ui/react-compose-refs/dist/index.mjs
var u = Object.defineProperty, d = (e, t) => u(e, "name", {
	value: t,
	configurable: !0
});
function f(e, t) {
	if (typeof e == "function") return e(t);
	e != null && (e.current = t);
}
d(f, "setRef");
function p(...e) {
	return (t) => {
		let n = !1, r = e.map((e) => {
			let r = f(e, t);
			return !n && typeof r == "function" && (n = !0), r;
		});
		if (n) return () => {
			for (let t = 0; t < r.length; t++) {
				let n = r[t];
				typeof n == "function" ? n() : f(e[t], null);
			}
		};
	};
}
d(p, "composeRefs");
function m(...t) {
	return e.useCallback(p(...t), t);
}
d(m, "useComposedRefs");
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-slot@1.3.3_@types+react@19.2.18_react@19.2.8/node_modules/@radix-ui/react-slot/dist/index.mjs
var h = Object.defineProperty, g = (e, t) => h(e, "name", {
	value: t,
	configurable: !0
});
// @__NO_SIDE_EFFECTS__
function _(t) {
	let n = e.forwardRef((n, r) => {
		let { children: i, ...a } = n, o = null, s = !1, c = [];
		E(i) && typeof A == "function" && (i = A(i._payload)), e.Children.forEach(i, (e) => {
			if (w(e)) {
				s = !0;
				let t = e, n = "child" in t.props ? t.props.child : t.props.children;
				E(n) && typeof A == "function" && (n = A(n._payload)), o = x(t, n), c.push(o?.props?.children);
			} else c.push(e);
		}), o ? o = e.cloneElement(o, void 0, c) : !s && e.Children.count(i) === 1 && e.isValidElement(i) && (o = i);
		let l = o ? C(o) : void 0, u = m(r, l);
		if (!o) {
			if (i || i === 0) throw Error(s ? k(t) : O(t));
			return i;
		}
		let d = S(a, o.props ?? {});
		return o.type !== e.Fragment && (d.ref = r ? u : l), e.cloneElement(o, d);
	});
	return n.displayName = `${t}.Slot`, n;
}
g(_, "createSlot");
var v = /* @__PURE__ */ _("Slot"), y = Symbol.for("radix.slottable");
// @__NO_SIDE_EFFECTS__
function b(e) {
	let t = /* @__PURE__ */ g((e) => "child" in e ? e.children(e.child) : e.children, "Slottable");
	return t.displayName = `${e}.Slottable`, t.__radixId = y, t;
}
g(b, "createSlottable");
var x = /* @__PURE__ */ g((t, n) => {
	if ("child" in t.props) {
		let n = t.props.child;
		return e.isValidElement(n) ? e.cloneElement(n, void 0, t.props.children(n.props.children)) : null;
	}
	return e.isValidElement(n) ? n : null;
}, "getSlottableElementFromSlottable");
function S(e, t) {
	let n = { ...t };
	for (let r in t) {
		let i = e[r], a = t[r];
		/^on[A-Z]/.test(r) ? i && a ? n[r] = (...e) => {
			let t = a(...e);
			return i(...e), t;
		} : i && (n[r] = i) : r === "style" ? n[r] = {
			...i,
			...a
		} : r === "className" && (n[r] = [i, a].filter(Boolean).join(" "));
	}
	return {
		...e,
		...n
	};
}
g(S, "mergeProps");
function C(e) {
	let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
	return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
g(C, "getElementRef");
function w(t) {
	return e.isValidElement(t) && typeof t.type == "function" && "__radixId" in t.type && t.type.__radixId === y;
}
g(w, "isSlottable");
var T = Symbol.for("react.lazy");
function E(e) {
	return typeof e == "object" && !!e && "$$typeof" in e && e.$$typeof === T && "_payload" in e && D(e._payload);
}
g(E, "isLazyComponent");
function D(e) {
	return typeof e == "object" && !!e && "then" in e;
}
g(D, "isPromiseLike");
var O = /* @__PURE__ */ g((e) => `${e} failed to slot onto its children. Expected a single React element child or \`Slottable\`.`, "createSlotError"), k = /* @__PURE__ */ g((e) => `${e} failed to slot onto its \`Slottable\`. Expected \`Slottable\` to receive a single React element child.`, "createSlottableError"), A = e.use, j = Object.defineProperty, M = (e, t) => j(e, "name", {
	value: t,
	configurable: !0
}), N = [
	"a",
	"button",
	"div",
	"form",
	"h2",
	"h3",
	"img",
	"input",
	"label",
	"li",
	"nav",
	"ol",
	"p",
	"select",
	"span",
	"svg",
	"ul"
].reduce((t, n) => {
	let r = /* @__PURE__ */ _(`Primitive.${n}`), i = e.forwardRef((e, t) => {
		let { asChild: i, ...o } = e, s = i ? r : n;
		return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ a(s, {
			...o,
			ref: t
		});
	});
	return i.displayName = `Primitive.${n}`, {
		...t,
		[n]: i
	};
}, {});
function P(e, t) {
	e && n.flushSync(() => e.dispatchEvent(t));
}
M(P, "dispatchDiscreteCustomEvent");
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-use-callback-ref@1.1.4_@types+react@19.2.18_react@19.2.8/node_modules/@radix-ui/react-use-callback-ref/dist/index.mjs
var F = Object.defineProperty, I = (e, t) => F(e, "name", {
	value: t,
	configurable: !0
});
function L(t) {
	let n = e.useRef(t);
	return e.useEffect(() => {
		n.current = t;
	}), e.useMemo(() => ((...e) => n.current?.(...e)), []);
}
I(L, "useCallbackRef");
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-focus-scope@1.1.16_@types+react-dom@19.2.4_@types+react@19.2.18__@types+react_cpmebpkjnwppiqaya6rzbfbhxq/node_modules/@radix-ui/react-focus-scope/dist/index.mjs
var ee = Object.defineProperty, R = (e, t) => ee(e, "name", {
	value: t,
	configurable: !0
}), te = "focusScope.autoFocusOnMount", z = "focusScope.autoFocusOnUnmount", B = {
	bubbles: !1,
	cancelable: !0
}, ne = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ R(function(t, n) {
	let { loop: r = !1, trapped: i = !1, onMountAutoFocus: o, onUnmountAutoFocus: s, ...c } = t, [l, u] = e.useState(null), d = L(o), f = L(s), p = e.useRef(null), h = m(n, u), g = e.useRef({
		paused: !1,
		pause() {
			this.paused = !0;
		},
		resume() {
			this.paused = !1;
		}
	}).current;
	e.useEffect(() => {
		if (i) {
			let e = function(e) {
				if (g.paused || !l) return;
				let t = e.target;
				l.contains(t) ? p.current = t : H(p.current, { select: !0 });
			}, t = function(e) {
				if (g.paused || !l) return;
				let t = e.relatedTarget;
				t !== null && (l.contains(t) || H(p.current, { select: !0 }));
			}, n = function(e) {
				if (document.activeElement === document.body) for (let t of e) t.removedNodes.length > 0 && H(l);
			};
			R(e, "handleFocusIn"), R(t, "handleFocusOut"), R(n, "handleMutations"), document.addEventListener("focusin", e), document.addEventListener("focusout", t);
			let r = new MutationObserver(n);
			return l && r.observe(l, {
				childList: !0,
				subtree: !0
			}), () => {
				document.removeEventListener("focusin", e), document.removeEventListener("focusout", t), r.disconnect();
			};
		}
	}, [
		i,
		l,
		g.paused
	]), e.useEffect(() => {
		if (l) {
			ce.add(g);
			let e = document.activeElement;
			if (!l.contains(e)) {
				let t = new CustomEvent(te, B);
				l.addEventListener(te, d), l.dispatchEvent(t), t.defaultPrevented || (re(de(ie(l)), { select: !0 }), document.activeElement === e && H(l));
			}
			return () => {
				l.removeEventListener(te, d), setTimeout(() => {
					let t = new CustomEvent(z, B);
					l.addEventListener(z, f), l.dispatchEvent(t), t.defaultPrevented || H(e ?? document.body, { select: !0 }), l.removeEventListener(z, f), ce.remove(g);
				}, 0);
			};
		}
	}, [
		l,
		d,
		f,
		g
	]);
	let _ = e.useCallback((e) => {
		if (!r && !i || g.paused) return;
		let t = e.key === "Tab" && !e.altKey && !e.ctrlKey && !e.metaKey, n = document.activeElement;
		if (t && n) {
			let t = e.currentTarget, [i, a] = V(t);
			i && a ? !e.shiftKey && n === a ? (e.preventDefault(), r && H(i, { select: !0 })) : e.shiftKey && n === i && (e.preventDefault(), r && H(a, { select: !0 })) : n === t && e.preventDefault();
		}
	}, [
		r,
		i,
		g.paused
	]);
	return /* @__PURE__ */ a(N.div, {
		tabIndex: -1,
		...c,
		ref: h,
		onKeyDown: _
	});
}, "FocusScope"));
function re(e, { select: t = !1 } = {}) {
	let n = document.activeElement;
	for (let r of e) if (H(r, { select: t }), document.activeElement !== n) return;
}
R(re, "focusFirst");
function V(e) {
	let t = ie(e);
	return [ae(t, e), ae(t.reverse(), e)];
}
R(V, "getTabbableEdges");
function ie(e) {
	let t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, { acceptNode: /* @__PURE__ */ R((e) => {
		let t = e.tagName === "INPUT" && e.type === "hidden";
		return e.disabled || e.hidden || t ? NodeFilter.FILTER_SKIP : e.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
	}, "acceptNode") });
	for (; n.nextNode();) t.push(n.currentNode);
	return t;
}
R(ie, "getTabbableCandidates");
function ae(e, t) {
	let n = typeof t.checkVisibility == "function" && t.checkVisibility({ checkVisibilityCSS: !0 });
	for (let r of e) if (!(n ? !r.checkVisibility({ checkVisibilityCSS: !0 }) : oe(r, { upTo: t }))) return r;
}
R(ae, "findVisible");
function oe(e, { upTo: t }) {
	if (getComputedStyle(e).visibility === "hidden") return !0;
	for (; e;) {
		if (t !== void 0 && e === t) return !1;
		if (getComputedStyle(e).display === "none") return !0;
		e = e.parentElement;
	}
	return !1;
}
R(oe, "isHidden");
function se(e) {
	return e instanceof HTMLInputElement && "select" in e;
}
R(se, "isSelectableInput");
function H(e, { select: t = !1 } = {}) {
	if (e && e.focus) {
		let n = document.activeElement;
		e.focus({ preventScroll: !0 }), e !== n && se(e) && t && e.select();
	}
}
R(H, "focus");
var ce = le();
function le() {
	let e = [];
	return {
		add(t) {
			let n = e[0];
			t !== n && n?.pause(), e = ue(e, t), e.unshift(t);
		},
		remove(t) {
			e = ue(e, t), e[0]?.resume();
		}
	};
}
R(le, "createFocusScopesStack");
function ue(e, t) {
	let n = [...e], r = n.indexOf(t);
	return r !== -1 && n.splice(r, 1), n;
}
R(ue, "arrayRemove");
function de(e) {
	return e.filter((e) => e.tagName !== "A");
}
R(de, "removeLinks");
//#endregion
//#region ../../node_modules/.pnpm/clsx@2.1.1/node_modules/clsx/dist/clsx.mjs
function fe(e) {
	var t, n, r = "";
	if (typeof e == "string" || typeof e == "number") r += e;
	else if (typeof e == "object") {
		if (Array.isArray(e)) {
			var i = e.length;
			for (t = 0; t < i; t++) e[t] && (n = fe(e[t])) && (r && (r += " "), r += n);
		} else for (n in e) e[n] && (r && (r += " "), r += n);
	}
	return r;
}
function pe() {
	for (var e, t, n = 0, r = "", i = arguments.length; n < i; n++) (e = arguments[n]) && (t = fe(e)) && (r && (r += " "), r += t);
	return r;
}
//#endregion
//#region ../../node_modules/.pnpm/tailwind-merge@3.6.0/node_modules/tailwind-merge/dist/bundle-mjs.mjs
var me = (e, t) => {
	let n = Array(e.length + t.length);
	for (let t = 0; t < e.length; t++) n[t] = e[t];
	for (let r = 0; r < t.length; r++) n[e.length + r] = t[r];
	return n;
}, he = (e, t) => ({
	classGroupId: e,
	validator: t
}), ge = (e = /* @__PURE__ */ new Map(), t = null, n) => ({
	nextPart: e,
	validators: t,
	classGroupId: n
}), _e = "-", ve = [], ye = "arbitrary..", be = (e) => {
	let t = Ce(e), { conflictingClassGroups: n, conflictingClassGroupModifiers: r } = e;
	return {
		getClassGroupId: (e) => {
			if (e.startsWith("[") && e.endsWith("]")) return Se(e);
			let n = e.split(_e);
			return xe(n, +(n[0] === "" && n.length > 1), t);
		},
		getConflictingClassGroupIds: (e, t) => {
			if (t) {
				let t = r[e], i = n[e];
				return t ? i ? me(i, t) : t : i || ve;
			}
			return n[e] || ve;
		}
	};
}, xe = (e, t, n) => {
	if (e.length - t === 0) return n.classGroupId;
	let r = e[t], i = n.nextPart.get(r);
	if (i) {
		let n = xe(e, t + 1, i);
		if (n) return n;
	}
	let a = n.validators;
	if (a === null) return;
	let o = t === 0 ? e.join(_e) : e.slice(t).join(_e), s = a.length;
	for (let e = 0; e < s; e++) {
		let t = a[e];
		if (t.validator(o)) return t.classGroupId;
	}
}, Se = (e) => e.slice(1, -1).indexOf(":") === -1 ? void 0 : (() => {
	let t = e.slice(1, -1), n = t.indexOf(":"), r = t.slice(0, n);
	return r ? ye + r : void 0;
})(), Ce = (e) => {
	let { theme: t, classGroups: n } = e;
	return we(n, t);
}, we = (e, t) => {
	let n = ge();
	for (let r in e) {
		let i = e[r];
		Te(i, n, r, t);
	}
	return n;
}, Te = (e, t, n, r) => {
	let i = e.length;
	for (let a = 0; a < i; a++) {
		let i = e[a];
		Ee(i, t, n, r);
	}
}, Ee = (e, t, n, r) => {
	if (typeof e == "string") {
		De(e, t, n);
		return;
	}
	if (typeof e == "function") {
		Oe(e, t, n, r);
		return;
	}
	ke(e, t, n, r);
}, De = (e, t, n) => {
	let r = e === "" ? t : Ae(t, e);
	r.classGroupId = n;
}, Oe = (e, t, n, r) => {
	if (je(e)) {
		Te(e(r), t, n, r);
		return;
	}
	t.validators === null && (t.validators = []), t.validators.push(he(n, e));
}, ke = (e, t, n, r) => {
	let i = Object.entries(e), a = i.length;
	for (let e = 0; e < a; e++) {
		let [a, o] = i[e];
		Te(o, Ae(t, a), n, r);
	}
}, Ae = (e, t) => {
	let n = e, r = t.split(_e), i = r.length;
	for (let e = 0; e < i; e++) {
		let t = r[e], i = n.nextPart.get(t);
		i || (i = ge(), n.nextPart.set(t, i)), n = i;
	}
	return n;
}, je = (e) => "isThemeGetter" in e && e.isThemeGetter === !0, Me = (e) => {
	if (e < 1) return {
		get: () => void 0,
		set: () => {}
	};
	let t = 0, n = Object.create(null), r = Object.create(null), i = (i, a) => {
		n[i] = a, t++, t > e && (t = 0, r = n, n = Object.create(null));
	};
	return {
		get(e) {
			let t = n[e];
			if (t !== void 0) return t;
			if ((t = r[e]) !== void 0) return i(e, t), t;
		},
		set(e, t) {
			e in n ? n[e] = t : i(e, t);
		}
	};
}, Ne = "!", Pe = ":", Fe = [], Ie = (e, t, n, r, i) => ({
	modifiers: e,
	hasImportantModifier: t,
	baseClassName: n,
	maybePostfixModifierPosition: r,
	isExternal: i
}), Le = (e) => {
	let { prefix: t, experimentalParseClassName: n } = e, r = (e) => {
		let t = [], n = 0, r = 0, i = 0, a, o = e.length;
		for (let s = 0; s < o; s++) {
			let o = e[s];
			if (n === 0 && r === 0) {
				if (o === Pe) {
					t.push(e.slice(i, s)), i = s + 1;
					continue;
				}
				if (o === "/") {
					a = s;
					continue;
				}
			}
			o === "[" ? n++ : o === "]" ? n-- : o === "(" ? r++ : o === ")" && r--;
		}
		let s = t.length === 0 ? e : e.slice(i), c = s, l = !1;
		s.endsWith(Ne) ? (c = s.slice(0, -1), l = !0) : s.startsWith(Ne) && (c = s.slice(1), l = !0);
		let u = a && a > i ? a - i : void 0;
		return Ie(t, l, c, u);
	};
	if (t) {
		let e = t + Pe, n = r;
		r = (t) => t.startsWith(e) ? n(t.slice(e.length)) : Ie(Fe, !1, t, void 0, !0);
	}
	if (n) {
		let e = r;
		r = (t) => n({
			className: t,
			parseClassName: e
		});
	}
	return r;
}, Re = (e) => {
	let t = /* @__PURE__ */ new Map();
	return e.orderSensitiveModifiers.forEach((e, n) => {
		t.set(e, 1e6 + n);
	}), (e) => {
		let n = [], r = [];
		for (let i = 0; i < e.length; i++) {
			let a = e[i], o = a[0] === "[", s = t.has(a);
			o || s ? (r.length > 0 && (r.sort(), n.push(...r), r = []), n.push(a)) : r.push(a);
		}
		return r.length > 0 && (r.sort(), n.push(...r)), n;
	};
}, ze = (e) => ({
	cache: Me(e.cacheSize),
	parseClassName: Le(e),
	sortModifiers: Re(e),
	postfixLookupClassGroupIds: Be(e),
	...be(e)
}), Be = (e) => {
	let t = Object.create(null), n = e.postfixLookupClassGroups;
	if (n) for (let e = 0; e < n.length; e++) t[n[e]] = !0;
	return t;
}, Ve = /\s+/, He = (e, t) => {
	let { parseClassName: n, getClassGroupId: r, getConflictingClassGroupIds: i, sortModifiers: a, postfixLookupClassGroupIds: o } = t, s = [], c = e.trim().split(Ve), l = "";
	for (let e = c.length - 1; e >= 0; --e) {
		let t = c[e], { isExternal: u, modifiers: d, hasImportantModifier: f, baseClassName: p, maybePostfixModifierPosition: m } = n(t);
		if (u) {
			l = t + (l.length > 0 ? " " + l : l);
			continue;
		}
		let h = !!m, g;
		if (h) {
			g = r(p.substring(0, m));
			let e = g && o[g] ? r(p) : void 0;
			e && e !== g && (g = e, h = !1);
		} else g = r(p);
		if (!g) {
			if (!h) {
				l = t + (l.length > 0 ? " " + l : l);
				continue;
			}
			if (g = r(p), !g) {
				l = t + (l.length > 0 ? " " + l : l);
				continue;
			}
			h = !1;
		}
		let _ = d.length === 0 ? "" : d.length === 1 ? d[0] : a(d).join(":"), v = f ? _ + Ne : _, y = v + g;
		if (s.indexOf(y) > -1) continue;
		s.push(y);
		let b = i(g, h);
		for (let e = 0; e < b.length; ++e) {
			let t = b[e];
			s.push(v + t);
		}
		l = t + (l.length > 0 ? " " + l : l);
	}
	return l;
}, Ue = (...e) => {
	let t = 0, n, r, i = "";
	for (; t < e.length;) (n = e[t++]) && (r = We(n)) && (i && (i += " "), i += r);
	return i;
}, We = (e) => {
	if (typeof e == "string") return e;
	let t, n = "";
	for (let r = 0; r < e.length; r++) e[r] && (t = We(e[r])) && (n && (n += " "), n += t);
	return n;
}, Ge = (e, ...t) => {
	let n, r, i, a, o = (o) => (n = ze(t.reduce((e, t) => t(e), e())), r = n.cache.get, i = n.cache.set, a = s, s(o)), s = (e) => {
		let t = r(e);
		if (t) return t;
		let a = He(e, n);
		return i(e, a), a;
	};
	return a = o, (...e) => a(Ue(...e));
}, Ke = [], U = (e) => {
	let t = (t) => t[e] || Ke;
	return t.isThemeGetter = !0, t;
}, qe = /^\[(?:(\w[\w-]*):)?(.+)\]$/i, Je = /^\((?:(\w[\w-]*):)?(.+)\)$/i, Ye = /^\d+(?:\.\d+)?\/\d+(?:\.\d+)?$/, Xe = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, Ze = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, Qe = /^(rgba?|hsla?|hwb|(ok)?(lab|lch)|color-mix)\(.+\)$/, $e = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, et = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, tt = (e) => Ye.test(e), W = (e) => !!e && !Number.isNaN(Number(e)), G = (e) => !!e && Number.isInteger(Number(e)), nt = (e) => e.endsWith("%") && W(e.slice(0, -1)), rt = (e) => Xe.test(e), it = () => !0, at = (e) => Ze.test(e) && !Qe.test(e), ot = () => !1, st = (e) => $e.test(e), ct = (e) => et.test(e), lt = (e) => !K(e) && !q(e), ut = (e) => e.startsWith("@container") && (e[10] === "/" && e[11] !== void 0 || e[11] === "s" && e[16] !== void 0 && e.startsWith("-size/", 10) || e[11] === "n" && e[18] !== void 0 && e.startsWith("-normal/", 10)), dt = (e) => Et(e, At, ot), K = (e) => qe.test(e), ft = (e) => Et(e, jt, at), pt = (e) => Et(e, Mt, W), mt = (e) => Et(e, Pt, it), ht = (e) => Et(e, Nt, ot), gt = (e) => Et(e, Ot, ot), _t = (e) => Et(e, kt, ct), vt = (e) => Et(e, Ft, st), q = (e) => Je.test(e), yt = (e) => Dt(e, jt), bt = (e) => Dt(e, Nt), xt = (e) => Dt(e, Ot), St = (e) => Dt(e, At), Ct = (e) => Dt(e, kt), wt = (e) => Dt(e, Ft, !0), Tt = (e) => Dt(e, Pt, !0), Et = (e, t, n) => {
	let r = qe.exec(e);
	return r ? r[1] ? t(r[1]) : n(r[2]) : !1;
}, Dt = (e, t, n = !1) => {
	let r = Je.exec(e);
	return r ? r[1] ? t(r[1]) : n : !1;
}, Ot = (e) => e === "position" || e === "percentage", kt = (e) => e === "image" || e === "url", At = (e) => e === "length" || e === "size" || e === "bg-size", jt = (e) => e === "length", Mt = (e) => e === "number", Nt = (e) => e === "family-name", Pt = (e) => e === "number" || e === "weight", Ft = (e) => e === "shadow", It = /*#__PURE__*/ Ge(() => {
	let e = U("color"), t = U("font"), n = U("text"), r = U("font-weight"), i = U("tracking"), a = U("leading"), o = U("breakpoint"), s = U("container"), c = U("spacing"), l = U("radius"), u = U("shadow"), d = U("inset-shadow"), f = U("text-shadow"), p = U("drop-shadow"), m = U("blur"), h = U("perspective"), g = U("aspect"), _ = U("ease"), v = U("animate"), y = () => [
		"auto",
		"avoid",
		"all",
		"avoid-page",
		"page",
		"left",
		"right",
		"column"
	], b = () => [
		"center",
		"top",
		"bottom",
		"left",
		"right",
		"top-left",
		"left-top",
		"top-right",
		"right-top",
		"bottom-right",
		"right-bottom",
		"bottom-left",
		"left-bottom"
	], x = () => [
		...b(),
		q,
		K
	], S = () => [
		"auto",
		"hidden",
		"clip",
		"visible",
		"scroll"
	], C = () => [
		"auto",
		"contain",
		"none"
	], w = () => [
		q,
		K,
		c
	], T = () => [
		tt,
		"full",
		"auto",
		...w()
	], E = () => [
		G,
		"none",
		"subgrid",
		q,
		K
	], D = () => [
		"auto",
		{ span: [
			"full",
			G,
			q,
			K
		] },
		G,
		q,
		K
	], O = () => [
		G,
		"auto",
		q,
		K
	], k = () => [
		"auto",
		"min",
		"max",
		"fr",
		q,
		K
	], A = () => [
		"start",
		"end",
		"center",
		"between",
		"around",
		"evenly",
		"stretch",
		"baseline",
		"center-safe",
		"end-safe"
	], j = () => [
		"start",
		"end",
		"center",
		"stretch",
		"center-safe",
		"end-safe"
	], M = () => ["auto", ...w()], N = () => [
		tt,
		"auto",
		"full",
		"dvw",
		"dvh",
		"lvw",
		"lvh",
		"svw",
		"svh",
		"min",
		"max",
		"fit",
		...w()
	], P = () => [
		tt,
		"screen",
		"full",
		"dvw",
		"lvw",
		"svw",
		"min",
		"max",
		"fit",
		...w()
	], F = () => [
		tt,
		"screen",
		"full",
		"lh",
		"dvh",
		"lvh",
		"svh",
		"min",
		"max",
		"fit",
		...w()
	], I = () => [
		e,
		q,
		K
	], L = () => [
		...b(),
		xt,
		gt,
		{ position: [q, K] }
	], ee = () => ["no-repeat", { repeat: [
		"",
		"x",
		"y",
		"space",
		"round"
	] }], R = () => [
		"auto",
		"cover",
		"contain",
		St,
		dt,
		{ size: [q, K] }
	], te = () => [
		nt,
		yt,
		ft
	], z = () => [
		"",
		"none",
		"full",
		l,
		q,
		K
	], B = () => [
		"",
		W,
		yt,
		ft
	], ne = () => [
		"solid",
		"dashed",
		"dotted",
		"double"
	], re = () => [
		"normal",
		"multiply",
		"screen",
		"overlay",
		"darken",
		"lighten",
		"color-dodge",
		"color-burn",
		"hard-light",
		"soft-light",
		"difference",
		"exclusion",
		"hue",
		"saturation",
		"color",
		"luminosity"
	], V = () => [
		W,
		nt,
		xt,
		gt
	], ie = () => [
		"",
		"none",
		m,
		q,
		K
	], ae = () => [
		"none",
		W,
		q,
		K
	], oe = () => [
		"none",
		W,
		q,
		K
	], se = () => [
		W,
		q,
		K
	], H = () => [
		tt,
		"full",
		...w()
	];
	return {
		cacheSize: 500,
		theme: {
			animate: [
				"spin",
				"ping",
				"pulse",
				"bounce"
			],
			aspect: ["video"],
			blur: [rt],
			breakpoint: [rt],
			color: [it],
			container: [rt],
			"drop-shadow": [rt],
			ease: [
				"in",
				"out",
				"in-out"
			],
			font: [lt],
			"font-weight": [
				"thin",
				"extralight",
				"light",
				"normal",
				"medium",
				"semibold",
				"bold",
				"extrabold",
				"black"
			],
			"inset-shadow": [rt],
			leading: [
				"none",
				"tight",
				"snug",
				"normal",
				"relaxed",
				"loose"
			],
			perspective: [
				"dramatic",
				"near",
				"normal",
				"midrange",
				"distant",
				"none"
			],
			radius: [rt],
			shadow: [rt],
			spacing: ["px", W],
			text: [rt],
			"text-shadow": [rt],
			tracking: [
				"tighter",
				"tight",
				"normal",
				"wide",
				"wider",
				"widest"
			]
		},
		classGroups: {
			aspect: [{ aspect: [
				"auto",
				"square",
				tt,
				K,
				q,
				g
			] }],
			container: ["container"],
			"container-type": [{ "@container": [
				"",
				"normal",
				"size",
				q,
				K
			] }],
			"container-named": [ut],
			columns: [{ columns: [
				W,
				K,
				q,
				s
			] }],
			"break-after": [{ "break-after": y() }],
			"break-before": [{ "break-before": y() }],
			"break-inside": [{ "break-inside": [
				"auto",
				"avoid",
				"avoid-page",
				"avoid-column"
			] }],
			"box-decoration": [{ "box-decoration": ["slice", "clone"] }],
			box: [{ box: ["border", "content"] }],
			display: [
				"block",
				"inline-block",
				"inline",
				"flex",
				"inline-flex",
				"table",
				"inline-table",
				"table-caption",
				"table-cell",
				"table-column",
				"table-column-group",
				"table-footer-group",
				"table-header-group",
				"table-row-group",
				"table-row",
				"flow-root",
				"grid",
				"inline-grid",
				"contents",
				"list-item",
				"hidden"
			],
			sr: ["sr-only", "not-sr-only"],
			float: [{ float: [
				"right",
				"left",
				"none",
				"start",
				"end"
			] }],
			clear: [{ clear: [
				"left",
				"right",
				"both",
				"none",
				"start",
				"end"
			] }],
			isolation: ["isolate", "isolation-auto"],
			"object-fit": [{ object: [
				"contain",
				"cover",
				"fill",
				"none",
				"scale-down"
			] }],
			"object-position": [{ object: x() }],
			overflow: [{ overflow: S() }],
			"overflow-x": [{ "overflow-x": S() }],
			"overflow-y": [{ "overflow-y": S() }],
			overscroll: [{ overscroll: C() }],
			"overscroll-x": [{ "overscroll-x": C() }],
			"overscroll-y": [{ "overscroll-y": C() }],
			position: [
				"static",
				"fixed",
				"absolute",
				"relative",
				"sticky"
			],
			inset: [{ inset: T() }],
			"inset-x": [{ "inset-x": T() }],
			"inset-y": [{ "inset-y": T() }],
			start: [{
				"inset-s": T(),
				start: T()
			}],
			end: [{
				"inset-e": T(),
				end: T()
			}],
			"inset-bs": [{ "inset-bs": T() }],
			"inset-be": [{ "inset-be": T() }],
			top: [{ top: T() }],
			right: [{ right: T() }],
			bottom: [{ bottom: T() }],
			left: [{ left: T() }],
			visibility: [
				"visible",
				"invisible",
				"collapse"
			],
			z: [{ z: [
				G,
				"auto",
				q,
				K
			] }],
			basis: [{ basis: [
				tt,
				"full",
				"auto",
				s,
				...w()
			] }],
			"flex-direction": [{ flex: [
				"row",
				"row-reverse",
				"col",
				"col-reverse"
			] }],
			"flex-wrap": [{ flex: [
				"nowrap",
				"wrap",
				"wrap-reverse"
			] }],
			flex: [{ flex: [
				W,
				tt,
				"auto",
				"initial",
				"none",
				K
			] }],
			grow: [{ grow: [
				"",
				W,
				q,
				K
			] }],
			shrink: [{ shrink: [
				"",
				W,
				q,
				K
			] }],
			order: [{ order: [
				G,
				"first",
				"last",
				"none",
				q,
				K
			] }],
			"grid-cols": [{ "grid-cols": E() }],
			"col-start-end": [{ col: D() }],
			"col-start": [{ "col-start": O() }],
			"col-end": [{ "col-end": O() }],
			"grid-rows": [{ "grid-rows": E() }],
			"row-start-end": [{ row: D() }],
			"row-start": [{ "row-start": O() }],
			"row-end": [{ "row-end": O() }],
			"grid-flow": [{ "grid-flow": [
				"row",
				"col",
				"dense",
				"row-dense",
				"col-dense"
			] }],
			"auto-cols": [{ "auto-cols": k() }],
			"auto-rows": [{ "auto-rows": k() }],
			gap: [{ gap: w() }],
			"gap-x": [{ "gap-x": w() }],
			"gap-y": [{ "gap-y": w() }],
			"justify-content": [{ justify: [...A(), "normal"] }],
			"justify-items": [{ "justify-items": [...j(), "normal"] }],
			"justify-self": [{ "justify-self": ["auto", ...j()] }],
			"align-content": [{ content: ["normal", ...A()] }],
			"align-items": [{ items: [...j(), { baseline: ["", "last"] }] }],
			"align-self": [{ self: [
				"auto",
				...j(),
				{ baseline: ["", "last"] }
			] }],
			"place-content": [{ "place-content": A() }],
			"place-items": [{ "place-items": [...j(), "baseline"] }],
			"place-self": [{ "place-self": ["auto", ...j()] }],
			p: [{ p: w() }],
			px: [{ px: w() }],
			py: [{ py: w() }],
			ps: [{ ps: w() }],
			pe: [{ pe: w() }],
			pbs: [{ pbs: w() }],
			pbe: [{ pbe: w() }],
			pt: [{ pt: w() }],
			pr: [{ pr: w() }],
			pb: [{ pb: w() }],
			pl: [{ pl: w() }],
			m: [{ m: M() }],
			mx: [{ mx: M() }],
			my: [{ my: M() }],
			ms: [{ ms: M() }],
			me: [{ me: M() }],
			mbs: [{ mbs: M() }],
			mbe: [{ mbe: M() }],
			mt: [{ mt: M() }],
			mr: [{ mr: M() }],
			mb: [{ mb: M() }],
			ml: [{ ml: M() }],
			"space-x": [{ "space-x": w() }],
			"space-x-reverse": ["space-x-reverse"],
			"space-y": [{ "space-y": w() }],
			"space-y-reverse": ["space-y-reverse"],
			size: [{ size: N() }],
			"inline-size": [{ inline: ["auto", ...P()] }],
			"min-inline-size": [{ "min-inline": ["auto", ...P()] }],
			"max-inline-size": [{ "max-inline": ["none", ...P()] }],
			"block-size": [{ block: ["auto", ...F()] }],
			"min-block-size": [{ "min-block": ["auto", ...F()] }],
			"max-block-size": [{ "max-block": ["none", ...F()] }],
			w: [{ w: [
				s,
				"screen",
				...N()
			] }],
			"min-w": [{ "min-w": [
				s,
				"screen",
				"none",
				...N()
			] }],
			"max-w": [{ "max-w": [
				s,
				"screen",
				"none",
				"prose",
				{ screen: [o] },
				...N()
			] }],
			h: [{ h: [
				"screen",
				"lh",
				...N()
			] }],
			"min-h": [{ "min-h": [
				"screen",
				"lh",
				"none",
				...N()
			] }],
			"max-h": [{ "max-h": [
				"screen",
				"lh",
				...N()
			] }],
			"font-size": [{ text: [
				"base",
				n,
				yt,
				ft
			] }],
			"font-smoothing": ["antialiased", "subpixel-antialiased"],
			"font-style": ["italic", "not-italic"],
			"font-weight": [{ font: [
				r,
				Tt,
				mt
			] }],
			"font-stretch": [{ "font-stretch": [
				"ultra-condensed",
				"extra-condensed",
				"condensed",
				"semi-condensed",
				"normal",
				"semi-expanded",
				"expanded",
				"extra-expanded",
				"ultra-expanded",
				nt,
				K
			] }],
			"font-family": [{ font: [
				bt,
				ht,
				t
			] }],
			"font-features": [{ "font-features": [K] }],
			"fvn-normal": ["normal-nums"],
			"fvn-ordinal": ["ordinal"],
			"fvn-slashed-zero": ["slashed-zero"],
			"fvn-figure": ["lining-nums", "oldstyle-nums"],
			"fvn-spacing": ["proportional-nums", "tabular-nums"],
			"fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
			tracking: [{ tracking: [
				i,
				q,
				K
			] }],
			"line-clamp": [{ "line-clamp": [
				W,
				"none",
				q,
				pt
			] }],
			leading: [{ leading: [a, ...w()] }],
			"list-image": [{ "list-image": [
				"none",
				q,
				K
			] }],
			"list-style-position": [{ list: ["inside", "outside"] }],
			"list-style-type": [{ list: [
				"disc",
				"decimal",
				"none",
				q,
				K
			] }],
			"text-alignment": [{ text: [
				"left",
				"center",
				"right",
				"justify",
				"start",
				"end"
			] }],
			"placeholder-color": [{ placeholder: I() }],
			"text-color": [{ text: I() }],
			"text-decoration": [
				"underline",
				"overline",
				"line-through",
				"no-underline"
			],
			"text-decoration-style": [{ decoration: [...ne(), "wavy"] }],
			"text-decoration-thickness": [{ decoration: [
				W,
				"from-font",
				"auto",
				q,
				ft
			] }],
			"text-decoration-color": [{ decoration: I() }],
			"underline-offset": [{ "underline-offset": [
				W,
				"auto",
				q,
				K
			] }],
			"text-transform": [
				"uppercase",
				"lowercase",
				"capitalize",
				"normal-case"
			],
			"text-overflow": [
				"truncate",
				"text-ellipsis",
				"text-clip"
			],
			"text-wrap": [{ text: [
				"wrap",
				"nowrap",
				"balance",
				"pretty"
			] }],
			indent: [{ indent: w() }],
			"tab-size": [{ tab: [
				G,
				q,
				K
			] }],
			"vertical-align": [{ align: [
				"baseline",
				"top",
				"middle",
				"bottom",
				"text-top",
				"text-bottom",
				"sub",
				"super",
				q,
				K
			] }],
			whitespace: [{ whitespace: [
				"normal",
				"nowrap",
				"pre",
				"pre-line",
				"pre-wrap",
				"break-spaces"
			] }],
			break: [{ break: [
				"normal",
				"words",
				"all",
				"keep"
			] }],
			wrap: [{ wrap: [
				"break-word",
				"anywhere",
				"normal"
			] }],
			hyphens: [{ hyphens: [
				"none",
				"manual",
				"auto"
			] }],
			content: [{ content: [
				"none",
				q,
				K
			] }],
			"bg-attachment": [{ bg: [
				"fixed",
				"local",
				"scroll"
			] }],
			"bg-clip": [{ "bg-clip": [
				"border",
				"padding",
				"content",
				"text"
			] }],
			"bg-origin": [{ "bg-origin": [
				"border",
				"padding",
				"content"
			] }],
			"bg-position": [{ bg: L() }],
			"bg-repeat": [{ bg: ee() }],
			"bg-size": [{ bg: R() }],
			"bg-image": [{ bg: [
				"none",
				{
					linear: [
						{ to: [
							"t",
							"tr",
							"r",
							"br",
							"b",
							"bl",
							"l",
							"tl"
						] },
						G,
						q,
						K
					],
					radial: [
						"",
						q,
						K
					],
					conic: [
						G,
						q,
						K
					]
				},
				Ct,
				_t
			] }],
			"bg-color": [{ bg: I() }],
			"gradient-from-pos": [{ from: te() }],
			"gradient-via-pos": [{ via: te() }],
			"gradient-to-pos": [{ to: te() }],
			"gradient-from": [{ from: I() }],
			"gradient-via": [{ via: I() }],
			"gradient-to": [{ to: I() }],
			rounded: [{ rounded: z() }],
			"rounded-s": [{ "rounded-s": z() }],
			"rounded-e": [{ "rounded-e": z() }],
			"rounded-t": [{ "rounded-t": z() }],
			"rounded-r": [{ "rounded-r": z() }],
			"rounded-b": [{ "rounded-b": z() }],
			"rounded-l": [{ "rounded-l": z() }],
			"rounded-ss": [{ "rounded-ss": z() }],
			"rounded-se": [{ "rounded-se": z() }],
			"rounded-ee": [{ "rounded-ee": z() }],
			"rounded-es": [{ "rounded-es": z() }],
			"rounded-tl": [{ "rounded-tl": z() }],
			"rounded-tr": [{ "rounded-tr": z() }],
			"rounded-br": [{ "rounded-br": z() }],
			"rounded-bl": [{ "rounded-bl": z() }],
			"border-w": [{ border: B() }],
			"border-w-x": [{ "border-x": B() }],
			"border-w-y": [{ "border-y": B() }],
			"border-w-s": [{ "border-s": B() }],
			"border-w-e": [{ "border-e": B() }],
			"border-w-bs": [{ "border-bs": B() }],
			"border-w-be": [{ "border-be": B() }],
			"border-w-t": [{ "border-t": B() }],
			"border-w-r": [{ "border-r": B() }],
			"border-w-b": [{ "border-b": B() }],
			"border-w-l": [{ "border-l": B() }],
			"divide-x": [{ "divide-x": B() }],
			"divide-x-reverse": ["divide-x-reverse"],
			"divide-y": [{ "divide-y": B() }],
			"divide-y-reverse": ["divide-y-reverse"],
			"border-style": [{ border: [
				...ne(),
				"hidden",
				"none"
			] }],
			"divide-style": [{ divide: [
				...ne(),
				"hidden",
				"none"
			] }],
			"border-color": [{ border: I() }],
			"border-color-x": [{ "border-x": I() }],
			"border-color-y": [{ "border-y": I() }],
			"border-color-s": [{ "border-s": I() }],
			"border-color-e": [{ "border-e": I() }],
			"border-color-bs": [{ "border-bs": I() }],
			"border-color-be": [{ "border-be": I() }],
			"border-color-t": [{ "border-t": I() }],
			"border-color-r": [{ "border-r": I() }],
			"border-color-b": [{ "border-b": I() }],
			"border-color-l": [{ "border-l": I() }],
			"divide-color": [{ divide: I() }],
			"outline-style": [{ outline: [
				...ne(),
				"none",
				"hidden"
			] }],
			"outline-offset": [{ "outline-offset": [
				W,
				q,
				K
			] }],
			"outline-w": [{ outline: [
				"",
				W,
				yt,
				ft
			] }],
			"outline-color": [{ outline: I() }],
			shadow: [{ shadow: [
				"",
				"none",
				u,
				wt,
				vt
			] }],
			"shadow-color": [{ shadow: I() }],
			"inset-shadow": [{ "inset-shadow": [
				"none",
				d,
				wt,
				vt
			] }],
			"inset-shadow-color": [{ "inset-shadow": I() }],
			"ring-w": [{ ring: B() }],
			"ring-w-inset": ["ring-inset"],
			"ring-color": [{ ring: I() }],
			"ring-offset-w": [{ "ring-offset": [W, ft] }],
			"ring-offset-color": [{ "ring-offset": I() }],
			"inset-ring-w": [{ "inset-ring": B() }],
			"inset-ring-color": [{ "inset-ring": I() }],
			"text-shadow": [{ "text-shadow": [
				"none",
				f,
				wt,
				vt
			] }],
			"text-shadow-color": [{ "text-shadow": I() }],
			opacity: [{ opacity: [
				W,
				q,
				K
			] }],
			"mix-blend": [{ "mix-blend": [
				...re(),
				"plus-darker",
				"plus-lighter"
			] }],
			"bg-blend": [{ "bg-blend": re() }],
			"mask-clip": [{ "mask-clip": [
				"border",
				"padding",
				"content",
				"fill",
				"stroke",
				"view"
			] }, "mask-no-clip"],
			"mask-composite": [{ mask: [
				"add",
				"subtract",
				"intersect",
				"exclude"
			] }],
			"mask-image-linear-pos": [{ "mask-linear": [W] }],
			"mask-image-linear-from-pos": [{ "mask-linear-from": V() }],
			"mask-image-linear-to-pos": [{ "mask-linear-to": V() }],
			"mask-image-linear-from-color": [{ "mask-linear-from": I() }],
			"mask-image-linear-to-color": [{ "mask-linear-to": I() }],
			"mask-image-t-from-pos": [{ "mask-t-from": V() }],
			"mask-image-t-to-pos": [{ "mask-t-to": V() }],
			"mask-image-t-from-color": [{ "mask-t-from": I() }],
			"mask-image-t-to-color": [{ "mask-t-to": I() }],
			"mask-image-r-from-pos": [{ "mask-r-from": V() }],
			"mask-image-r-to-pos": [{ "mask-r-to": V() }],
			"mask-image-r-from-color": [{ "mask-r-from": I() }],
			"mask-image-r-to-color": [{ "mask-r-to": I() }],
			"mask-image-b-from-pos": [{ "mask-b-from": V() }],
			"mask-image-b-to-pos": [{ "mask-b-to": V() }],
			"mask-image-b-from-color": [{ "mask-b-from": I() }],
			"mask-image-b-to-color": [{ "mask-b-to": I() }],
			"mask-image-l-from-pos": [{ "mask-l-from": V() }],
			"mask-image-l-to-pos": [{ "mask-l-to": V() }],
			"mask-image-l-from-color": [{ "mask-l-from": I() }],
			"mask-image-l-to-color": [{ "mask-l-to": I() }],
			"mask-image-x-from-pos": [{ "mask-x-from": V() }],
			"mask-image-x-to-pos": [{ "mask-x-to": V() }],
			"mask-image-x-from-color": [{ "mask-x-from": I() }],
			"mask-image-x-to-color": [{ "mask-x-to": I() }],
			"mask-image-y-from-pos": [{ "mask-y-from": V() }],
			"mask-image-y-to-pos": [{ "mask-y-to": V() }],
			"mask-image-y-from-color": [{ "mask-y-from": I() }],
			"mask-image-y-to-color": [{ "mask-y-to": I() }],
			"mask-image-radial": [{ "mask-radial": [q, K] }],
			"mask-image-radial-from-pos": [{ "mask-radial-from": V() }],
			"mask-image-radial-to-pos": [{ "mask-radial-to": V() }],
			"mask-image-radial-from-color": [{ "mask-radial-from": I() }],
			"mask-image-radial-to-color": [{ "mask-radial-to": I() }],
			"mask-image-radial-shape": [{ "mask-radial": ["circle", "ellipse"] }],
			"mask-image-radial-size": [{ "mask-radial": [{
				closest: ["side", "corner"],
				farthest: ["side", "corner"]
			}] }],
			"mask-image-radial-pos": [{ "mask-radial-at": b() }],
			"mask-image-conic-pos": [{ "mask-conic": [W] }],
			"mask-image-conic-from-pos": [{ "mask-conic-from": V() }],
			"mask-image-conic-to-pos": [{ "mask-conic-to": V() }],
			"mask-image-conic-from-color": [{ "mask-conic-from": I() }],
			"mask-image-conic-to-color": [{ "mask-conic-to": I() }],
			"mask-mode": [{ mask: [
				"alpha",
				"luminance",
				"match"
			] }],
			"mask-origin": [{ "mask-origin": [
				"border",
				"padding",
				"content",
				"fill",
				"stroke",
				"view"
			] }],
			"mask-position": [{ mask: L() }],
			"mask-repeat": [{ mask: ee() }],
			"mask-size": [{ mask: R() }],
			"mask-type": [{ "mask-type": ["alpha", "luminance"] }],
			"mask-image": [{ mask: [
				"none",
				q,
				K
			] }],
			filter: [{ filter: [
				"",
				"none",
				q,
				K
			] }],
			blur: [{ blur: ie() }],
			brightness: [{ brightness: [
				W,
				q,
				K
			] }],
			contrast: [{ contrast: [
				W,
				q,
				K
			] }],
			"drop-shadow": [{ "drop-shadow": [
				"",
				"none",
				p,
				wt,
				vt
			] }],
			"drop-shadow-color": [{ "drop-shadow": I() }],
			grayscale: [{ grayscale: [
				"",
				W,
				q,
				K
			] }],
			"hue-rotate": [{ "hue-rotate": [
				W,
				q,
				K
			] }],
			invert: [{ invert: [
				"",
				W,
				q,
				K
			] }],
			saturate: [{ saturate: [
				W,
				q,
				K
			] }],
			sepia: [{ sepia: [
				"",
				W,
				q,
				K
			] }],
			"backdrop-filter": [{ "backdrop-filter": [
				"",
				"none",
				q,
				K
			] }],
			"backdrop-blur": [{ "backdrop-blur": ie() }],
			"backdrop-brightness": [{ "backdrop-brightness": [
				W,
				q,
				K
			] }],
			"backdrop-contrast": [{ "backdrop-contrast": [
				W,
				q,
				K
			] }],
			"backdrop-grayscale": [{ "backdrop-grayscale": [
				"",
				W,
				q,
				K
			] }],
			"backdrop-hue-rotate": [{ "backdrop-hue-rotate": [
				W,
				q,
				K
			] }],
			"backdrop-invert": [{ "backdrop-invert": [
				"",
				W,
				q,
				K
			] }],
			"backdrop-opacity": [{ "backdrop-opacity": [
				W,
				q,
				K
			] }],
			"backdrop-saturate": [{ "backdrop-saturate": [
				W,
				q,
				K
			] }],
			"backdrop-sepia": [{ "backdrop-sepia": [
				"",
				W,
				q,
				K
			] }],
			"border-collapse": [{ border: ["collapse", "separate"] }],
			"border-spacing": [{ "border-spacing": w() }],
			"border-spacing-x": [{ "border-spacing-x": w() }],
			"border-spacing-y": [{ "border-spacing-y": w() }],
			"table-layout": [{ table: ["auto", "fixed"] }],
			caption: [{ caption: ["top", "bottom"] }],
			transition: [{ transition: [
				"",
				"all",
				"colors",
				"opacity",
				"shadow",
				"transform",
				"none",
				q,
				K
			] }],
			"transition-behavior": [{ transition: ["normal", "discrete"] }],
			duration: [{ duration: [
				W,
				"initial",
				q,
				K
			] }],
			ease: [{ ease: [
				"linear",
				"initial",
				_,
				q,
				K
			] }],
			delay: [{ delay: [
				W,
				q,
				K
			] }],
			animate: [{ animate: [
				"none",
				v,
				q,
				K
			] }],
			backface: [{ backface: ["hidden", "visible"] }],
			perspective: [{ perspective: [
				h,
				q,
				K
			] }],
			"perspective-origin": [{ "perspective-origin": x() }],
			rotate: [{ rotate: ae() }],
			"rotate-x": [{ "rotate-x": ae() }],
			"rotate-y": [{ "rotate-y": ae() }],
			"rotate-z": [{ "rotate-z": ae() }],
			scale: [{ scale: oe() }],
			"scale-x": [{ "scale-x": oe() }],
			"scale-y": [{ "scale-y": oe() }],
			"scale-z": [{ "scale-z": oe() }],
			"scale-3d": ["scale-3d"],
			skew: [{ skew: se() }],
			"skew-x": [{ "skew-x": se() }],
			"skew-y": [{ "skew-y": se() }],
			transform: [{ transform: [
				q,
				K,
				"",
				"none",
				"gpu",
				"cpu"
			] }],
			"transform-origin": [{ origin: x() }],
			"transform-style": [{ transform: ["3d", "flat"] }],
			translate: [{ translate: H() }],
			"translate-x": [{ "translate-x": H() }],
			"translate-y": [{ "translate-y": H() }],
			"translate-z": [{ "translate-z": H() }],
			"translate-none": ["translate-none"],
			zoom: [{ zoom: [
				G,
				q,
				K
			] }],
			accent: [{ accent: I() }],
			appearance: [{ appearance: ["none", "auto"] }],
			"caret-color": [{ caret: I() }],
			"color-scheme": [{ scheme: [
				"normal",
				"dark",
				"light",
				"light-dark",
				"only-dark",
				"only-light"
			] }],
			cursor: [{ cursor: [
				"auto",
				"default",
				"pointer",
				"wait",
				"text",
				"move",
				"help",
				"not-allowed",
				"none",
				"context-menu",
				"progress",
				"cell",
				"crosshair",
				"vertical-text",
				"alias",
				"copy",
				"no-drop",
				"grab",
				"grabbing",
				"all-scroll",
				"col-resize",
				"row-resize",
				"n-resize",
				"e-resize",
				"s-resize",
				"w-resize",
				"ne-resize",
				"nw-resize",
				"se-resize",
				"sw-resize",
				"ew-resize",
				"ns-resize",
				"nesw-resize",
				"nwse-resize",
				"zoom-in",
				"zoom-out",
				q,
				K
			] }],
			"field-sizing": [{ "field-sizing": ["fixed", "content"] }],
			"pointer-events": [{ "pointer-events": ["auto", "none"] }],
			resize: [{ resize: [
				"none",
				"",
				"y",
				"x"
			] }],
			"scroll-behavior": [{ scroll: ["auto", "smooth"] }],
			"scrollbar-thumb-color": [{ "scrollbar-thumb": I() }],
			"scrollbar-track-color": [{ "scrollbar-track": I() }],
			"scrollbar-gutter": [{ "scrollbar-gutter": [
				"auto",
				"stable",
				"both"
			] }],
			"scrollbar-w": [{ scrollbar: [
				"auto",
				"thin",
				"none"
			] }],
			"scroll-m": [{ "scroll-m": w() }],
			"scroll-mx": [{ "scroll-mx": w() }],
			"scroll-my": [{ "scroll-my": w() }],
			"scroll-ms": [{ "scroll-ms": w() }],
			"scroll-me": [{ "scroll-me": w() }],
			"scroll-mbs": [{ "scroll-mbs": w() }],
			"scroll-mbe": [{ "scroll-mbe": w() }],
			"scroll-mt": [{ "scroll-mt": w() }],
			"scroll-mr": [{ "scroll-mr": w() }],
			"scroll-mb": [{ "scroll-mb": w() }],
			"scroll-ml": [{ "scroll-ml": w() }],
			"scroll-p": [{ "scroll-p": w() }],
			"scroll-px": [{ "scroll-px": w() }],
			"scroll-py": [{ "scroll-py": w() }],
			"scroll-ps": [{ "scroll-ps": w() }],
			"scroll-pe": [{ "scroll-pe": w() }],
			"scroll-pbs": [{ "scroll-pbs": w() }],
			"scroll-pbe": [{ "scroll-pbe": w() }],
			"scroll-pt": [{ "scroll-pt": w() }],
			"scroll-pr": [{ "scroll-pr": w() }],
			"scroll-pb": [{ "scroll-pb": w() }],
			"scroll-pl": [{ "scroll-pl": w() }],
			"snap-align": [{ snap: [
				"start",
				"end",
				"center",
				"align-none"
			] }],
			"snap-stop": [{ snap: ["normal", "always"] }],
			"snap-type": [{ snap: [
				"none",
				"x",
				"y",
				"both"
			] }],
			"snap-strictness": [{ snap: ["mandatory", "proximity"] }],
			touch: [{ touch: [
				"auto",
				"none",
				"manipulation"
			] }],
			"touch-x": [{ "touch-pan": [
				"x",
				"left",
				"right"
			] }],
			"touch-y": [{ "touch-pan": [
				"y",
				"up",
				"down"
			] }],
			"touch-pz": ["touch-pinch-zoom"],
			select: [{ select: [
				"none",
				"text",
				"all",
				"auto"
			] }],
			"will-change": [{ "will-change": [
				"auto",
				"scroll",
				"contents",
				"transform",
				q,
				K
			] }],
			fill: [{ fill: ["none", ...I()] }],
			"stroke-w": [{ stroke: [
				W,
				yt,
				ft,
				pt
			] }],
			stroke: [{ stroke: ["none", ...I()] }],
			"forced-color-adjust": [{ "forced-color-adjust": ["auto", "none"] }]
		},
		conflictingClassGroups: {
			"container-named": ["container-type"],
			overflow: ["overflow-x", "overflow-y"],
			overscroll: ["overscroll-x", "overscroll-y"],
			inset: [
				"inset-x",
				"inset-y",
				"inset-bs",
				"inset-be",
				"start",
				"end",
				"top",
				"right",
				"bottom",
				"left"
			],
			"inset-x": ["right", "left"],
			"inset-y": ["top", "bottom"],
			flex: [
				"basis",
				"grow",
				"shrink"
			],
			gap: ["gap-x", "gap-y"],
			p: [
				"px",
				"py",
				"ps",
				"pe",
				"pbs",
				"pbe",
				"pt",
				"pr",
				"pb",
				"pl"
			],
			px: ["pr", "pl"],
			py: ["pt", "pb"],
			m: [
				"mx",
				"my",
				"ms",
				"me",
				"mbs",
				"mbe",
				"mt",
				"mr",
				"mb",
				"ml"
			],
			mx: ["mr", "ml"],
			my: ["mt", "mb"],
			size: ["w", "h"],
			"font-size": ["leading"],
			"fvn-normal": [
				"fvn-ordinal",
				"fvn-slashed-zero",
				"fvn-figure",
				"fvn-spacing",
				"fvn-fraction"
			],
			"fvn-ordinal": ["fvn-normal"],
			"fvn-slashed-zero": ["fvn-normal"],
			"fvn-figure": ["fvn-normal"],
			"fvn-spacing": ["fvn-normal"],
			"fvn-fraction": ["fvn-normal"],
			"line-clamp": ["display", "overflow"],
			rounded: [
				"rounded-s",
				"rounded-e",
				"rounded-t",
				"rounded-r",
				"rounded-b",
				"rounded-l",
				"rounded-ss",
				"rounded-se",
				"rounded-ee",
				"rounded-es",
				"rounded-tl",
				"rounded-tr",
				"rounded-br",
				"rounded-bl"
			],
			"rounded-s": ["rounded-ss", "rounded-es"],
			"rounded-e": ["rounded-se", "rounded-ee"],
			"rounded-t": ["rounded-tl", "rounded-tr"],
			"rounded-r": ["rounded-tr", "rounded-br"],
			"rounded-b": ["rounded-br", "rounded-bl"],
			"rounded-l": ["rounded-tl", "rounded-bl"],
			"border-spacing": ["border-spacing-x", "border-spacing-y"],
			"border-w": [
				"border-w-x",
				"border-w-y",
				"border-w-s",
				"border-w-e",
				"border-w-bs",
				"border-w-be",
				"border-w-t",
				"border-w-r",
				"border-w-b",
				"border-w-l"
			],
			"border-w-x": ["border-w-r", "border-w-l"],
			"border-w-y": ["border-w-t", "border-w-b"],
			"border-color": [
				"border-color-x",
				"border-color-y",
				"border-color-s",
				"border-color-e",
				"border-color-bs",
				"border-color-be",
				"border-color-t",
				"border-color-r",
				"border-color-b",
				"border-color-l"
			],
			"border-color-x": ["border-color-r", "border-color-l"],
			"border-color-y": ["border-color-t", "border-color-b"],
			translate: [
				"translate-x",
				"translate-y",
				"translate-none"
			],
			"translate-none": [
				"translate",
				"translate-x",
				"translate-y",
				"translate-z"
			],
			"scroll-m": [
				"scroll-mx",
				"scroll-my",
				"scroll-ms",
				"scroll-me",
				"scroll-mbs",
				"scroll-mbe",
				"scroll-mt",
				"scroll-mr",
				"scroll-mb",
				"scroll-ml"
			],
			"scroll-mx": ["scroll-mr", "scroll-ml"],
			"scroll-my": ["scroll-mt", "scroll-mb"],
			"scroll-p": [
				"scroll-px",
				"scroll-py",
				"scroll-ps",
				"scroll-pe",
				"scroll-pbs",
				"scroll-pbe",
				"scroll-pt",
				"scroll-pr",
				"scroll-pb",
				"scroll-pl"
			],
			"scroll-px": ["scroll-pr", "scroll-pl"],
			"scroll-py": ["scroll-pt", "scroll-pb"],
			touch: [
				"touch-x",
				"touch-y",
				"touch-pz"
			],
			"touch-x": ["touch"],
			"touch-y": ["touch"],
			"touch-pz": ["touch"]
		},
		conflictingClassGroupModifiers: { "font-size": ["leading"] },
		postfixLookupClassGroups: ["container-type"],
		orderSensitiveModifiers: [
			"*",
			"**",
			"after",
			"backdrop",
			"before",
			"details-content",
			"file",
			"first-letter",
			"first-line",
			"marker",
			"placeholder",
			"selection"
		]
	};
});
//#endregion
//#region src/lib/utils.ts
function J(...e) {
	return It(pe(e));
}
//#endregion
//#region src/components/ui/portal-popover.tsx
var Lt = "data-portal-popover";
function Rt(e) {
	return e instanceof Element && e.closest("[data-portal-popover]") !== null;
}
var zt = (e) => e.preventDefault(), Bt = e.forwardRef(function({ className: e, style: t, onWheel: n, onTouchMove: i, ...o }, s) {
	return typeof document > "u" ? null : r(/* @__PURE__ */ a(ne, {
		asChild: !0,
		onMountAutoFocus: zt,
		onUnmountAutoFocus: zt,
		children: /* @__PURE__ */ a("div", {
			ref: s,
			[Lt]: "",
			className: J(e),
			style: {
				pointerEvents: "auto",
				...t
			},
			onWheel: (e) => {
				e.stopPropagation(), n?.(e);
			},
			onTouchMove: (e) => {
				e.stopPropagation(), i?.(e);
			},
			...o
		})
	}), document.body);
}), Vt = e.forwardRef(function({ label: t, checked: n, defaultChecked: r, indeterminate: i, disabled: s, className: c, fieldClassName: l, labelClassName: u, indicatorClassName: d, onChange: f, onCheckedChange: p, ...m }, h) {
	let g = e.useRef(null), [_, v] = e.useState(!!r), y = n ?? _;
	return e.useEffect(() => {
		g.current && (g.current.indeterminate = !!i);
	}, [i]), /* @__PURE__ */ o("label", {
		className: J("inline-flex h-[24px] w-[24px] shrink-0 cursor-pointer items-center", t && "h-auto w-auto gap-[8px] text-[16px] font-normal text-[#6c6c6c]", s && "cursor-not-allowed opacity-60", l),
		children: [
			/* @__PURE__ */ a("input", {
				type: "checkbox",
				className: J("peer sr-only", c),
				ref: (e) => {
					g.current = e, typeof h == "function" ? h(e) : h && (h.current = e);
				},
				checked: n,
				defaultChecked: n === void 0 ? r : void 0,
				disabled: s,
				onChange: (e) => {
					n === void 0 && v(e.target.checked), f?.(e), p?.(e.target.checked);
				},
				...m
			}),
			/* @__PURE__ */ a(Ht, {
				checked: y,
				indeterminate: i,
				className: J("rounded-[7px] peer-focus-visible:ring-2 peer-focus-visible:ring-[#307FF6] peer-focus-visible:ring-offset-1", d)
			}),
			t && /* @__PURE__ */ a("span", {
				className: u,
				children: t
			})
		]
	});
});
function Ht({ checked: e, indeterminate: t, className: n }) {
	return /* @__PURE__ */ a("span", {
		className: J("inline-flex size-[24px] shrink-0 items-center justify-center", n),
		"aria-hidden": "true",
		children: a(t ? Ut : e ? Jt : qt, {})
	});
}
function Ut({ className: e }) {
	return /* @__PURE__ */ o("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "24",
		height: "24",
		viewBox: "0 0 24 24",
		fill: "none",
		className: e,
		"aria-hidden": "true",
		children: [/* @__PURE__ */ a("rect", {
			x: "1.5",
			y: "1.5",
			width: "21",
			height: "21",
			rx: "5.5",
			fill: "#F8F8F8",
			stroke: "#307FF6"
		}), /* @__PURE__ */ a("path", {
			d: "M7 12H17",
			stroke: "#307FF6",
			strokeWidth: "2",
			strokeLinecap: "round"
		})]
	});
}
function Wt({ checked: e, className: t }) {
	return /* @__PURE__ */ a("span", {
		className: J("inline-flex size-[24px] shrink-0 items-center justify-center", t),
		"aria-hidden": "true",
		children: a(e ? Kt : Gt, {})
	});
}
function Gt({ className: e }) {
	return /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "24",
		height: "24",
		viewBox: "0 0 24 24",
		fill: "none",
		className: e,
		"aria-hidden": "true",
		children: /* @__PURE__ */ a("circle", {
			cx: "12",
			cy: "12",
			r: "10.5",
			fill: "white",
			stroke: "#6C6C6C"
		})
	});
}
function Kt({ className: e }) {
	return /* @__PURE__ */ o("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "24",
		height: "24",
		viewBox: "0 0 24 24",
		fill: "none",
		className: e,
		"aria-hidden": "true",
		children: [/* @__PURE__ */ a("circle", {
			cx: "12",
			cy: "12",
			r: "11",
			fill: "#307FF6"
		}), /* @__PURE__ */ a("path", {
			d: "M7.28613 12.457L11.3017 16.4495L17.9516 8.3335",
			stroke: "white",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})]
	});
}
function qt({ className: e }) {
	return /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "24",
		height: "24",
		viewBox: "0 0 24 24",
		fill: "none",
		className: e,
		"aria-hidden": "true",
		children: /* @__PURE__ */ a("rect", {
			x: "1.5",
			y: "1.5",
			width: "21",
			height: "21",
			rx: "5.5",
			fill: "#F8F8F8",
			stroke: "#6C6C6C"
		})
	});
}
function Jt({ className: e }) {
	return /* @__PURE__ */ o("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "24",
		height: "24",
		viewBox: "0 0 24 24",
		fill: "none",
		className: e,
		"aria-hidden": "true",
		children: [/* @__PURE__ */ a("rect", {
			x: "1.5",
			y: "1.5",
			width: "21",
			height: "21",
			rx: "5.5",
			fill: "#F8F8F8",
			stroke: "#307FF6"
		}), /* @__PURE__ */ a("path", {
			d: "M7 12.1235L11.0155 16.116L17.6655 8",
			stroke: "#307FF6",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})]
	});
}
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-label@2.1.15_@types+react-dom@19.2.4_@types+react@19.2.18__@types+react@19.2._652g4yrchr3cpucqf6hbqibaqe/node_modules/@radix-ui/react-label/dist/index.mjs
var Yt = Object.defineProperty, Xt = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ ((e, t) => Yt(e, "name", {
	value: t,
	configurable: !0
}))(function(e, t) {
	return /* @__PURE__ */ a(N.label, {
		...e,
		ref: t,
		onMouseDown: (t) => {
			t.target.closest("button, input, select, textarea") || (e.onMouseDown?.(t), !t.defaultPrevented && t.detail > 1 && t.preventDefault());
		}
	});
}, "Label"));
//#endregion
//#region src/components/ui/label.tsx
function Y({ className: e, ...t }) {
	return /* @__PURE__ */ a(Xt, {
		"data-slot": "label",
		className: J("flex items-center gap-2 text-sm font-medium leading-none select-none peer-disabled:cursor-not-allowed peer-disabled:opacity-50 group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50", e),
		...t
	});
}
//#endregion
//#region src/components/ui/autocomplete.tsx
function Zt(t) {
	let { id: n, label: r, options: i, searchValue: s, onSearchValueChange: u, placeholder: d = "Select", disabled: f = !1, loading: p = !1, loadingLabel: m = "Loading...", emptyLabel: h = "No results found", size: g = "default", ariaLabel: _, ariaInvalid: v, ariaDescribedBy: y, className: b, labelClassName: x, inputClassName: S, clearable: C = !0 } = t, w = e.useId(), T = n ?? (r ? w : void 0), [E, D] = e.useState(!1), O = e.useRef(null), k = e.useRef(null), A = e.useRef(null), j = c(O, {
		open: E && !f,
		width: "trigger",
		gap: 6,
		estimatedHeight: 250
	}), M = t.multiple === !0, N = M ? t.values : t.value ? [t.value] : [], P = i.filter((e) => N.includes(e.value)), F = M ? void 0 : P[0], I = M ? t.onChipClick : void 0, L = M ? t.isChipMarked : void 0, ee = M ? t.chipActionLabel : void 0, R = M || E ? s : F?.label ?? "", te = C && !f && (N.length > 0 || !!s);
	e.useEffect(() => {
		let e = (e) => {
			l(e.target, O, A) || D(!1);
		};
		return document.addEventListener("mousedown", e), () => document.removeEventListener("mousedown", e);
	}, []);
	let z = () => {
		f || D(!0);
	}, B = (e) => {
		if (M) {
			let n = N.includes(e.value) ? N.filter((t) => t !== e.value) : [...N, e.value];
			t.onValuesChange(n), u(""), window.setTimeout(() => k.current?.focus(), 0);
			return;
		}
		t.onValueChange(e.value), u(e.label), D(!1);
	}, ne = (e) => {
		M && t.onValuesChange(N.filter((t) => t !== e));
	}, re = /* @__PURE__ */ o("div", {
		className: J("group/autocomplete relative min-w-0 w-full", !r && b),
		ref: O,
		children: [/* @__PURE__ */ o("div", {
			className: J("flex min-h-[45px] w-full min-w-0 items-center gap-[6px] rounded-[12px] border border-[#f8f8f8] bg-[#f8f8f8] px-[10px] py-[6px] text-[14px] text-[#404040] transition-[border-color,box-shadow] focus-within:border-[#2f80ed]", f && "cursor-not-allowed opacity-50", $t(g), S),
			onClick: () => k.current?.focus(),
			children: [/* @__PURE__ */ o("span", {
				className: "flex min-w-0 flex-1 flex-wrap items-center gap-[6px]",
				children: [M && P.length > 0 && P.map((e) => {
					let t = L?.(e.value) ?? !1;
					return /* @__PURE__ */ o("span", {
						className: J("inline-flex h-[28px] min-w-0 max-w-full items-center gap-[5px] rounded-[14px] px-[9px] text-[14px] leading-none text-white", t ? "bg-[#02074f]" : "bg-[#307FF6]", tn(g)),
						children: [I && !f ? /* @__PURE__ */ o("button", {
							type: "button",
							className: "flex min-w-0 items-center gap-[4px] text-left",
							"aria-label": ee?.(e, t) ?? `Toggle ${e.label}`,
							"aria-pressed": t,
							onMouseDown: (e) => e.preventDefault(),
							onClick: (t) => {
								t.stopPropagation(), I(e.value);
							},
							children: [/* @__PURE__ */ a("span", {
								className: "min-w-0 overflow-hidden text-ellipsis whitespace-nowrap",
								children: e.label
							}), t && /* @__PURE__ */ a("span", {
								className: "shrink-0 text-[11px] font-medium",
								children: "Mandatory"
							})]
						}) : /* @__PURE__ */ a("span", {
							className: "min-w-0 overflow-hidden text-ellipsis whitespace-nowrap",
							children: e.label
						}), !f && /* @__PURE__ */ a("button", {
							type: "button",
							className: "flex h-[18px] w-[18px] shrink-0 items-center justify-center rounded-full text-white hover:bg-white hover:text-[#307FF6]",
							"aria-label": `Remove ${e.label}`,
							onMouseDown: (e) => e.preventDefault(),
							onClick: (t) => {
								t.stopPropagation(), ne(e.value);
							},
							children: /* @__PURE__ */ a(sn, {})
						})]
					}, e.value);
				}), /* @__PURE__ */ a("input", {
					ref: k,
					id: T,
					type: "text",
					className: J("min-w-[120px] flex-1 border-0 bg-transparent p-0 text-[14px] text-[#404040] outline-none placeholder:text-[#8a8a8a] disabled:cursor-not-allowed", en(g)),
					role: "combobox",
					"aria-autocomplete": "list",
					"aria-expanded": E,
					"aria-controls": E && T ? `${T}-listbox` : void 0,
					"aria-label": _,
					"aria-invalid": v,
					"aria-describedby": y,
					placeholder: N.length > 0 ? "" : d,
					disabled: f,
					value: R,
					onFocus: z,
					onClick: z,
					onChange: (e) => {
						u(e.target.value), !M && t.value && t.onValueChange(""), D(!0);
					},
					onKeyDown: (e) => {
						e.key === "Escape" && D(!1), e.key === "ArrowDown" && D(!0), e.key === "Backspace" && M && !s && N.length > 0 && t.onValuesChange(N.slice(0, -1));
					}
				})]
			}), /* @__PURE__ */ o("span", {
				className: "flex shrink-0 items-center gap-[4px]",
				children: [te && /* @__PURE__ */ a("button", {
					type: "button",
					className: "hidden h-[24px] w-[24px] items-center justify-center rounded-full text-[#6c6c6c] hover:bg-white hover:text-[#307FF6] group-hover/autocomplete:flex",
					"aria-label": "Clear selection",
					onMouseDown: (e) => e.preventDefault(),
					onClick: () => {
						M ? t.onValuesChange([]) : t.onValueChange(""), u(""), D(!0), window.setTimeout(() => k.current?.focus(), 0);
					},
					children: /* @__PURE__ */ a(sn, {})
				}), /* @__PURE__ */ a(on, { className: J("transition-transform", E && "rotate-180") })]
			})]
		}), E && !f && j && /* @__PURE__ */ a(Bt, {
			ref: A,
			style: j,
			id: T ? `${T}-listbox` : void 0,
			className: J("z-[60] max-h-[250px] overflow-auto rounded-[12px] border border-[#eeeff2] bg-white py-0 shadow-[0_2px_4px_rgb(0_0_0_/_12%)]", nn(g)),
			role: "listbox",
			"aria-multiselectable": M || void 0,
			children: p ? /* @__PURE__ */ a("div", {
				className: "px-[16px] py-[14px] text-[14px] text-[#8a8a8a]",
				children: m
			}) : i.length > 0 ? i.map((e) => {
				let t = N.includes(e.value);
				return /* @__PURE__ */ o("button", {
					type: "button",
					className: J("flex min-h-[50px] w-full cursor-pointer items-center gap-[8px] border-0 border-b border-[#f7f7f7] bg-transparent px-[16px] text-left text-[16px] text-[#404040] last:border-b-0 hover:bg-[#f6f6f6]", t && "bg-[rgba(47,128,237,0.12)] hover:bg-[rgba(47,128,237,0.12)]"),
					role: "option",
					"aria-selected": t,
					onMouseDown: (e) => e.preventDefault(),
					onClick: () => B(e),
					children: [M && /* @__PURE__ */ a(Wt, {
						checked: t,
						className: "size-[18px] [&_svg]:size-[18px]"
					}), /* @__PURE__ */ a("span", {
						className: "min-w-0 flex-1 overflow-hidden text-ellipsis whitespace-nowrap",
						children: e.label
					})]
				}, e.value);
			}) : /* @__PURE__ */ a("div", {
				className: "px-[16px] py-[14px] text-[14px] text-[#8a8a8a]",
				children: h
			})
		})]
	});
	return r ? /* @__PURE__ */ o("div", {
		className: J("block min-w-0", b),
		children: [/* @__PURE__ */ a(Y, {
			htmlFor: T,
			className: J("mb-[8px] block text-[16px] font-normal leading-[130%] text-[#404040]", Qt(g), x),
			children: r
		}), re]
	}) : re;
}
function Qt(e) {
	if (e === "small") return "mb-[5px] text-[12px]";
}
function $t(e) {
	if (e === "small") return "min-h-[36px] rounded-[8px] px-[10px] py-[4px] text-[13px]";
}
function en(e) {
	if (e === "small") return "text-[13px]";
}
function tn(e) {
	if (e === "small") return "h-[22px] px-[7px] text-[12px]";
}
function nn(e) {
	if (e === "small") return "rounded-[8px]";
}
function rn(e, t, n) {
	let r = t.trim().toLowerCase(), i = r ? e.filter((e) => e.label.toLowerCase().includes(r)) : e;
	return an([...e.filter((e) => n.includes(e.value)), ...i]);
}
function an(e) {
	let t = /* @__PURE__ */ new Set();
	return e.filter((e) => !e.value || t.has(e.value) ? !1 : (t.add(e.value), !0));
}
function on({ className: e }) {
	return /* @__PURE__ */ a("svg", {
		className: J("h-[24px] w-[24px]", e),
		viewBox: "0 0 24 24",
		fill: "none",
		"aria-hidden": "true",
		children: /* @__PURE__ */ a("path", {
			d: "M7 10l5 5 5-5",
			stroke: "#404040",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	});
}
function sn() {
	return /* @__PURE__ */ a("svg", {
		className: "h-[18px] w-[18px]",
		viewBox: "0 0 24 24",
		fill: "none",
		"aria-hidden": "true",
		children: /* @__PURE__ */ a("path", {
			d: "M7 7l10 10M17 7L7 17",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round"
		})
	});
}
//#endregion
//#region src/components/ui/avatar.tsx
function cn({ name: t, src: n, initials: r, alt: i, size: o = "md", className: s, ...c }) {
	let [l, u] = e.useState(), d = r ?? un(t), f = i ?? t, p = n && n !== l ? n : void 0;
	return /* @__PURE__ */ a("div", {
		className: J("flex shrink-0 items-center justify-center overflow-hidden rounded-full bg-primary font-semibold text-primary-foreground ring-2 ring-background", ln(o), s),
		...f ? { "aria-label": f } : {},
		...c,
		children: p ? /* @__PURE__ */ a("img", {
			src: p,
			alt: f ?? "",
			className: "size-full object-cover",
			onError: () => u(p)
		}) : d
	});
}
function ln(e) {
	return e === "sm" ? "size-8 text-xs" : e === "lg" ? "size-20 text-xl" : "size-11 text-sm";
}
function un(e) {
	if (e) return e.trim().split(/\s+/).map((e) => e[0]).filter(Boolean).slice(0, 2).join("").toUpperCase();
}
//#endregion
//#region ../../node_modules/.pnpm/class-variance-authority@0.7.1/node_modules/class-variance-authority/dist/index.mjs
var dn = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, fn = pe, pn = (e, t) => (n) => {
	if (t?.variants == null) return fn(e, n?.class, n?.className);
	let { variants: r, defaultVariants: i } = t, a = Object.keys(r).map((e) => {
		let t = n?.[e], a = i?.[e];
		if (t === null) return null;
		let o = dn(t) || dn(a);
		return r[e][o];
	}), o = n && Object.entries(n).reduce((e, t) => {
		let [n, r] = t;
		return r === void 0 || (e[n] = r), e;
	}, {});
	return fn(e, a, t?.compoundVariants?.reduce((e, t) => {
		let { class: n, className: r, ...a } = t;
		return Object.entries(a).every((e) => {
			let [t, n] = e;
			return Array.isArray(n) ? n.includes({
				...i,
				...o
			}[t]) : {
				...i,
				...o
			}[t] === n;
		}) ? [
			...e,
			n,
			r
		] : e;
	}, []), n?.class, n?.className);
}, mn = pn("inline-flex w-fit shrink-0 items-center justify-center gap-1 overflow-hidden rounded-md border px-2 py-0.5 text-xs font-medium whitespace-nowrap transition-[color,box-shadow] focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 aria-invalid:border-destructive aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 [&>svg]:pointer-events-none [&>svg]:size-3", {
	variants: { variant: {
		default: "border-transparent bg-primary text-primary-foreground [a&]:hover:bg-primary/90",
		secondary: "border-transparent bg-secondary text-secondary-foreground [a&]:hover:bg-secondary/90",
		destructive: "border-transparent bg-destructive text-destructive-foreground [a&]:hover:bg-destructive/90",
		success: "border-transparent bg-success/10 text-success [a&]:hover:bg-success/15",
		warning: "border-transparent bg-warning/15 text-warning [a&]:hover:bg-warning/20",
		muted: "border-transparent bg-muted text-muted-foreground [a&]:hover:bg-muted/80",
		outline: "text-foreground [a&]:hover:bg-accent [a&]:hover:text-accent-foreground"
	} },
	defaultVariants: { variant: "default" }
}), hn = {
	blue: "default",
	green: "success",
	orange: "warning",
	red: "destructive",
	gray: "muted"
};
function gn({ className: e, variant: t, color: n, ...r }) {
	return /* @__PURE__ */ a("span", {
		className: J(mn({
			variant: t ?? (n ? hn[n] : void 0),
			className: e
		})),
		...r
	});
}
//#endregion
//#region src/components/ui/brand-logo.tsx
function _n({ className: e, ...t }) {
	return /* @__PURE__ */ o("div", {
		className: J("flex items-center gap-2", e),
		"aria-label": "BrightSource",
		...t,
		children: [/* @__PURE__ */ o("svg", {
			viewBox: "0 0 24 24",
			className: "size-[22px]",
			"aria-hidden": "true",
			children: [
				/* @__PURE__ */ a("path", {
					d: "M1 2h5a4 4 0 0 1 0 8H1V2Z",
					fill: "#00c27f"
				}),
				/* @__PURE__ */ a("path", {
					d: "M1 14h5a4 4 0 0 1 0 8H1v-8Z",
					fill: "#00c8df"
				}),
				/* @__PURE__ */ a("path", {
					d: "M13 2h5a4 4 0 0 1 0 8h-5V2Z",
					fill: "#ffae00"
				}),
				/* @__PURE__ */ a("path", {
					d: "M13 14h5a4 4 0 0 1 0 8h-5v-8Z",
					fill: "#ff5527"
				})
			]
		}), /* @__PURE__ */ o("span", {
			className: "text-[22px] font-semibold tracking-[-0.035em] text-foreground",
			children: ["Bright", /* @__PURE__ */ a("span", {
				className: "font-medium",
				children: ".source"
			})]
		})]
	});
}
//#endregion
//#region src/components/ui/button.tsx
var vn = pn("inline-flex shrink-0 items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-all outline-none focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:pointer-events-none disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4 cursor-pointer", {
	variants: {
		variant: {
			default: "bg-primary text-primary-foreground shadow-xs hover:bg-primary/90",
			accent: "bg-accent text-accent-foreground shadow-xs hover:bg-accent/90",
			destructive: "bg-destructive text-destructive-foreground shadow-xs hover:bg-destructive/90 focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40",
			outline: "border bg-background shadow-xs hover:bg-accent hover:text-accent-foreground dark:border-input dark:bg-input/30 dark:hover:bg-input/50",
			secondary: "bg-secondary text-secondary-foreground shadow-xs hover:bg-secondary/80",
			ghost: "hover:bg-accent hover:text-accent-foreground dark:hover:bg-accent/50",
			link: "text-primary underline-offset-4 hover:underline"
		},
		size: {
			default: "h-9 px-4 py-2 has-[>svg]:px-3",
			sm: "h-8 gap-1.5 rounded-md px-3 has-[>svg]:px-2.5",
			lg: "h-10 rounded-md px-6 has-[>svg]:px-4",
			icon: "size-9"
		}
	},
	defaultVariants: {
		variant: "default",
		size: "default"
	}
});
function yn({ className: e, variant: t, size: n, asChild: r = !1, ...i }) {
	return /* @__PURE__ */ a(r ? v : "button", {
		className: J(vn({
			variant: t,
			size: n,
			className: e
		})),
		...i
	});
}
//#endregion
//#region src/components/ui/card.tsx
function bn({ className: e, ...t }) {
	return /* @__PURE__ */ a("div", {
		"data-slot": "card",
		className: J("rounded-xl border bg-card py-6 text-card-foreground shadow-sm", e),
		...t
	});
}
function xn({ className: e, ...t }) {
	return /* @__PURE__ */ a("div", {
		"data-slot": "card-header",
		className: J("grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 px-6", e),
		...t
	});
}
function Sn({ className: e, ...t }) {
	return /* @__PURE__ */ a("div", {
		"data-slot": "card-title",
		className: J("font-semibold leading-none tracking-tight", e),
		...t
	});
}
function Cn({ className: e, ...t }) {
	return /* @__PURE__ */ a("div", {
		"data-slot": "card-description",
		className: J("text-sm text-muted-foreground", e),
		...t
	});
}
function wn({ className: e, ...t }) {
	return /* @__PURE__ */ a("div", {
		"data-slot": "card-content",
		className: J("px-6", e),
		...t
	});
}
function Tn({ className: e, ...t }) {
	return /* @__PURE__ */ a("div", {
		"data-slot": "card-footer",
		className: J("flex items-center px-6", e),
		...t
	});
}
//#endregion
//#region src/components/ui/skeleton.tsx
function En({ className: e, ...t }) {
	return /* @__PURE__ */ a("div", {
		"data-slot": "skeleton",
		className: J("animate-pulse rounded-md bg-accent", e),
		...t
	});
}
//#endregion
//#region src/components/ui/data-table.tsx
function Dn({ columns: t, rows: n, getRowId: r, isLoading: i = !1, emptyTitle: s = "No data", emptyDescription: c, pagination: l, onPageChange: u, actions: d, defaultSortColumnId: f, defaultSortDirection: p = "asc", selection: m, expansion: h, tableClassName: g, headClassName: _, bodyClassName: v, rowClassName: y, rowProps: b, className: x }) {
	let S = f ?? t.find((e) => e.sortable !== !1)?.id ?? t[0]?.id ?? "", [C, w] = e.useState(S), [T, E] = e.useState(p), D = t.find((e) => e.sortable !== !1)?.id ?? t[0]?.id ?? "", O = t.some((e) => e.id === C) ? C : D, k = e.useMemo(() => {
		let e = t.find((e) => e.id === O);
		return !e || e.sortable === !1 ? n : n.slice().sort((t, n) => {
			let r = jn(An(t, e), An(n, e));
			return T === "asc" ? r : -r;
		});
	}, [
		t,
		n,
		O,
		T
	]), A = l ? Math.max(1, Math.ceil(l.total / l.pageSize)) : 1, j = l?.mode === "server" ? k : l ? k.slice(l.page * l.pageSize, l.page * l.pageSize + l.pageSize) : k, M = m ? j.filter((e) => m.isRowSelectable?.(e) !== !1) : [], N = m?.selectedRowIds ?? [], P = e.useMemo(() => new Set(N), [N]), F = M.length > 0 && M.every((e) => P.has(r(e))), I = M.some((e) => P.has(r(e))), L = t.length + Number(!!m) + Number(!!h), ee = (e) => {
		if (e.sortable !== !1) {
			if (O === e.id) {
				E((e) => e === "asc" ? "desc" : "asc");
				return;
			}
			w(e.id), E("asc");
		}
	}, R = () => {
		if (!m) return;
		let e = M.map(r);
		if (F) {
			m.onSelectedRowIdsChange(N.filter((t) => !e.includes(t)));
			return;
		}
		m.onSelectedRowIdsChange([.../* @__PURE__ */ new Set([...N, ...e])]);
	}, te = (e) => {
		if (!m) return;
		let t = r(e);
		m.onSelectedRowIdsChange(P.has(t) ? N.filter((e) => e !== t) : [...N, t]);
	}, z = (e) => {
		if (!h) return;
		let t = r(e);
		h.onExpandedRowIdsChange(h.expandedRowIds.includes(t) ? h.expandedRowIds.filter((e) => e !== t) : [...h.expandedRowIds, t]);
	};
	return /* @__PURE__ */ o("section", {
		className: J("min-w-0 max-w-full overflow-hidden rounded-[4px] bg-white p-[24px] shadow-[0_1px_5px_rgb(0_0_0_/_12%)]", x),
		children: [
			d && /* @__PURE__ */ a("div", {
				className: "mb-[16px] flex justify-end",
				children: d
			}),
			/* @__PURE__ */ a("div", {
				className: "max-w-full overflow-x-auto overscroll-x-contain pb-[4px]",
				children: /* @__PURE__ */ o("table", {
					className: J("w-full min-w-full border-separate border-spacing-y-[8px] text-left text-[16px] text-[#404040]", g),
					children: [/* @__PURE__ */ a("thead", {
						className: _,
						children: /* @__PURE__ */ o("tr", { children: [
							m && /* @__PURE__ */ a("th", {
								scope: "col",
								className: J("w-[46px] border-b border-[#E5E5E5] px-[16px] py-[18px]", m.headerClassName),
								children: /* @__PURE__ */ a(Vt, {
									indeterminate: I && !F,
									checked: F,
									disabled: !M.length,
									onChange: R,
									"aria-label": "Select all rows on this page"
								})
							}),
							t.map((e) => {
								let t = O === e.id && e.sortable !== !1;
								return /* @__PURE__ */ a("th", {
									scope: "col",
									className: J("border-b border-[#E5E5E5] whitespace-nowrap px-[16px] py-[18px] text-[16px] font-semibold normal-case text-[#404040]", e.headerClassName),
									children: e.sortable === !1 ? e.label : /* @__PURE__ */ o("button", {
										type: "button",
										className: "group inline-flex cursor-pointer items-center gap-[4px] border-0 bg-transparent p-0 text-left text-[16px] font-semibold normal-case text-[#404040]",
										onClick: () => ee(e),
										children: [/* @__PURE__ */ a("span", { children: e.label }), /* @__PURE__ */ a(Mn, { className: J("transition-[opacity,transform]", t ? "opacity-60" : "opacity-0 group-hover:opacity-60 group-focus-visible:opacity-60", t && T === "desc" && "rotate-180") })]
									})
								}, e.id);
							}),
							h && /* @__PURE__ */ a("th", {
								scope: "col",
								className: J("w-[46px] border-b border-[#E5E5E5] px-[16px] py-[18px]", h.headerClassName),
								children: /* @__PURE__ */ a("span", {
									className: "sr-only",
									children: "Expand row"
								})
							})
						] })
					}), /* @__PURE__ */ a("tbody", {
						className: v,
						children: i ? Array.from({ length: 5 }).map((e, n) => /* @__PURE__ */ o("tr", {
							className: "even:bg-[#F8F8F8]",
							children: [
								m && /* @__PURE__ */ a("td", {
									className: J("px-[16px] py-[14px]", m.cellClassName),
									children: /* @__PURE__ */ a(En, { className: "h-[18px] w-[18px] bg-[#eef2f8]" })
								}),
								t.map((e) => /* @__PURE__ */ a("td", {
									className: "px-[16px] py-[14px]",
									children: /* @__PURE__ */ a(En, { className: "h-[18px] w-full bg-[#eef2f8]" })
								}, e.id)),
								h && /* @__PURE__ */ a("td", {
									className: J("px-[16px] py-[14px]", h.cellClassName),
									children: /* @__PURE__ */ a(En, { className: "h-[18px] w-[18px] bg-[#eef2f8]" })
								})
							]
						}, `loading-${n}`)) : j.length > 0 ? j.map((n) => {
							let i = r(n), s = P.has(i), c = h?.expandedRowIds.includes(i) ?? !1, l = h?.getRowLabel?.(n) ?? m?.getRowLabel?.(n) ?? "row", u = b?.(n);
							return /* @__PURE__ */ o(e.Fragment, { children: [/* @__PURE__ */ o("tr", {
								...u,
								className: J("even:bg-[#F8F8F8]", y?.(n), u?.className),
								children: [
									m && /* @__PURE__ */ a("td", {
										className: J("whitespace-nowrap px-[16px] py-[14px] text-[16px] font-normal text-[#6C6C6C]", m.cellClassName),
										children: /* @__PURE__ */ a(Vt, {
											checked: s,
											disabled: m.isRowSelectable?.(n) === !1,
											onChange: () => te(n),
											"aria-label": `Select ${m.getRowLabel?.(n) ?? l}`
										})
									}),
									t.map((e, r) => /* @__PURE__ */ a("td", {
										className: J("whitespace-nowrap px-[16px] py-[14px] text-[16px] font-normal text-[#6C6C6C]", !m && r === 0 && "rounded-l-[4px]", !h && r === t.length - 1 && "rounded-r-[4px]", e.className),
										children: e.render(n)
									}, e.id)),
									h && /* @__PURE__ */ a("td", {
										className: J("whitespace-nowrap px-[16px] py-[14px] text-[16px] font-normal text-[#6C6C6C]", h.cellClassName),
										children: /* @__PURE__ */ a("button", {
											type: "button",
											className: "grid size-[34px] place-items-center rounded-full text-[#6c6c6c] hover:bg-[#f8fbff] hover:text-[#307FF6]",
											"aria-label": `${c ? "Hide" : "Show"} details for ${l}`,
											"aria-expanded": c,
											onClick: () => z(n),
											children: /* @__PURE__ */ a(Nn, { className: J("transition-transform", c && "rotate-180") })
										})
									})
								]
							}), h && c && /* @__PURE__ */ a("tr", {
								className: J("bg-[#fbfcff]", h.expandedRowClassName),
								children: /* @__PURE__ */ a("td", {
									colSpan: L,
									className: J("p-[16px]", h.expandedCellClassName),
									children: h.renderExpandedRow(n)
								})
							})] }, i);
						}) : /* @__PURE__ */ a("tr", { children: /* @__PURE__ */ o("td", {
							colSpan: L,
							className: "h-[32rem] rounded-b-[1rem] bg-[#f8f8f8] px-[16px] py-[48px] text-center",
							children: [/* @__PURE__ */ a("div", {
								className: "text-[16px] font-semibold text-[#404040]",
								children: s
							}), c && /* @__PURE__ */ a("div", {
								className: "mt-[6px] text-[14px] text-[#6C6C6C]",
								children: c
							})]
						}) })
					})]
				})
			}),
			l && u && A > 1 && /* @__PURE__ */ a(On, {
				page: l.page,
				pageCount: A,
				onPageChange: u,
				disabled: i
			})
		]
	});
}
function On({ page: e, pageCount: t, onPageChange: n, disabled: r }) {
	let i = kn(e, t);
	return /* @__PURE__ */ a("nav", {
		className: "pt-[12px] pb-[12px]",
		"aria-label": "Table pagination",
		children: /* @__PURE__ */ o("ul", {
			className: "m-0 flex list-none justify-center gap-[2px] p-0",
			children: [
				/* @__PURE__ */ a("li", { children: /* @__PURE__ */ a("button", {
					type: "button",
					className: "grid h-[28px] min-w-[28px] cursor-pointer place-items-center rounded-[4px] border-0 bg-transparent px-[4px] text-[#A4A4A4] disabled:cursor-not-allowed disabled:opacity-40",
					disabled: r || e <= 0,
					onClick: () => n(Math.max(0, e - 1)),
					"aria-label": "Previous page",
					children: /* @__PURE__ */ a(Pn, {})
				}) }),
				i.map((t, i) => /* @__PURE__ */ a("li", { children: t === "ellipsis" ? /* @__PURE__ */ a("span", {
					className: "grid h-[28px] min-w-[28px] place-items-center px-[4px] text-[16px] text-[#A4A4A4]",
					children: "…"
				}) : /* @__PURE__ */ a("button", {
					type: "button",
					className: J("grid h-[28px] min-w-[28px] cursor-pointer place-items-center rounded-[4px] border-0 bg-transparent px-[4px] text-[16px] text-[#A4A4A4] hover:bg-[#f8f8f8]", t === e && "text-[#404040]"),
					disabled: r,
					"aria-current": t === e ? "page" : void 0,
					onClick: () => n(t),
					children: t + 1
				}) }, `${t}-${i}`)),
				/* @__PURE__ */ a("li", { children: /* @__PURE__ */ a("button", {
					type: "button",
					className: "grid h-[28px] min-w-[28px] cursor-pointer place-items-center rounded-[4px] border-0 bg-transparent px-[4px] text-[#A4A4A4] disabled:cursor-not-allowed disabled:opacity-40",
					disabled: r || e >= t - 1,
					onClick: () => n(Math.min(t - 1, e + 1)),
					"aria-label": "Next page",
					children: /* @__PURE__ */ a(Fn, {})
				}) })
			]
		})
	});
}
function kn(e, t) {
	if (t <= 7) return Array.from({ length: t }, (e, t) => t);
	let n = [0], r = Math.max(1, e - 1), i = Math.min(t - 2, e + 1);
	r > 1 && n.push("ellipsis");
	for (let e = r; e <= i; e += 1) n.push(e);
	return i < t - 2 && n.push("ellipsis"), n.push(t - 1), n;
}
function An(e, t) {
	return t.sortValue ? t.sortValue(e) : t.render(e);
}
function jn(e, t) {
	return typeof e == "number" && typeof t == "number" ? e - t : String(e ?? "").localeCompare(String(t ?? ""), void 0, {
		numeric: !0,
		sensitivity: "base"
	});
}
function Mn({ className: e }) {
	return /* @__PURE__ */ a("svg", {
		className: J("h-[18px] w-[18px]", e),
		viewBox: "0 0 24 24",
		fill: "none",
		"aria-hidden": "true",
		children: /* @__PURE__ */ a("path", {
			d: "M7 10l5 5 5-5",
			stroke: "#6C6C6C",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	});
}
function Nn({ className: e }) {
	return /* @__PURE__ */ a("svg", {
		className: J("h-[18px] w-[18px]", e),
		viewBox: "0 0 24 24",
		fill: "none",
		"aria-hidden": "true",
		children: /* @__PURE__ */ a("path", {
			d: "M6 9l6 6 6-6",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	});
}
function Pn() {
	return /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "14",
		height: "15",
		viewBox: "0 0 14 15",
		fill: "none",
		"aria-hidden": "true",
		children: /* @__PURE__ */ a("path", {
			d: "M8 11.5L6 7.5L8 3.5",
			stroke: "#6C6C6C",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	});
}
function Fn() {
	return /* @__PURE__ */ a("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: "14",
		height: "15",
		viewBox: "0 0 14 15",
		fill: "none",
		"aria-hidden": "true",
		children: /* @__PURE__ */ a("path", {
			d: "M6 11.5L8 7.5L6 3.5",
			stroke: "#6C6C6C",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	});
}
//#endregion
//#region src/components/ui/select.tsx
function In({ id: t, label: n, className: r, fieldClassName: i, labelClassName: s, children: c, ...l }) {
	let u = e.useId(), d = t ?? (n ? u : void 0), f = /* @__PURE__ */ a("select", {
		id: d,
		className: J("h-11 w-full rounded-xl border border-input-border bg-white px-3.5 text-[15px] text-foreground outline-none transition-[border-color,box-shadow] disabled:cursor-not-allowed disabled:opacity-50 focus:border-ring focus:ring-2 focus:ring-ring/10", r),
		...l,
		children: c
	});
	return n ? /* @__PURE__ */ o("label", {
		className: J("block space-y-2 text-sm font-medium text-foreground", i),
		htmlFor: d,
		children: [/* @__PURE__ */ a("span", {
			className: s,
			children: n
		}), f]
	}) : f;
}
function Ln({ id: t, label: n, value: r, options: i, onValueChange: s, placeholder: u, disabled: d = !1, clearable: f = !0, placeholderSelectable: p = !0, filterable: m = !1, size: h = "default", ariaLabel: g, ariaInvalid: _, ariaDescribedBy: v, className: y, labelClassName: b }) {
	let x = e.useId(), S = t ?? (n ? x : void 0), [C, w] = e.useState(!1), [T, E] = e.useState(""), D = e.useRef(null), O = e.useRef(null), k = e.useRef(null), A = c(O, {
		open: C && !d,
		gap: 3,
		width: "trigger",
		estimatedHeight: 250
	}), j = i.find((e) => e.value === r), M = g ?? (typeof n == "string" ? n : void 0), N = j?.label ?? u ?? "", P = f && !d && r !== "", F = m ? i.filter((e) => e.label.toLowerCase().includes(T.trim().toLowerCase())) : i, I = (e) => {
		s(e), E(""), w(!1);
	};
	e.useEffect(() => {
		let e = (e) => {
			l(e.target, D, k) || w(!1);
		};
		return document.addEventListener("mousedown", e), () => document.removeEventListener("mousedown", e);
	}, []), e.useEffect(() => {
		C || E("");
	}, [C]);
	let L = /* @__PURE__ */ o("div", {
		className: J("group/select relative", !n && y),
		ref: D,
		children: [
			/* @__PURE__ */ o("button", {
				ref: O,
				id: S,
				type: "button",
				className: J("flex min-h-[45px] w-full cursor-pointer items-center justify-between rounded-[12px] border border-[#f8f8f8] bg-[#f8f8f8] px-[14px] text-left text-[14px] text-[#404040] outline-none transition-[border-color,box-shadow] focus:border-[#2f80ed] disabled:cursor-not-allowed disabled:opacity-80", Bn(h)),
				"aria-haspopup": "listbox",
				"aria-expanded": C,
				"aria-label": M,
				"aria-invalid": _,
				"aria-describedby": v,
				disabled: d,
				onClick: () => w((e) => !e),
				children: [/* @__PURE__ */ o("span", {
					className: J("flex min-w-0 items-center gap-[8px] overflow-hidden", !j && "text-[#8a8a8a]"),
					children: [j?.startAdornment ?? j?.icon, /* @__PURE__ */ a("span", {
						className: "overflow-hidden text-ellipsis whitespace-nowrap",
						children: N
					})]
				}), /* @__PURE__ */ o("span", {
					className: "ml-[8px] flex shrink-0 items-center gap-[4px]",
					children: [P && /* @__PURE__ */ a("span", {
						"aria-hidden": "true",
						className: "h-[24px] w-[24px] shrink-0"
					}), /* @__PURE__ */ a(Yn, { className: J("transition-transform", C && "rotate-180") })]
				})]
			}),
			P && /* @__PURE__ */ a("button", {
				type: "button",
				"aria-label": "Clear selection",
				className: J("absolute top-1/2 flex h-[24px] w-[24px] -translate-y-1/2 items-center justify-center rounded-full text-[#6c6c6c] opacity-0 transition-opacity hover:bg-white hover:text-[#307FF6] focus-visible:opacity-100 group-hover/select:opacity-100", Vn(h)),
				onClick: () => I(""),
				children: /* @__PURE__ */ a(Xn, {})
			}),
			C && !d && A && /* @__PURE__ */ o(Bt, {
				ref: k,
				className: J("z-[60] max-h-[250px] overflow-auto rounded-[12px] border border-[#eeeff2] bg-white py-0 shadow-[0_2px_4px_rgb(0_0_0_/_12%)]", Hn(h)),
				style: A,
				role: "listbox",
				children: [
					m && /* @__PURE__ */ a("div", {
						className: "sticky top-0 z-[1] border-b border-[#eeeff2] bg-white p-[8px]",
						children: /* @__PURE__ */ a("input", {
							type: "search",
							value: T,
							onChange: (e) => E(e.target.value),
							placeholder: "Search...",
							"aria-label": "Search options",
							className: "h-[36px] w-full rounded-[8px] border border-[#d8d8d8] px-[10px] text-[13px] text-[#404040] outline-none focus:border-[#2f80ed]",
							autoFocus: !0
						})
					}),
					u !== void 0 && p && /* @__PURE__ */ a(qn, {
						label: u,
						isSelected: r === "",
						onSelect: () => I("")
					}),
					F.map((e) => /* @__PURE__ */ a(qn, {
						label: e.label,
						startAdornment: e.startAdornment ?? e.icon,
						isSelected: e.value === r,
						onSelect: () => I(e.value)
					}, e.value)),
					m && F.length === 0 && /* @__PURE__ */ a("p", {
						className: "px-[16px] py-[14px] text-[14px] text-[#6c6c6c]",
						children: "No options found."
					})
				]
			})
		]
	});
	return n ? /* @__PURE__ */ o("div", {
		className: J("block min-w-0", y),
		children: [/* @__PURE__ */ a(Y, {
			htmlFor: S,
			className: J("mb-[8px] block text-[16px] font-normal leading-[130%] text-[#404040]", zn(h), b),
			children: n
		}), L]
	}) : L;
}
function Rn({ id: t, label: n, values: r, options: i, onValuesChange: s, placeholder: u = "All", size: d = "default", ariaLabel: f, ariaInvalid: p, ariaDescribedBy: m, className: h, labelClassName: g }) {
	let _ = e.useId(), v = t ?? (n ? _ : void 0), [y, b] = e.useState(!1), x = e.useRef(null), S = e.useRef(null), C = e.useRef(null), w = c(S, {
		open: y,
		gap: 3,
		width: "trigger",
		estimatedHeight: 250
	}), T = i.filter((e) => r.includes(e.value)), E = r.length > 0;
	e.useEffect(() => {
		let e = (e) => {
			l(e.target, x, C) || b(!1);
		};
		return document.addEventListener("mousedown", e), () => document.removeEventListener("mousedown", e);
	}, []);
	let D = (e) => {
		if (r.includes(e)) {
			s(r.filter((t) => t !== e));
			return;
		}
		s([...r, e]);
	}, O = (e) => {
		s(r.filter((t) => t !== e));
	}, k = /* @__PURE__ */ o("div", {
		className: J("group/select relative flex min-h-[45px] w-full items-center justify-between gap-[10px] rounded-[12px] border border-[#f8f8f8] bg-[#f8f8f8] px-[10px] py-[8px] text-left text-[14px] text-[#404040] transition-[border-color,box-shadow] focus-within:border-[#2f80ed]", Un(d), !n && h),
		ref: x,
		children: [
			/* @__PURE__ */ a("button", {
				ref: S,
				id: v,
				type: "button",
				className: "absolute inset-0 w-full cursor-pointer rounded-[inherit] outline-none",
				"aria-haspopup": "listbox",
				"aria-expanded": y,
				"aria-label": f,
				"aria-invalid": p,
				"aria-describedby": m,
				onClick: () => b((e) => !e),
				children: /* @__PURE__ */ a("span", {
					className: "sr-only",
					children: T.length > 0 ? T.map((e) => e.label).join(", ") : u
				})
			}),
			/* @__PURE__ */ a("span", {
				className: J("pointer-events-none relative flex min-w-0 flex-1 flex-wrap items-center gap-[6px]", Wn(d)),
				children: T.length > 0 ? T.map((e) => /* @__PURE__ */ o("span", {
					className: J("inline-flex h-[28px] max-w-full items-center gap-[5px] rounded-[14px] bg-[#307FF6] px-[9px] text-[14px] leading-none text-white", Gn(d)),
					children: [/* @__PURE__ */ a("span", {
						className: "min-w-0 overflow-hidden text-ellipsis whitespace-nowrap",
						children: e.label
					}), /* @__PURE__ */ a("button", {
						type: "button",
						className: J("pointer-events-auto flex h-[18px] w-[18px] shrink-0 items-center justify-center rounded-full text-white hover:bg-white hover:text-[#307FF6] focus-visible:bg-white focus-visible:text-[#307FF6]", Kn(d)),
						"aria-label": `Remove ${e.label}`,
						onClick: () => O(e.value),
						children: /* @__PURE__ */ a(Xn, { className: "h-[16px] w-[16px]" })
					})]
				}, e.value)) : /* @__PURE__ */ a("span", {
					className: "text-[#8a8a8a]",
					children: u
				})
			}),
			/* @__PURE__ */ o("span", {
				className: "pointer-events-none relative flex shrink-0 items-center gap-[4px]",
				children: [E && /* @__PURE__ */ a("button", {
					type: "button",
					className: "pointer-events-auto flex h-[24px] w-[24px] items-center justify-center rounded-full text-[#6c6c6c] opacity-0 transition-opacity hover:bg-white hover:text-[#307FF6] focus-visible:opacity-100 group-hover/select:opacity-100",
					"aria-label": "Clear selections",
					onClick: () => s([]),
					children: /* @__PURE__ */ a(Xn, {})
				}), /* @__PURE__ */ a(Yn, { className: J("transition-transform", y && "rotate-180") })]
			}),
			y && w && /* @__PURE__ */ a(Bt, {
				ref: C,
				style: w,
				className: J("z-[60] max-h-[250px] overflow-auto rounded-[12px] border border-[#eeeff2] bg-white py-0 shadow-[0_2px_4px_rgb(0_0_0_/_12%)]", Hn(d)),
				role: "listbox",
				"aria-multiselectable": "true",
				children: i.map((e) => /* @__PURE__ */ a(Jn, {
					label: e.label,
					isSelected: r.includes(e.value),
					onSelect: () => D(e.value)
				}, e.value))
			})
		]
	});
	return n ? /* @__PURE__ */ o("div", {
		className: J("block min-w-0", h),
		children: [/* @__PURE__ */ a(Y, {
			htmlFor: v,
			className: J("mb-[8px] block text-[16px] font-normal leading-[130%] text-[#404040]", zn(d), g),
			children: n
		}), k]
	}) : k;
}
function zn(e) {
	if (e === "small") return "mb-[5px] text-[12px]";
}
function Bn(e) {
	if (e === "small") return "h-[36px] min-h-[36px] rounded-[8px] px-[10px] py-0 text-[13px]";
}
function Vn(e) {
	return e === "small" ? "right-[38px]" : "right-[42px]";
}
function Hn(e) {
	if (e === "small") return "rounded-[8px]";
}
function Un(e) {
	if (e === "small") return "h-auto min-h-[36px] rounded-[8px] px-[10px] py-[6px] text-[13px]";
}
function Wn(e) {
	if (e === "small") return "flex-wrap gap-[4px]";
}
function Gn(e) {
	if (e === "small") return "h-[22px] min-w-0 shrink px-[7px] text-[12px]";
}
function Kn(e) {
	if (e === "small") return "h-[14px] w-[14px]";
}
function qn({ label: e, startAdornment: t, isSelected: n, onSelect: r }) {
	return /* @__PURE__ */ o("button", {
		type: "button",
		className: J("flex h-[50px] w-full cursor-pointer items-center gap-[8px] border-0 border-b border-[#f7f7f7] bg-transparent px-[16px] text-left text-[16px] text-[#404040] last:border-b-0 hover:bg-[#f6f6f6]", n && "bg-[rgba(47,128,237,0.12)] hover:bg-[rgba(47,128,237,0.12)]"),
		role: "option",
		"aria-selected": n,
		onClick: r,
		children: [
			/* @__PURE__ */ a(Wt, { checked: n }),
			t,
			/* @__PURE__ */ a("span", {
				className: "min-w-0 flex-1 overflow-hidden text-ellipsis whitespace-nowrap",
				children: e
			})
		]
	});
}
function Jn({ label: e, isSelected: t, onSelect: n }) {
	return /* @__PURE__ */ o("button", {
		type: "button",
		className: J("flex h-[50px] w-full cursor-pointer items-center gap-[8px] border-0 border-b border-[#f7f7f7] bg-transparent px-[16px] text-left text-[16px] text-[#404040] last:border-b-0 hover:bg-[#f6f6f6]", t && "bg-[rgba(47,128,237,0.12)] hover:bg-[rgba(47,128,237,0.12)]"),
		role: "option",
		"aria-selected": t,
		onClick: n,
		children: [/* @__PURE__ */ a(Ht, { checked: t }), /* @__PURE__ */ a("span", {
			className: "min-w-0 flex-1 overflow-hidden text-ellipsis whitespace-nowrap",
			children: e
		})]
	});
}
function Yn({ className: e }) {
	return /* @__PURE__ */ a("svg", {
		className: J("h-[24px] w-[24px]", e),
		viewBox: "0 0 24 24",
		fill: "none",
		"aria-hidden": "true",
		children: /* @__PURE__ */ a("path", {
			d: "M7 10l5 5 5-5",
			stroke: "#404040",
			strokeWidth: "2",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	});
}
function Xn({ className: e }) {
	return /* @__PURE__ */ a("svg", {
		className: J("h-[24px] w-[24px]", e),
		viewBox: "0 0 24 24",
		fill: "none",
		"aria-hidden": "true",
		children: /* @__PURE__ */ a("path", {
			d: "M7 7l10 10M17 7L7 17",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round"
		})
	});
}
//#endregion
//#region src/components/ui/date-picker.tsx
var Zn = [
	"Su",
	"Mo",
	"Tu",
	"We",
	"Th",
	"Fr",
	"Sa"
], Qn = new Intl.DateTimeFormat("en", {
	month: "long",
	year: "numeric"
}), $n = new Intl.DateTimeFormat("en", { month: "long" }), er = Array.from({ length: 12 }, (e, t) => $n.format(new Date(2e3, t, 1)));
function tr({ id: t, label: n, value: r, onValueChange: i, placeholder: s = "dd/MM/yyyy", disabled: u = !1, size: d = "default", minValue: f, maxValue: p, className: m, labelClassName: h, ariaInvalid: g, ariaDescribedBy: _ }) {
	let v = e.useId(), y = t ?? (n ? v : void 0), [b, x] = e.useState(!1), [S, C] = e.useState(!1), w = e.useRef(null), T = e.useRef(null), E = e.useRef(null), D = e.useRef(null), O = `${v}-month-year-picker`, k = or(r), A = typeof n == "string" ? n : void 0, j = f && or(f) ? f : "", M = p && or(p) ? p : "", [N, P] = e.useState(() => lr(k, j, M));
	e.useEffect(() => {
		k && P((e) => e.getFullYear() === k.getFullYear() && e.getMonth() === k.getMonth() ? e : hr(k));
	}, [r]);
	let F = fr(N, j, M), I = e.useCallback(() => {
		x(!1), C(!1);
	}, []), L = c(T, {
		open: b && !u,
		gap: d === "small" ? 6 : 8,
		width: 292,
		estimatedHeight: S ? 420 : 360,
		onClose: I
	});
	e.useEffect(() => {
		let e = (e) => {
			l(e.target, w, E) || I();
		};
		return document.addEventListener("mousedown", e), () => document.removeEventListener("mousedown", e);
	}, [I]), e.useEffect(() => {
		S && D.current?.focus();
	}, [S]);
	let ee = (e) => {
		let t = sr(e);
		ur(t, j, M) || (i(t), x(!1), C(!1));
	}, R = () => {
		i(""), x(!1), C(!1);
	}, te = /* @__PURE__ */ o("div", {
		className: J("group/date-picker relative", !n && m),
		ref: w,
		children: [
			/* @__PURE__ */ o("button", {
				ref: T,
				id: y,
				type: "button",
				className: J("flex min-h-[45px] w-full cursor-pointer items-center justify-between rounded-[12px] border border-[#f8f8f8] bg-[#f8f8f8] px-[14px] text-left text-[14px] text-[#404040] outline-none transition-[border-color,box-shadow] focus:border-[#2f80ed] disabled:cursor-not-allowed disabled:opacity-80", rr(d)),
				"aria-haspopup": "dialog",
				"aria-expanded": b,
				"aria-label": A,
				"aria-invalid": g,
				"aria-describedby": _,
				disabled: u,
				onClick: () => {
					if (b) {
						C(!1), x(!1);
						return;
					}
					P(lr(k, j, M)), x(!0);
				},
				children: [/* @__PURE__ */ a("span", {
					className: J("overflow-hidden text-ellipsis whitespace-nowrap", !k && "text-[#8a8a8a]"),
					children: k ? cr(k) : s
				}), /* @__PURE__ */ o("span", {
					className: "ml-[8px] flex shrink-0 items-center gap-[4px]",
					children: [r && !u && /* @__PURE__ */ a("span", {
						"aria-hidden": "true",
						className: "h-[24px] w-[24px] shrink-0"
					}), /* @__PURE__ */ a(yr, {})]
				})]
			}),
			r && !u && /* @__PURE__ */ a("button", {
				type: "button",
				"aria-label": "Clear date",
				className: J("absolute top-1/2 flex h-[24px] w-[24px] -translate-y-1/2 items-center justify-center rounded-full text-[#6c6c6c] opacity-0 transition-opacity hover:bg-white hover:text-[#307FF6] focus-visible:opacity-100 group-hover/date-picker:opacity-100", ir(d)),
				onClick: R,
				children: /* @__PURE__ */ a(br, {})
			}),
			b && !u && L && /* @__PURE__ */ o(Bt, {
				ref: E,
				className: J("z-[60] w-[292px] rounded-[22px] border border-[#eeeff2] bg-white p-[10px] shadow-[0_2px_4px_rgb(0_0_0_/_12%)]", ar(d)),
				style: L,
				role: "dialog",
				"aria-label": "Choose date",
				children: [
					/* @__PURE__ */ o("div", {
						className: "mb-[8px] flex items-center justify-between gap-[8px]",
						children: [
							/* @__PURE__ */ a("button", {
								type: "button",
								className: "grid h-[34px] w-[34px] cursor-pointer place-items-center rounded-[12px] border-0 bg-transparent text-[24px] text-[#2f80ed] hover:bg-[#f8f8f8]",
								"aria-label": "Previous month",
								onClick: () => {
									C(!1), P(gr(N, -1));
								},
								children: "‹"
							}),
							/* @__PURE__ */ a("button", {
								type: "button",
								className: "min-w-0 rounded-[12px] px-[12px] py-[7px] text-[14px] font-medium text-[#404040] outline-none hover:bg-[#f8f8f8] focus-visible:ring-2 focus-visible:ring-[#2f80ed]",
								"aria-label": `Change month and year, ${Qn.format(N)}`,
								"aria-expanded": S,
								"aria-controls": O,
								onClick: () => {
									S || P(dr(N, j, M)), C((e) => !e);
								},
								children: Qn.format(N)
							}),
							/* @__PURE__ */ a("button", {
								type: "button",
								className: "grid h-[34px] w-[34px] cursor-pointer place-items-center rounded-[12px] border-0 bg-transparent text-[24px] text-[#2f80ed] hover:bg-[#f8f8f8]",
								"aria-label": "Next month",
								onClick: () => {
									C(!1), P(gr(N, 1));
								},
								children: "›"
							})
						]
					}),
					S && /* @__PURE__ */ o("div", {
						id: O,
						className: "mb-[8px] grid grid-cols-2 gap-[8px] rounded-[12px] bg-[#f8f8f8] p-[8px]",
						role: "group",
						"aria-label": "Choose month and year",
						children: [/* @__PURE__ */ a(In, {
							ref: D,
							className: "h-[34px] min-w-0 cursor-pointer rounded-[8px] border-[#eeeff2] px-[8px] text-[13px] text-[#404040] focus:border-[#2f80ed]",
							"aria-label": "Month",
							value: N.getMonth(),
							onChange: (e) => P(new Date(N.getFullYear(), Number(e.target.value), 1)),
							children: er.map((e, t) => /* @__PURE__ */ a("option", {
								value: t,
								disabled: pr(N.getFullYear(), t, j, M),
								children: e
							}, e))
						}), /* @__PURE__ */ a(In, {
							className: "h-[34px] min-w-0 cursor-pointer rounded-[8px] border-[#eeeff2] px-[8px] text-[13px] text-[#404040] focus:border-[#2f80ed]",
							"aria-label": "Year",
							value: N.getFullYear(),
							onChange: (e) => {
								let t = Number(e.target.value), n = mr(t, N.getMonth(), j, M);
								P(new Date(t, n, 1));
							},
							children: F.map((e) => /* @__PURE__ */ a("option", {
								value: e,
								children: e
							}, e))
						})]
					}),
					/* @__PURE__ */ o("div", {
						className: "grid grid-cols-7 gap-[4px] text-center",
						children: [Zn.map((e) => /* @__PURE__ */ a("div", {
							className: "py-[6px] text-[12px] font-medium text-[#8a8a8a]",
							children: e
						}, e)), vr(N).map((e) => {
							let t = sr(e), n = e.getMonth() !== N.getMonth(), r = k ? _r(e, k) : !1, i = _r(e, /* @__PURE__ */ new Date()), o = ur(t, j, M);
							return /* @__PURE__ */ a("button", {
								type: "button",
								className: J("h-[34px] cursor-pointer rounded-[10px] border-0 bg-transparent text-[13px] text-[#404040] transition-colors hover:bg-[#f8f8f8] disabled:cursor-not-allowed disabled:opacity-30 disabled:hover:bg-transparent", n && "text-[#8a8a8a]", i && !r && "font-semibold text-[#2f80ed]", r && "bg-[#2f80ed] text-white hover:bg-[#2a73d5]"),
								disabled: o,
								onClick: () => ee(e),
								children: e.getDate()
							}, t);
						})]
					}),
					/* @__PURE__ */ o("div", {
						className: "mt-[10px] flex justify-between border-t border-[#eeeff2] pt-[8px]",
						children: [/* @__PURE__ */ a("button", {
							type: "button",
							className: "cursor-pointer rounded-[12px] border-0 bg-transparent px-[10px] py-[6px] text-[12px] text-[#404040] hover:bg-[#f8f8f8]",
							onClick: R,
							children: "clear"
						}), /* @__PURE__ */ a("button", {
							type: "button",
							className: "cursor-pointer rounded-[12px] border-0 bg-transparent px-[10px] py-[6px] text-[12px] text-[#404040] hover:bg-[#f8f8f8]",
							onClick: () => ee(/* @__PURE__ */ new Date()),
							children: "Today"
						})]
					})
				]
			})
		]
	});
	return n ? /* @__PURE__ */ o("div", {
		className: J("block min-w-0", m),
		children: [/* @__PURE__ */ a(Y, {
			htmlFor: y,
			className: J("mb-[8px] block text-[16px] font-normal leading-[130%] text-[#404040]", nr(d), h),
			children: n
		}), te]
	}) : te;
}
function nr(e) {
	if (e === "small") return "mb-[5px] text-[12px]";
}
function rr(e) {
	if (e === "small") return "h-[36px] min-h-[36px] rounded-[8px] px-[10px] py-0 text-[13px]";
}
function ir(e) {
	return e === "small" ? "right-[38px]" : "right-[42px]";
}
function ar(e) {
	if (e === "small") return "rounded-[8px]";
}
function or(e) {
	if (!e) return null;
	let t = e.split("-").map(Number), n = t[0], r = t[1], i = t[2];
	if (!n || !r || !i) return null;
	let a = new Date(n, r - 1, i);
	return Number.isNaN(a.getTime()) ? null : a;
}
function sr(e) {
	return `${e.getFullYear()}-${String(e.getMonth() + 1).padStart(2, "0")}-${String(e.getDate()).padStart(2, "0")}`;
}
function cr(e) {
	return `${String(e.getDate()).padStart(2, "0")}/${String(e.getMonth() + 1).padStart(2, "0")}/${e.getFullYear()}`;
}
function lr(e, t, n) {
	if (e) return hr(e);
	let r = /* @__PURE__ */ new Date(), i = sr(r), a = or(t), o = or(n);
	return hr(a && t > i ? a : o && n < i ? o : r);
}
function ur(e, t, n) {
	return !!(t && e < t || n && e > n);
}
function dr(e, t, n) {
	let r = sr(hr(e)), i = sr(new Date(e.getFullYear(), e.getMonth() + 1, 0)), a = or(t), o = or(n);
	return a && i < t ? hr(a) : o && r > n ? hr(o) : e;
}
function fr(e, t, n) {
	let r = (/* @__PURE__ */ new Date()).getFullYear(), i = t ? or(t)?.getFullYear() ?? r - 100 : Math.min(r - 100, e.getFullYear()), a = n ? or(n)?.getFullYear() ?? r + 100 : Math.max(r + 100, e.getFullYear());
	return Array.from({ length: Math.max(0, a - i + 1) }, (e, t) => a - t);
}
function pr(e, t, n, r) {
	let i = sr(new Date(e, t, 1)), a = sr(new Date(e, t + 1, 0));
	return !!(n && a < n || r && i > r);
}
function mr(e, t, n, r) {
	return pr(e, t, n, r) ? Array.from({ length: 12 }, (e, t) => t).filter((t) => !pr(e, t, n, r)).reduce((e, n) => Math.abs(n - t) < Math.abs(e - t) ? n : e) : t;
}
function hr(e) {
	return new Date(e.getFullYear(), e.getMonth(), 1);
}
function gr(e, t) {
	return new Date(e.getFullYear(), e.getMonth() + t, 1);
}
function _r(e, t) {
	return e.getFullYear() === t.getFullYear() && e.getMonth() === t.getMonth() && e.getDate() === t.getDate();
}
function vr(e) {
	let t = hr(e), n = new Date(t);
	return n.setDate(1 - t.getDay()), Array.from({ length: 42 }, (e, t) => {
		let r = new Date(n);
		return r.setDate(n.getDate() + t), r;
	});
}
function yr({ className: e }) {
	return /* @__PURE__ */ a("svg", {
		className: J("h-[24px] w-[24px]", e),
		viewBox: "0 0 24 24",
		fill: "none",
		"aria-hidden": "true",
		children: /* @__PURE__ */ a("path", {
			d: "M7 3v3M17 3v3M4.5 9h15M6.5 5h11A2.5 2.5 0 0 1 20 7.5v10A2.5 2.5 0 0 1 17.5 20h-11A2.5 2.5 0 0 1 4 17.5v-10A2.5 2.5 0 0 1 6.5 5Z",
			stroke: "#404040",
			strokeWidth: "1.8",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	});
}
function br({ className: e }) {
	return /* @__PURE__ */ a("svg", {
		className: J("h-[24px] w-[24px]", e),
		viewBox: "0 0 24 24",
		fill: "none",
		"aria-hidden": "true",
		children: /* @__PURE__ */ a("path", {
			d: "M7 7l10 10M17 7L7 17",
			stroke: "currentColor",
			strokeWidth: "2",
			strokeLinecap: "round"
		})
	});
}
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+primitive@1.1.7/node_modules/@radix-ui/primitive/dist/index.mjs
var xr = Object.defineProperty, Sr = (e, t) => xr(e, "name", {
	value: t,
	configurable: !0
}), Cr = !!(typeof window < "u" && window.document && window.document.createElement);
function wr(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
	return /* @__PURE__ */ Sr(function(r) {
		if (e?.(r), n === !1 || !r || !r.defaultPrevented) return t?.(r);
	}, "handleEvent");
}
Sr(wr, "composeEventHandlers");
function Tr(e) {
	if (!Cr) throw Error("Cannot access window outside of the DOM");
	return e?.ownerDocument?.defaultView ?? window;
}
Sr(Tr, "getOwnerWindow");
function Er(e) {
	if (!Cr) throw Error("Cannot access document outside of the DOM");
	return e?.ownerDocument ?? document;
}
Sr(Er, "getOwnerDocument");
function Dr(e, t = !1) {
	let { activeElement: n } = Er(e);
	if (!n?.nodeName) return null;
	if (Or(n) && n.contentDocument) return Dr(n.contentDocument.body, t);
	if (t) {
		let e = n.getAttribute("aria-activedescendant");
		if (e) {
			let t = Er(n).getElementById(e);
			if (t) return t;
		}
	}
	return n;
}
Sr(Dr, "getActiveElement");
function Or(e) {
	return e.tagName === "IFRAME";
}
Sr(Or, "isFrame");
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-context@1.2.2_@types+react@19.2.18_react@19.2.8/node_modules/@radix-ui/react-context/dist/index.mjs
var kr = Object.defineProperty, X = (e, t) => kr(e, "name", {
	value: t,
	configurable: !0
});
// @__NO_SIDE_EFFECTS__
function Ar(t, n) {
	let r = e.createContext(n);
	r.displayName = t + "Context";
	let i = /* @__PURE__ */ X((t) => {
		let { children: n, ...i } = t, o = e.useMemo(() => i, Object.values(i));
		return /* @__PURE__ */ a(r.Provider, {
			value: o,
			children: n
		});
	}, "Provider");
	i.displayName = t + "Provider";
	function o(i, a = {}) {
		let { optional: o = !1 } = a, s = e.useContext(r);
		if (s) return s;
		if (n !== void 0) return n;
		if (!o) throw Error(`\`${i}\` must be used within \`${t}\``);
	}
	return X(o, "useContext"), [i, o];
}
X(Ar, "createContext");
// @__NO_SIDE_EFFECTS__
function jr(t, n = []) {
	let r = [];
	function i(n, i) {
		let o = e.createContext(i);
		o.displayName = n + "Context";
		let s = r.length;
		r = [...r, i];
		let c = /* @__PURE__ */ X((n) => {
			let { scope: r, children: i, ...c } = n, l = r?.[t]?.[s] || o, u = e.useMemo(() => c, Object.values(c));
			return /* @__PURE__ */ a(l.Provider, {
				value: u,
				children: i
			});
		}, "Provider");
		c.displayName = n + "Provider";
		function l(r, a, c = {}) {
			let { optional: l = !1 } = c, u = a?.[t]?.[s] || o, d = e.useContext(u);
			if (d) return d;
			if (i !== void 0) return i;
			if (!l) throw Error(`\`${r}\` must be used within \`${n}\``);
		}
		return X(l, "useContext"), [c, l];
	}
	X(i, "createContext");
	let o = /* @__PURE__ */ X(() => {
		let n = r.map((t) => e.createContext(t));
		return /* @__PURE__ */ X(function(r) {
			let i = r?.[t] || n;
			return e.useMemo(() => ({ [`__scope${t}`]: {
				...r,
				[t]: i
			} }), [r, i]);
		}, "useScope");
	}, "createScope");
	return o.scopeName = t, [i, Mr(o, ...n)];
}
X(jr, "createContextScope");
function Mr(...t) {
	let n = t[0];
	if (t.length === 1) return n;
	let r = /* @__PURE__ */ X(() => {
		let r = t.map((e) => ({
			useScope: e(),
			scopeName: e.scopeName
		}));
		return /* @__PURE__ */ X(function(t) {
			let i = r.reduce((e, { useScope: n, scopeName: r }) => {
				let i = n(t)[`__scope${r}`];
				return {
					...e,
					...i
				};
			}, {});
			return e.useMemo(() => ({ [`__scope${n.scopeName}`]: i }), [i]);
		}, "useComposedScopes");
	}, "createScope");
	return r.scopeName = n.scopeName, r;
}
X(Mr, "composeContextScopes");
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-use-layout-effect@1.1.4_@types+react@19.2.18_react@19.2.8/node_modules/@radix-ui/react-use-layout-effect/dist/index.mjs
var Nr = globalThis?.document ? e.useLayoutEffect : () => {}, Pr = Object.defineProperty, Fr = (e, t) => Pr(e, "name", {
	value: t,
	configurable: !0
}), Ir = e.useId || (() => void 0), Lr = 0;
function Rr(t) {
	let [n, r] = e.useState(Ir());
	return Nr(() => {
		t || r((e) => e ?? String(Lr++));
	}, [t]), t || (n ? `radix-${n}` : "");
}
Fr(Rr, "useId");
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-use-effect-event@0.0.5_@types+react@19.2.18_react@19.2.8/node_modules/@radix-ui/react-use-effect-event/dist/index.mjs
var zr = Object.defineProperty, Br = (e, t) => zr(e, "name", {
	value: t,
	configurable: !0
}), Vr = e.useEffectEvent, Hr = e.useInsertionEffect;
function Ur(t) {
	if (typeof Vr == "function") return Vr(t);
	let n = e.useRef(() => {
		throw Error("Cannot call an event handler while rendering.");
	});
	return typeof Hr == "function" ? Hr(() => {
		n.current = t;
	}) : Nr(() => {
		n.current = t;
	}), e.useMemo(() => ((...e) => n.current?.(...e)), []);
}
Br(Ur, "useEffectEvent");
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-use-controllable-state@1.2.6_@types+react@19.2.18_react@19.2.8/node_modules/@radix-ui/react-use-controllable-state/dist/index.mjs
var Wr = Object.defineProperty, Gr = (e, t) => Wr(e, "name", {
	value: t,
	configurable: !0
}), Kr = e.useInsertionEffect || Nr;
function qr({ prop: t, defaultProp: n, onChange: r = /* @__PURE__ */ Gr(() => {}, "onChange"), caller: i }) {
	let [a, o, s] = Jr({
		defaultProp: n,
		onChange: r
	}), c = t !== void 0;
	return [c ? t : a, e.useCallback((e) => {
		if (c) {
			let n = Yr(e) ? e(t) : e;
			n !== t && s.current?.(n);
		} else o(e);
	}, [
		c,
		t,
		o,
		s
	])];
}
Gr(qr, "useControllableState");
function Jr({ defaultProp: t, onChange: n }) {
	let [r, i] = e.useState(t), a = e.useRef(r), o = e.useRef(n);
	return Kr(() => {
		o.current = n;
	}, [n]), e.useEffect(() => {
		a.current !== r && (o.current?.(r), a.current = r);
	}, [r, a]), [
		r,
		i,
		o
	];
}
Gr(Jr, "useUncontrolledState");
function Yr(e) {
	return typeof e == "function";
}
Gr(Yr, "isFunction");
var Xr = Symbol("RADIX:SYNC_STATE");
function Zr(t, n, r, i) {
	let { prop: a, defaultProp: o, onChange: s, caller: c } = n, l = a !== void 0, u = Ur(s), d = [{
		...r,
		state: o
	}];
	i && d.push(i);
	let [f, p] = e.useReducer((e, n) => {
		if (n.type === Xr) return {
			...e,
			state: n.state
		};
		let r = t(e, n);
		return l && !Object.is(r.state, e.state) && u(r.state), r;
	}, ...d), m = f.state, h = e.useRef(m);
	e.useEffect(() => {
		h.current !== m && (h.current = m, l || u(m));
	}, [
		m,
		h,
		l
	]);
	let g = e.useMemo(() => a === void 0 ? f : {
		...f,
		state: a
	}, [f, a]);
	return e.useEffect(() => {
		l && !Object.is(a, f.state) && p({
			type: Xr,
			state: a
		});
	}, [
		a,
		f.state,
		l
	]), [g, p];
}
Gr(Zr, "useControllableStateReducer");
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-dismissable-layer@1.1.19_@types+react-dom@19.2.4_@types+react@19.2.18__@types_bqbmiifn43hfn3jajjiwywgvvm/node_modules/@radix-ui/react-dismissable-layer/dist/index.mjs
var Qr = Object.defineProperty, Z = (e, t) => Qr(e, "name", {
	value: t,
	configurable: !0
}), $r = "dismissableLayer.update", ei = "dismissableLayer.pointerDownOutside", ti = "dismissableLayer.focusOutside", ni, ri = e.createContext({
	layers: /* @__PURE__ */ new Set(),
	layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
	branches: /* @__PURE__ */ new Set(),
	dismissableSurfaces: /* @__PURE__ */ new Set()
}), ii = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Z(function(t, n) {
	let { disableOutsidePointerEvents: r = !1, deferPointerDownOutside: i = !1, onEscapeKeyDown: o, onPointerDownOutside: s, onFocusOutside: c, onInteractOutside: l, onDismiss: u, ...d } = t, f = e.useContext(ri), [p, h] = e.useState(null), g = p?.ownerDocument ?? globalThis?.document, [, _] = e.useState({}), v = m(n, h), y = Array.from(f.layers), [b] = [...f.layersWithOutsidePointerEventsDisabled].slice(-1), x = b ? y.indexOf(b) : -1, S = p ? y.indexOf(p) : -1, C = f.layersWithOutsidePointerEventsDisabled.size > 0, w = S >= x, T = e.useRef(!1), E = si((e) => {
		s?.(e), l?.(e), e.defaultPrevented || u?.();
	}, {
		ownerDocument: g,
		deferPointerDownOutside: i,
		isDeferredPointerDownOutsideRef: T,
		dismissableSurfaces: f.dismissableSurfaces,
		shouldHandlePointerDownOutside: e.useCallback((e) => {
			if (!(e instanceof Node)) return !1;
			let t = [...f.branches].some((t) => t.contains(e));
			return w && !t;
		}, [f.branches, w])
	}), D = ci((e) => {
		if (i && T.current) return;
		let t = e.target;
		[...f.branches].some((e) => e.contains(t)) || (c?.(e), l?.(e), e.defaultPrevented || u?.());
	}, g), O = p ? S === y.length - 1 : !1, k = L((e) => {
		e.key === "Escape" && (o?.(e), !e.defaultPrevented && u && (e.preventDefault(), u()));
	});
	return e.useEffect(() => {
		if (O) return g.addEventListener("keydown", k, { capture: !0 }), () => g.removeEventListener("keydown", k, { capture: !0 });
	}, [
		g,
		O,
		k
	]), e.useEffect(() => {
		if (p) return r && (f.layersWithOutsidePointerEventsDisabled.size === 0 && (ni = g.body.style.pointerEvents, g.body.style.pointerEvents = "none"), f.layersWithOutsidePointerEventsDisabled.add(p)), f.layers.add(p), li(), () => {
			r && (f.layersWithOutsidePointerEventsDisabled.delete(p), f.layersWithOutsidePointerEventsDisabled.size === 0 && (g.body.style.pointerEvents = ni));
		};
	}, [
		p,
		g,
		r,
		f
	]), e.useEffect(() => () => {
		p && (f.layers.delete(p), f.layersWithOutsidePointerEventsDisabled.delete(p), li());
	}, [p, f]), e.useEffect(() => {
		let e = /* @__PURE__ */ Z(() => _({}), "handleUpdate");
		return document.addEventListener($r, e), () => document.removeEventListener($r, e);
	}, []), /* @__PURE__ */ a(N.div, {
		...d,
		ref: v,
		style: {
			pointerEvents: C ? w ? "auto" : "none" : void 0,
			...t.style
		},
		onFocusCapture: wr(t.onFocusCapture, D.onFocusCapture),
		onBlurCapture: wr(t.onBlurCapture, D.onBlurCapture),
		onPointerDownCapture: wr(t.onPointerDownCapture, E.onPointerDownCapture)
	});
}, "DismissableLayer"));
function ai() {
	let t = e.useContext(ri), [n, r] = e.useState(null);
	return e.useEffect(() => {
		if (n) return t.dismissableSurfaces.add(n), () => {
			t.dismissableSurfaces.delete(n);
		};
	}, [n, t.dismissableSurfaces]), r;
}
Z(ai, "useDismissableLayerSurface");
var oi = /* @__PURE__ */ Z(() => !0, "IS_TRUE");
function si(t, n) {
	let { ownerDocument: r = globalThis?.document, deferPointerDownOutside: i = !1, isDeferredPointerDownOutsideRef: a, dismissableSurfaces: o, shouldHandlePointerDownOutside: s = oi } = n, c = L(t), l = e.useRef(!1), u = e.useRef(!1), d = e.useRef(/* @__PURE__ */ new Map()), f = e.useRef(() => {});
	return e.useEffect(() => {
		function e() {
			u.current = !1, a.current = !1, d.current.clear();
		}
		Z(e, "resetOutsideInteraction");
		function t() {
			return Array.from(d.current.values()).some(Boolean);
		}
		Z(t, "isOutsideInteractionIntercepted");
		function n(e) {
			if (!u.current) return;
			let t = e.target;
			t instanceof Node && [...o].some((e) => e.contains(t)) || d.current.set(e.type, !0), e.type === "click" && window.setTimeout(() => {
				u.current && f.current();
			}, 0);
		}
		Z(n, "handleInteractionCapture");
		function p(e) {
			u.current && d.current.set(e.type, !1);
		}
		Z(p, "handleInteractionBubble");
		let m = /* @__PURE__ */ Z((n) => {
			if (n.target && !l.current) {
				let o = function() {
					r.removeEventListener("click", f.current);
					let n = t();
					e(), n || ui(ei, c, p, { discrete: !0 });
				};
				if (Z(o, "handleAndDispatchPointerDownOutsideEvent"), !s(n.target)) {
					r.removeEventListener("click", f.current), e(), l.current = !1;
					return;
				}
				let p = { originalEvent: n };
				u.current = !0, a.current = i && n.button === 0, d.current.clear(), !i || n.button !== 0 ? o() : (r.removeEventListener("click", f.current), f.current = o, r.addEventListener("click", f.current, { once: !0 }));
			} else r.removeEventListener("click", f.current), e();
			l.current = !1;
		}, "handlePointerDown"), h = [
			"pointerup",
			"mousedown",
			"mouseup",
			"touchstart",
			"touchend",
			"click"
		];
		for (let e of h) r.addEventListener(e, n, !0), r.addEventListener(e, p);
		let g = window.setTimeout(() => {
			r.addEventListener("pointerdown", m);
		}, 0);
		return () => {
			window.clearTimeout(g), r.removeEventListener("pointerdown", m), r.removeEventListener("click", f.current);
			for (let e of h) r.removeEventListener(e, n, !0), r.removeEventListener(e, p);
		};
	}, [
		r,
		c,
		i,
		a,
		o,
		s
	]), { onPointerDownCapture: /* @__PURE__ */ Z(() => l.current = !0, "onPointerDownCapture") };
}
Z(si, "usePointerDownOutside");
function ci(t, n = globalThis?.document) {
	let r = L(t), i = e.useRef(!1);
	return e.useEffect(() => {
		let e = /* @__PURE__ */ Z((e) => {
			e.target && !i.current && ui(ti, r, { originalEvent: e }, { discrete: !1 });
		}, "handleFocus");
		return n.addEventListener("focusin", e), () => n.removeEventListener("focusin", e);
	}, [n, r]), {
		onFocusCapture: /* @__PURE__ */ Z(() => i.current = !0, "onFocusCapture"),
		onBlurCapture: /* @__PURE__ */ Z(() => i.current = !1, "onBlurCapture")
	};
}
Z(ci, "useFocusOutside");
function li() {
	let e = new CustomEvent($r);
	document.dispatchEvent(e);
}
Z(li, "dispatchUpdate");
function ui(e, t, n, { discrete: r }) {
	let i = n.originalEvent.target, a = new CustomEvent(e, {
		bubbles: !1,
		cancelable: !0,
		detail: n
	});
	t && i.addEventListener(e, t, { once: !0 }), r ? P(i, a) : i.dispatchEvent(a);
}
Z(ui, "handleAndDispatchCustomEvent");
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-portal@1.1.17_@types+react-dom@19.2.4_@types+react@19.2.18__@types+react@19.2_ipllvnaldonbw7njujcrayfexi/node_modules/@radix-ui/react-portal/dist/index.mjs
var di = Object.defineProperty, fi = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ ((e, t) => di(e, "name", {
	value: t,
	configurable: !0
}))(function(t, r) {
	let { container: i, ...o } = t, [s, c] = e.useState(!1);
	Nr(() => c(!0), []);
	let l = i || s && globalThis?.document?.body;
	return l ? n.createPortal(/* @__PURE__ */ a(N.div, {
		...o,
		ref: r
	}), l) : null;
}, "Portal")), pi = Object.defineProperty, mi = (e, t) => pi(e, "name", {
	value: t,
	configurable: !0
});
function hi(t, n) {
	return e.useReducer((e, t) => n[e][t] ?? e, t);
}
mi(hi, "useStateMachine");
var gi = /* @__PURE__ */ mi((t) => {
	let { present: n, children: r } = t, i = _i(n), a = typeof r == "function" ? r({ present: i.isPresent }) : e.Children.only(r), o = yi(i.ref, xi(a));
	return typeof r == "function" || i.isPresent ? e.cloneElement(a, { ref: o }) : null;
}, "Presence");
function _i(t) {
	let [n, r] = e.useState(), i = e.useRef(null), a = e.useRef(t), o = e.useRef("none"), s = e.useRef(void 0), [c, l] = hi(t ? "mounted" : "unmounted", {
		mounted: {
			UNMOUNT: "unmounted",
			ANIMATION_OUT: "unmountSuspended"
		},
		unmountSuspended: {
			MOUNT: "mounted",
			ANIMATION_END: "unmounted"
		},
		unmounted: { MOUNT: "mounted" }
	});
	return e.useEffect(() => {
		c === "mounted" ? (o.current = s.current ?? bi(i.current), s.current = void 0) : o.current = "none";
	}, [c]), Nr(() => {
		let e = i.current, n = a.current;
		if (n !== t) {
			let r = o.current, i = bi(e);
			t ? (s.current = i, l("MOUNT")) : i === "none" || e?.display === "none" ? l("UNMOUNT") : l(n && r !== i ? "ANIMATION_OUT" : "UNMOUNT"), a.current = t;
		}
	}, [t, l]), Nr(() => {
		if (n) {
			let e, t = n.ownerDocument.defaultView ?? window, r = /* @__PURE__ */ mi((r) => {
				let o = bi(i.current).includes(CSS.escape(r.animationName));
				if (r.target === n && o && (l("ANIMATION_END"), !a.current)) {
					let r = n.style.animationFillMode;
					n.style.animationFillMode = "forwards", e = t.setTimeout(() => {
						n.style.animationFillMode === "forwards" && (n.style.animationFillMode = r);
					});
				}
			}, "handleAnimationEnd"), s = /* @__PURE__ */ mi((e) => {
				e.target === n && (o.current = bi(i.current));
			}, "handleAnimationStart");
			return n.addEventListener("animationstart", s), n.addEventListener("animationcancel", r), n.addEventListener("animationend", r), () => {
				t.clearTimeout(e), n.removeEventListener("animationstart", s), n.removeEventListener("animationcancel", r), n.removeEventListener("animationend", r);
			};
		}
		l("ANIMATION_END");
	}, [n, l]), {
		isPresent: ["mounted", "unmountSuspended"].includes(c),
		ref: e.useCallback((e) => {
			if (e) {
				let t = getComputedStyle(e);
				i.current = t, s.current = bi(t);
			} else i.current = null;
			r(e);
		}, [])
	};
}
mi(_i, "usePresence");
function vi(e, t) {
	if (typeof e == "function") return e(t);
	e != null && (e.current = t);
}
mi(vi, "setRef");
function yi(...t) {
	let n = e.useRef(t);
	return n.current = t, e.useCallback((e) => {
		let t = n.current, r = !1, i = t.map((t) => {
			let n = vi(t, e);
			return !r && typeof n == "function" && (r = !0), n;
		});
		if (r) return () => {
			for (let e = 0; e < i.length; e++) {
				let n = i[e];
				typeof n == "function" ? n() : vi(t[e], null);
			}
		};
	}, []);
}
mi(yi, "useStableComposedRefs");
function bi(e) {
	return e?.animationName || "none";
}
mi(bi, "getAnimationName");
function xi(e) {
	let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
	return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
mi(xi, "getElementRef");
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-focus-guards@1.1.6_@types+react@19.2.18_react@19.2.8/node_modules/@radix-ui/react-focus-guards/dist/index.mjs
var Si = Object.defineProperty, Ci = (e, t) => Si(e, "name", {
	value: t,
	configurable: !0
}), wi = 0, Ti = null;
function Ei(e) {
	return Di(), e.children;
}
Ci(Ei, "FocusGuards");
function Di() {
	e.useEffect(() => {
		Ti ||= {
			start: Oi(),
			end: Oi()
		};
		let { start: e, end: t } = Ti;
		return document.body.firstElementChild !== e && document.body.insertAdjacentElement("afterbegin", e), document.body.lastElementChild !== t && document.body.insertAdjacentElement("beforeend", t), wi++, () => {
			wi === 1 && (Ti?.start.remove(), Ti?.end.remove(), Ti = null), wi = Math.max(0, wi - 1);
		};
	}, []);
}
Ci(Di, "useFocusGuards");
function Oi() {
	let e = document.createElement("span");
	return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
Ci(Oi, "createFocusGuard");
//#endregion
//#region ../../node_modules/.pnpm/tslib@2.8.1/node_modules/tslib/tslib.es6.mjs
var ki = function() {
	return ki = Object.assign || function(e) {
		for (var t, n = 1, r = arguments.length; n < r; n++) for (var i in t = arguments[n], t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
		return e;
	}, ki.apply(this, arguments);
};
function Ai(e, t) {
	var n = {};
	for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
	if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++) t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
	return n;
}
function ji(e, t, n) {
	if (n || arguments.length === 2) for (var r = 0, i = t.length, a; r < i; r++) (a || !(r in t)) && (a ||= Array.prototype.slice.call(t, 0, r), a[r] = t[r]);
	return e.concat(a || Array.prototype.slice.call(t));
}
//#endregion
//#region ../../node_modules/.pnpm/react-remove-scroll-bar@2.3.8_@types+react@19.2.18_react@19.2.8/node_modules/react-remove-scroll-bar/dist/es2015/constants.js
var Mi = "right-scroll-bar-position", Ni = "width-before-scroll-bar", Pi = "with-scroll-bars-hidden", Fi = "--removed-body-scroll-bar-size";
//#endregion
//#region ../../node_modules/.pnpm/use-callback-ref@1.3.3_@types+react@19.2.18_react@19.2.8/node_modules/use-callback-ref/dist/es2015/assignRef.js
function Ii(e, t) {
	return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
//#endregion
//#region ../../node_modules/.pnpm/use-callback-ref@1.3.3_@types+react@19.2.18_react@19.2.8/node_modules/use-callback-ref/dist/es2015/useRef.js
function Li(e, n) {
	var r = t(function() {
		return {
			value: e,
			callback: n,
			facade: {
				get current() {
					return r.value;
				},
				set current(e) {
					var t = r.value;
					t !== e && (r.value = e, r.callback(e, t));
				}
			}
		};
	})[0];
	return r.callback = n, r.facade;
}
//#endregion
//#region ../../node_modules/.pnpm/use-callback-ref@1.3.3_@types+react@19.2.18_react@19.2.8/node_modules/use-callback-ref/dist/es2015/useMergeRef.js
var Ri = typeof window < "u" ? e.useLayoutEffect : e.useEffect, zi = /* @__PURE__ */ new WeakMap();
function Bi(e, t) {
	var n = Li(t || null, function(t) {
		return e.forEach(function(e) {
			return Ii(e, t);
		});
	});
	return Ri(function() {
		var t = zi.get(n);
		if (t) {
			var r = new Set(t), i = new Set(e), a = n.current;
			r.forEach(function(e) {
				i.has(e) || Ii(e, null);
			}), i.forEach(function(e) {
				r.has(e) || Ii(e, a);
			});
		}
		zi.set(n, e);
	}, [e]), n;
}
//#endregion
//#region ../../node_modules/.pnpm/use-sidecar@1.1.3_@types+react@19.2.18_react@19.2.8/node_modules/use-sidecar/dist/es2015/medium.js
function Vi(e) {
	return e;
}
function Hi(e, t) {
	t === void 0 && (t = Vi);
	var n = [], r = !1;
	return {
		read: function() {
			if (r) throw Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
			return n.length ? n[n.length - 1] : e;
		},
		useMedium: function(e) {
			var i = t(e, r);
			return n.push(i), function() {
				n = n.filter(function(e) {
					return e !== i;
				});
			};
		},
		assignSyncMedium: function(e) {
			for (r = !0; n.length;) {
				var t = n;
				n = [], t.forEach(e);
			}
			n = {
				push: function(t) {
					return e(t);
				},
				filter: function() {
					return n;
				}
			};
		},
		assignMedium: function(e) {
			r = !0;
			var t = [];
			if (n.length) {
				var i = n;
				n = [], i.forEach(e), t = n;
			}
			var a = function() {
				var n = t;
				t = [], n.forEach(e);
			}, o = function() {
				return Promise.resolve().then(a);
			};
			o(), n = {
				push: function(e) {
					t.push(e), o();
				},
				filter: function(e) {
					return t = t.filter(e), n;
				}
			};
		}
	};
}
function Ui(e) {
	e === void 0 && (e = {});
	var t = Hi(null);
	return t.options = ki({
		async: !0,
		ssr: !1
	}, e), t;
}
//#endregion
//#region ../../node_modules/.pnpm/use-sidecar@1.1.3_@types+react@19.2.18_react@19.2.8/node_modules/use-sidecar/dist/es2015/exports.js
var Wi = function(t) {
	var n = t.sideCar, r = Ai(t, ["sideCar"]);
	if (!n) throw Error("Sidecar: please provide `sideCar` property to import the right car");
	var i = n.read();
	if (!i) throw Error("Sidecar medium not found");
	return e.createElement(i, ki({}, r));
};
Wi.isSideCarExport = !0;
function Gi(e, t) {
	return e.useMedium(t), Wi;
}
//#endregion
//#region ../../node_modules/.pnpm/react-remove-scroll@2.7.2_@types+react@19.2.18_react@19.2.8/node_modules/react-remove-scroll/dist/es2015/medium.js
var Ki = Ui(), qi = function() {}, Ji = e.forwardRef(function(t, n) {
	var r = e.useRef(null), i = e.useState({
		onScrollCapture: qi,
		onWheelCapture: qi,
		onTouchMoveCapture: qi
	}), a = i[0], o = i[1], s = t.forwardProps, c = t.children, l = t.className, u = t.removeScrollBar, d = t.enabled, f = t.shards, p = t.sideCar, m = t.noRelative, h = t.noIsolation, g = t.inert, _ = t.allowPinchZoom, v = t.as, y = v === void 0 ? "div" : v, b = t.gapMode, x = Ai(t, [
		"forwardProps",
		"children",
		"className",
		"removeScrollBar",
		"enabled",
		"shards",
		"sideCar",
		"noRelative",
		"noIsolation",
		"inert",
		"allowPinchZoom",
		"as",
		"gapMode"
	]), S = p, C = Bi([r, n]), w = ki(ki({}, x), a);
	return e.createElement(e.Fragment, null, d && e.createElement(S, {
		sideCar: Ki,
		removeScrollBar: u,
		shards: f,
		noRelative: m,
		noIsolation: h,
		inert: g,
		setCallbacks: o,
		allowPinchZoom: !!_,
		lockRef: r,
		gapMode: b
	}), s ? e.cloneElement(e.Children.only(c), ki(ki({}, w), { ref: C })) : e.createElement(y, ki({}, w, {
		className: l,
		ref: C
	}), c));
});
Ji.defaultProps = {
	enabled: !0,
	removeScrollBar: !0,
	inert: !1
}, Ji.classNames = {
	fullWidth: Ni,
	zeroRight: Mi
};
//#endregion
//#region ../../node_modules/.pnpm/get-nonce@1.0.1/node_modules/get-nonce/dist/es2015/index.js
var Yi, Xi = function() {
	if (Yi) return Yi;
	if (typeof __webpack_nonce__ < "u") return __webpack_nonce__;
};
//#endregion
//#region ../../node_modules/.pnpm/react-style-singleton@2.2.3_@types+react@19.2.18_react@19.2.8/node_modules/react-style-singleton/dist/es2015/singleton.js
function Zi() {
	if (!document) return null;
	var e = document.createElement("style");
	e.type = "text/css";
	var t = Xi();
	return t && e.setAttribute("nonce", t), e;
}
function Qi(e, t) {
	e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function $i(e) {
	(document.head || document.getElementsByTagName("head")[0]).appendChild(e);
}
var ea = function() {
	var e = 0, t = null;
	return {
		add: function(n) {
			e == 0 && (t = Zi()) && (Qi(t, n), $i(t)), e++;
		},
		remove: function() {
			e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
		}
	};
}, ta = function() {
	var t = ea();
	return function(n, r) {
		e.useEffect(function() {
			return t.add(n), function() {
				t.remove();
			};
		}, [n && r]);
	};
}, na = function() {
	var e = ta();
	return function(t) {
		var n = t.styles, r = t.dynamic;
		return e(n, r), null;
	};
}, ra = {
	left: 0,
	top: 0,
	right: 0,
	gap: 0
}, ia = function(e) {
	return parseInt(e || "", 10) || 0;
}, aa = function(e) {
	var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], i = t[e === "padding" ? "paddingRight" : "marginRight"];
	return [
		ia(n),
		ia(r),
		ia(i)
	];
}, oa = function(e) {
	if (e === void 0 && (e = "margin"), typeof window > "u") return ra;
	var t = aa(e), n = document.documentElement.clientWidth, r = window.innerWidth;
	return {
		left: t[0],
		top: t[1],
		right: t[2],
		gap: Math.max(0, r - n + t[2] - t[0])
	};
}, sa = na(), ca = "data-scroll-locked", la = function(e, t, n, r) {
	var i = e.left, a = e.top, o = e.right, s = e.gap;
	return n === void 0 && (n = "margin"), `
  .${Pi} {
   overflow: hidden ${r};
   padding-right: ${s}px ${r};
  }
  body[${ca}] {
    overflow: hidden ${r};
    overscroll-behavior: contain;
    ${[
		t && `position: relative ${r};`,
		n === "margin" && `
    padding-left: ${i}px;
    padding-top: ${a}px;
    padding-right: ${o}px;
    margin-left:0;
    margin-top:0;
    margin-right: ${s}px ${r};
    `,
		n === "padding" && `padding-right: ${s}px ${r};`
	].filter(Boolean).join("")}
  }
  
  .${Mi} {
    right: ${s}px ${r};
  }
  
  .${Ni} {
    margin-right: ${s}px ${r};
  }
  
  .${Mi} .${Mi} {
    right: 0 ${r};
  }
  
  .${Ni} .${Ni} {
    margin-right: 0 ${r};
  }
  
  body[${ca}] {
    ${Fi}: ${s}px;
  }
`;
}, ua = function() {
	var e = parseInt(document.body.getAttribute("data-scroll-locked") || "0", 10);
	return isFinite(e) ? e : 0;
}, da = function() {
	e.useEffect(function() {
		return document.body.setAttribute(ca, (ua() + 1).toString()), function() {
			var e = ua() - 1;
			e <= 0 ? document.body.removeAttribute(ca) : document.body.setAttribute(ca, e.toString());
		};
	}, []);
}, fa = function(t) {
	var n = t.noRelative, r = t.noImportant, i = t.gapMode, a = i === void 0 ? "margin" : i;
	da();
	var o = e.useMemo(function() {
		return oa(a);
	}, [a]);
	return e.createElement(sa, { styles: la(o, !n, a, r ? "" : "!important") });
}, pa = !1;
if (typeof window < "u") try {
	var ma = Object.defineProperty({}, "passive", { get: function() {
		return pa = !0, !0;
	} });
	window.addEventListener("test", ma, ma), window.removeEventListener("test", ma, ma);
} catch {
	pa = !1;
}
var ha = pa ? { passive: !1 } : !1, ga = function(e) {
	return e.tagName === "TEXTAREA";
}, _a = function(e, t) {
	if (!(e instanceof Element)) return !1;
	var n = window.getComputedStyle(e);
	return n[t] !== "hidden" && !(n.overflowY === n.overflowX && !ga(e) && n[t] === "visible");
}, va = function(e) {
	return _a(e, "overflowY");
}, ya = function(e) {
	return _a(e, "overflowX");
}, ba = function(e, t) {
	var n = t.ownerDocument, r = t;
	do {
		if (typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host), Ca(e, r)) {
			var i = wa(e, r);
			if (i[1] > i[2]) return !0;
		}
		r = r.parentNode;
	} while (r && r !== n.body);
	return !1;
}, xa = function(e) {
	return [
		e.scrollTop,
		e.scrollHeight,
		e.clientHeight
	];
}, Sa = function(e) {
	return [
		e.scrollLeft,
		e.scrollWidth,
		e.clientWidth
	];
}, Ca = function(e, t) {
	return e === "v" ? va(t) : ya(t);
}, wa = function(e, t) {
	return e === "v" ? xa(t) : Sa(t);
}, Ta = function(e, t) {
	return e === "h" && t === "rtl" ? -1 : 1;
}, Ea = function(e, t, n, r, i) {
	var a = Ta(e, window.getComputedStyle(t).direction), o = a * r, s = n.target, c = t.contains(s), l = !1, u = o > 0, d = 0, f = 0;
	do {
		if (!s) break;
		var p = wa(e, s), m = p[0], h = p[1] - p[2] - a * m;
		(m || h) && Ca(e, s) && (d += h, f += m);
		var g = s.parentNode;
		s = g && g.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? g.host : g;
	} while (!c && s !== document.body || c && (t.contains(s) || t === s));
	return (u && (i && Math.abs(d) < 1 || !i && o > d) || !u && (i && Math.abs(f) < 1 || !i && -o > f)) && (l = !0), l;
}, Da = function(e) {
	return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, Oa = function(e) {
	return [e.deltaX, e.deltaY];
}, ka = function(e) {
	return e && "current" in e ? e.current : e;
}, Aa = function(e, t) {
	return e[0] === t[0] && e[1] === t[1];
}, ja = function(e) {
	return `
  .block-interactivity-${e} {pointer-events: none;}
  .allow-interactivity-${e} {pointer-events: all;}
`;
}, Ma = 0, Na = [];
function Pa(t) {
	var n = e.useRef([]), r = e.useRef([0, 0]), i = e.useRef(), a = e.useState(Ma++)[0], o = e.useState(na)[0], s = e.useRef(t);
	e.useEffect(function() {
		s.current = t;
	}, [t]), e.useEffect(function() {
		if (t.inert) {
			document.body.classList.add(`block-interactivity-${a}`);
			var e = ji([t.lockRef.current], (t.shards || []).map(ka), !0).filter(Boolean);
			return e.forEach(function(e) {
				return e.classList.add(`allow-interactivity-${a}`);
			}), function() {
				document.body.classList.remove(`block-interactivity-${a}`), e.forEach(function(e) {
					return e.classList.remove(`allow-interactivity-${a}`);
				});
			};
		}
	}, [
		t.inert,
		t.lockRef.current,
		t.shards
	]);
	var c = e.useCallback(function(e, t) {
		if ("touches" in e && e.touches.length === 2 || e.type === "wheel" && e.ctrlKey) return !s.current.allowPinchZoom;
		var n = Da(e), a = r.current, o = "deltaX" in e ? e.deltaX : a[0] - n[0], c = "deltaY" in e ? e.deltaY : a[1] - n[1], l, u = e.target, d = Math.abs(o) > Math.abs(c) ? "h" : "v";
		if ("touches" in e && d === "h" && u.type === "range") return !1;
		var f = window.getSelection(), p = f && f.anchorNode;
		if (p && (p === u || p.contains(u))) return !1;
		var m = ba(d, u);
		if (!m) return !0;
		if (m ? l = d : (l = d === "v" ? "h" : "v", m = ba(d, u)), !m) return !1;
		if (!i.current && "changedTouches" in e && (o || c) && (i.current = l), !l) return !0;
		var h = i.current || l;
		return Ea(h, t, e, h === "h" ? o : c, !0);
	}, []), l = e.useCallback(function(e) {
		var t = e;
		if (!(!Na.length || Na[Na.length - 1] !== o)) {
			var r = "deltaY" in t ? Oa(t) : Da(t), i = n.current.filter(function(e) {
				return e.name === t.type && (e.target === t.target || t.target === e.shadowParent) && Aa(e.delta, r);
			})[0];
			if (i && i.should) {
				t.cancelable && t.preventDefault();
				return;
			}
			if (!i) {
				var a = (s.current.shards || []).map(ka).filter(Boolean).filter(function(e) {
					return e.contains(t.target);
				});
				(a.length > 0 ? c(t, a[0]) : !s.current.noIsolation) && t.cancelable && t.preventDefault();
			}
		}
	}, []), u = e.useCallback(function(e, t, r, i) {
		var a = {
			name: e,
			delta: t,
			target: r,
			should: i,
			shadowParent: Fa(r)
		};
		n.current.push(a), setTimeout(function() {
			n.current = n.current.filter(function(e) {
				return e !== a;
			});
		}, 1);
	}, []), d = e.useCallback(function(e) {
		r.current = Da(e), i.current = void 0;
	}, []), f = e.useCallback(function(e) {
		u(e.type, Oa(e), e.target, c(e, t.lockRef.current));
	}, []), p = e.useCallback(function(e) {
		u(e.type, Da(e), e.target, c(e, t.lockRef.current));
	}, []);
	e.useEffect(function() {
		return Na.push(o), t.setCallbacks({
			onScrollCapture: f,
			onWheelCapture: f,
			onTouchMoveCapture: p
		}), document.addEventListener("wheel", l, ha), document.addEventListener("touchmove", l, ha), document.addEventListener("touchstart", d, ha), function() {
			Na = Na.filter(function(e) {
				return e !== o;
			}), document.removeEventListener("wheel", l, ha), document.removeEventListener("touchmove", l, ha), document.removeEventListener("touchstart", d, ha);
		};
	}, []);
	var m = t.removeScrollBar, h = t.inert;
	return e.createElement(e.Fragment, null, h ? e.createElement(o, { styles: ja(a) }) : null, m ? e.createElement(fa, {
		noRelative: t.noRelative,
		gapMode: t.gapMode
	}) : null);
}
function Fa(e) {
	for (var t = null; e !== null;) e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
	return t;
}
//#endregion
//#region ../../node_modules/.pnpm/react-remove-scroll@2.7.2_@types+react@19.2.18_react@19.2.8/node_modules/react-remove-scroll/dist/es2015/sidecar.js
var Ia = Gi(Ki, Pa), La = e.forwardRef(function(t, n) {
	return e.createElement(Ji, ki({}, t, {
		ref: n,
		sideCar: Ia
	}));
});
La.classNames = Ji.classNames;
//#endregion
//#region ../../node_modules/.pnpm/aria-hidden@1.2.6/node_modules/aria-hidden/dist/es2015/index.js
var Ra = function(e) {
	return typeof document > "u" ? null : (Array.isArray(e) ? e[0] : e).ownerDocument.body;
}, za = /* @__PURE__ */ new WeakMap(), Ba = /* @__PURE__ */ new WeakMap(), Va = {}, Ha = 0, Ua = function(e) {
	return e && (e.host || Ua(e.parentNode));
}, Wa = function(e, t) {
	return t.map(function(t) {
		if (e.contains(t)) return t;
		var n = Ua(t);
		return n && e.contains(n) ? n : (console.error("aria-hidden", t, "in not contained inside", e, ". Doing nothing"), null);
	}).filter(function(e) {
		return !!e;
	});
}, Ga = function(e, t, n, r) {
	var i = Wa(t, Array.isArray(e) ? e : [e]);
	Va[n] || (Va[n] = /* @__PURE__ */ new WeakMap());
	var a = Va[n], o = [], s = /* @__PURE__ */ new Set(), c = new Set(i), l = function(e) {
		!e || s.has(e) || (s.add(e), l(e.parentNode));
	};
	i.forEach(l);
	var u = function(e) {
		!e || c.has(e) || Array.prototype.forEach.call(e.children, function(e) {
			if (s.has(e)) u(e);
			else try {
				var t = e.getAttribute(r), i = t !== null && t !== "false", c = (za.get(e) || 0) + 1, l = (a.get(e) || 0) + 1;
				za.set(e, c), a.set(e, l), o.push(e), c === 1 && i && Ba.set(e, !0), l === 1 && e.setAttribute(n, "true"), i || e.setAttribute(r, "true");
			} catch (t) {
				console.error("aria-hidden: cannot operate on ", e, t);
			}
		});
	};
	return u(t), s.clear(), Ha++, function() {
		o.forEach(function(e) {
			var t = za.get(e) - 1, i = a.get(e) - 1;
			za.set(e, t), a.set(e, i), t || (Ba.has(e) || e.removeAttribute(r), Ba.delete(e)), i || e.removeAttribute(n);
		}), Ha--, Ha || (za = /* @__PURE__ */ new WeakMap(), za = /* @__PURE__ */ new WeakMap(), Ba = /* @__PURE__ */ new WeakMap(), Va = {});
	};
}, Ka = function(e, t, n) {
	n === void 0 && (n = "data-aria-hidden");
	var r = Array.from(Array.isArray(e) ? e : [e]), i = t || Ra(e);
	return i ? (r.push.apply(r, Array.from(i.querySelectorAll("[aria-live], script"))), Ga(r, i, n, "aria-hidden")) : function() {
		return null;
	};
}, qa = Object.defineProperty, Q = (e, t) => qa(e, "name", {
	value: t,
	configurable: !0
}), Ja = "Dialog", [Ya, Xa] = /* @__PURE__ */ jr(Ja), [Za, $] = Ya(Ja), Qa = /* @__PURE__ */ Q((t) => {
	let { __scopeDialog: n, children: r, open: i, defaultOpen: o, onOpenChange: s, modal: c = !0 } = t, l = e.useRef(null), u = e.useRef(null), [d, f] = qr({
		prop: i,
		defaultProp: o ?? !1,
		onChange: s,
		caller: Ja
	}), [p, m] = e.useState(0), [h, g] = e.useState(0);
	return /* @__PURE__ */ a(Za, {
		scope: n,
		triggerRef: l,
		contentRef: u,
		contentId: Rr(),
		titleId: Rr(),
		descriptionId: Rr(),
		titlePresent: p > 0,
		descriptionPresent: h > 0,
		setTitleCount: m,
		setDescriptionCount: g,
		open: d,
		onOpenChange: f,
		onOpenToggle: e.useCallback(() => f((e) => !e), [f]),
		modal: c,
		children: r
	});
}, "Dialog"), $a = "DialogTrigger", eo = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Q(function(e, t) {
	let { __scopeDialog: n, ...r } = e, i = $($a, n), o = m(t, i.triggerRef);
	return /* @__PURE__ */ a(N.button, {
		type: "button",
		"aria-haspopup": "dialog",
		"aria-expanded": i.open,
		"aria-controls": i.open ? i.contentId : void 0,
		"data-state": xo(i.open),
		...r,
		ref: o,
		onClick: wr(e.onClick, i.onOpenToggle)
	});
}, "DialogTrigger")), to = "DialogPortal", [no, ro] = Ya(to, { forceMount: void 0 }), io = /* @__PURE__ */ Q((t) => {
	let { __scopeDialog: n, forceMount: r, children: i, container: o } = t, s = $(to, n);
	return /* @__PURE__ */ a(no, {
		scope: n,
		forceMount: r,
		children: e.Children.map(i, (e) => /* @__PURE__ */ a(gi, {
			present: r || s.open,
			children: /* @__PURE__ */ a(fi, {
				asChild: !0,
				container: o,
				children: e
			})
		}))
	});
}, "DialogPortal"), ao = "DialogOverlay", oo = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Q(function(e, t) {
	let n = ro(ao, e.__scopeDialog), { forceMount: r = n.forceMount, ...i } = e, o = $(ao, e.__scopeDialog);
	return o.modal ? /* @__PURE__ */ a(gi, {
		present: r || o.open,
		children: /* @__PURE__ */ a(co, {
			...i,
			ref: t
		})
	}) : null;
}, "DialogOverlay")), so = /* @__PURE__ */ _("DialogOverlay.RemoveScroll"), co = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Q(function(e, t) {
	let { __scopeDialog: n, ...r } = e, i = $(ao, n), o = m(t, ai());
	return /* @__PURE__ */ a(La, {
		as: so,
		allowPinchZoom: !0,
		shards: [i.contentRef],
		children: /* @__PURE__ */ a(N.div, {
			"data-state": xo(i.open),
			...r,
			ref: o,
			style: {
				pointerEvents: "auto",
				...r.style
			}
		})
	});
}, "DialogOverlayImpl")), lo = "DialogContent", uo = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Q(function(e, t) {
	let n = ro(lo, e.__scopeDialog), { forceMount: r = n.forceMount, ...i } = e, o = $(lo, e.__scopeDialog);
	return /* @__PURE__ */ a(gi, {
		present: r || o.open,
		children: o.modal ? /* @__PURE__ */ a(fo, {
			...i,
			ref: t
		}) : /* @__PURE__ */ a(po, {
			...i,
			ref: t
		})
	});
}, "DialogContent")), fo = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Q(function(t, n) {
	let r = $(lo, t.__scopeDialog), i = e.useRef(null), o = m(n, r.contentRef, i);
	return e.useEffect(() => {
		let e = i.current;
		if (e) return Ka(e);
	}, []), /* @__PURE__ */ a(mo, {
		...t,
		ref: o,
		trapFocus: r.open,
		disableOutsidePointerEvents: r.open,
		onCloseAutoFocus: wr(t.onCloseAutoFocus, (e) => {
			e.preventDefault(), r.triggerRef.current?.focus();
		}),
		onPointerDownOutside: wr(t.onPointerDownOutside, (e) => {
			let t = e.detail.originalEvent, n = t.button === 0 && t.ctrlKey === !0;
			(t.button === 2 || n) && e.preventDefault();
		}),
		onFocusOutside: wr(t.onFocusOutside, (e) => e.preventDefault())
	});
}, "DialogContentModal")), po = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Q(function(t, n) {
	let r = $(lo, t.__scopeDialog), i = e.useRef(!1), o = e.useRef(!1);
	return /* @__PURE__ */ a(mo, {
		...t,
		ref: n,
		trapFocus: !1,
		disableOutsidePointerEvents: !1,
		onCloseAutoFocus: (e) => {
			t.onCloseAutoFocus?.(e), e.defaultPrevented || (i.current || r.triggerRef.current?.focus(), e.preventDefault()), i.current = !1, o.current = !1;
		},
		onInteractOutside: (e) => {
			t.onInteractOutside?.(e), e.defaultPrevented || (i.current = !0, e.detail.originalEvent.type === "pointerdown" && (o.current = !0));
			let n = e.target;
			r.triggerRef.current?.contains(n) && e.preventDefault(), e.detail.originalEvent.type === "focusin" && o.current && e.preventDefault();
		}
	});
}, "DialogContentNonModal")), mo = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Q(function(e, t) {
	let { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: o, onCloseAutoFocus: s, ...c } = e, l = $(lo, n);
	return Di(), /* @__PURE__ */ a(i, { children: /* @__PURE__ */ a(ne, {
		asChild: !0,
		loop: !0,
		trapped: r,
		onMountAutoFocus: o,
		onUnmountAutoFocus: s,
		children: /* @__PURE__ */ a(ii, {
			role: "dialog",
			id: l.contentId,
			"aria-describedby": l.descriptionPresent ? l.descriptionId : void 0,
			"aria-labelledby": l.titlePresent ? l.titleId : void 0,
			"data-state": xo(l.open),
			...c,
			ref: t,
			deferPointerDownOutside: !0,
			onDismiss: () => l.onOpenChange(!1)
		})
	}) });
}, "DialogContentImpl")), ho = "DialogTitle", go = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Q(function(e, t) {
	let { __scopeDialog: n, ...r } = e, i = $(ho, n), { setTitleCount: o } = i;
	return Nr(() => (o((e) => e + 1), () => o((e) => e - 1)), [o]), /* @__PURE__ */ a(N.h2, {
		id: i.titleId,
		...r,
		ref: t
	});
}, "DialogTitle")), _o = "DialogDescription", vo = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Q(function(e, t) {
	let { __scopeDialog: n, ...r } = e, i = $(_o, n), { setDescriptionCount: o } = i;
	return Nr(() => (o((e) => e + 1), () => o((e) => e - 1)), [o]), /* @__PURE__ */ a(N.p, {
		id: i.descriptionId,
		...r,
		ref: t
	});
}, "DialogDescription")), yo = "DialogClose", bo = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Q(function(e, t) {
	let { __scopeDialog: n, ...r } = e, i = $(yo, n);
	return /* @__PURE__ */ a(N.button, {
		type: "button",
		...r,
		ref: t,
		onClick: wr(e.onClick, () => i.onOpenChange(!1))
	});
}, "DialogClose"));
function xo(e) {
	return e ? "open" : "closed";
}
Q(xo, "getState");
//#endregion
//#region src/components/ui/dialog.tsx
function So({ ...e }) {
	return /* @__PURE__ */ a(Qa, {
		"data-slot": "dialog",
		...e
	});
}
function Co({ ...e }) {
	return /* @__PURE__ */ a(eo, {
		"data-slot": "dialog-trigger",
		...e
	});
}
function wo({ ...e }) {
	return /* @__PURE__ */ a(io, {
		"data-slot": "dialog-portal",
		...e
	});
}
function To({ ...e }) {
	return /* @__PURE__ */ a(bo, {
		"data-slot": "dialog-close",
		...e
	});
}
function Eo({ className: e, ...t }) {
	return /* @__PURE__ */ a(oo, {
		"data-slot": "dialog-overlay",
		className: J("fixed inset-0 z-50 bg-black/50", e),
		...t
	});
}
function Do({ className: e, children: t, overlayClassName: n, showCloseButton: r = !0, onInteractOutside: i, ...s }) {
	return /* @__PURE__ */ o(wo, { children: [/* @__PURE__ */ a(Eo, { className: n }), /* @__PURE__ */ o(uo, {
		"data-slot": "dialog-content",
		className: J("fixed left-1/2 top-1/2 z-50 grid w-[calc(100vw-2rem)] max-w-lg -translate-x-1/2 -translate-y-1/2 gap-4 rounded-lg border bg-background p-6 text-foreground shadow-lg outline-none", e),
		onInteractOutside: (e) => {
			Rt(e.target) && e.preventDefault(), i?.(e);
		},
		...s,
		children: [t, r && /* @__PURE__ */ o(bo, {
			className: "absolute right-4 top-4 grid size-8 cursor-pointer place-items-center rounded-full text-muted-foreground transition-colors hover:bg-muted hover:text-foreground focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:pointer-events-none",
			children: [/* @__PURE__ */ o("svg", {
				"aria-hidden": "true",
				className: "size-4",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: "2",
				viewBox: "0 0 24 24",
				children: [/* @__PURE__ */ a("path", { d: "M18 6 6 18" }), /* @__PURE__ */ a("path", { d: "m6 6 12 12" })]
			}), /* @__PURE__ */ a("span", {
				className: "sr-only",
				children: "Close"
			})]
		})]
	})] });
}
function Oo({ className: e, ...t }) {
	return /* @__PURE__ */ a("div", {
		"data-slot": "dialog-header",
		className: J("flex flex-col gap-2 text-center sm:text-left", e),
		...t
	});
}
function ko({ className: e, ...t }) {
	return /* @__PURE__ */ a("div", {
		"data-slot": "dialog-body",
		className: e,
		...t
	});
}
function Ao({ className: e, ...t }) {
	return /* @__PURE__ */ a("div", {
		"data-slot": "dialog-footer",
		className: J("flex flex-col-reverse gap-2 sm:flex-row sm:justify-end", e),
		...t
	});
}
function jo({ className: e, ...t }) {
	return /* @__PURE__ */ a(go, {
		"data-slot": "dialog-title",
		className: J("text-lg font-semibold leading-none tracking-tight", e),
		...t
	});
}
function Mo({ className: e, ...t }) {
	return /* @__PURE__ */ a(vo, {
		"data-slot": "dialog-description",
		className: J("text-sm text-muted-foreground", e),
		...t
	});
}
//#endregion
//#region src/components/ui/input.tsx
function No({ w: e = 24, h: t = 24, fill: n = "#A4A4A4", className: r }) {
	return /* @__PURE__ */ o("svg", {
		width: e,
		height: t,
		className: r,
		viewBox: "0 0 24 24",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		"aria-hidden": "true",
		children: [/* @__PURE__ */ a("path", {
			d: "M11 20.75C5.62 20.75 1.25 16.38 1.25 11C1.25 5.62 5.62 1.25 11 1.25C16.38 1.25 20.75 5.62 20.75 11C20.75 16.38 16.38 20.75 11 20.75ZM11 2.75C6.45 2.75 2.75 6.45 2.75 11C2.75 15.55 6.45 19.25 11 19.25C15.55 19.25 19.25 15.55 19.25 11C19.25 6.45 15.55 2.75 11 2.75Z",
			fill: n
		}), /* @__PURE__ */ a("path", {
			d: "M20.16 22.79C20.08 22.79 20 22.78 19.93 22.77C19.46 22.71 18.61 22.39 18.13 20.96C17.88 20.21 17.97 19.46 18.38 18.89C18.79 18.32 19.48 18 20.27 18C21.29 18 22.09 18.39 22.45 19.08C22.81 19.77 22.71 20.65 22.14 21.5C21.43 22.57 20.66 22.79 20.16 22.79ZM19.56 20.49C19.73 21.01 19.97 21.27 20.13 21.29C20.29 21.31 20.59 21.12 20.9 20.67C21.19 20.24 21.21 19.93 21.14 19.79C21.07 19.65 20.79 19.5 20.27 19.5C19.96 19.5 19.73 19.6 19.6 19.77C19.48 19.94 19.46 20.2 19.56 20.49Z",
			fill: n
		})]
	});
}
function Po({ className: t, type: n, id: r, label: i, variant: s = "default", size: c = "default", fieldClassName: l, labelClassName: u, inputWrapperClassName: d, startAdornment: f, endAdornment: p, invalid: m, missing: h, missingLabel: g = "Missing", missingClassName: _, error: v, errorClassName: y, onValueChange: b, onChange: x, placeholder: S, ...C }) {
	let w = e.useId(), T = r ?? (i ? w : void 0), E = m ?? C["aria-invalid"] ?? !!v, D = n === "search", O = S ?? (D ? "Search" : void 0), k = p === void 0 ? D ? /* @__PURE__ */ a("span", {
		className: "pointer-events-none absolute right-[14px] top-1/2 z-[1] -translate-y-1/2",
		children: /* @__PURE__ */ a(No, {
			w: 16,
			h: 16
		})
	}) : void 0 : p, A = /* @__PURE__ */ a("input", {
		id: T,
		type: n,
		"data-slot": "input",
		"aria-invalid": E,
		placeholder: O,
		className: J(zo(s, !!E), Ro(c), D && p === void 0 && "pr-[42px]", D && "[&::-webkit-search-cancel-button]:appearance-none", t),
		onChange: (e) => {
			x?.(e), b?.(e.target.value);
		},
		...C
	}), j = !!(f || k);
	return !i && !j && !l && !h && !v ? A : /* @__PURE__ */ o("div", {
		className: J(Fo(s), l),
		children: [
			i && /* @__PURE__ */ a(Y, {
				htmlFor: T,
				className: J(Io(s), Lo(c), u),
				children: i
			}),
			j ? /* @__PURE__ */ o("div", {
				className: J("relative w-full", d),
				children: [
					f,
					A,
					k
				]
			}) : A,
			h && /* @__PURE__ */ a(Y, {
				className: J("inline-block w-full text-right text-[12px] font-normal leading-[normal] text-[#f75245]", _),
				children: g
			}),
			v && /* @__PURE__ */ a(Y, {
				className: J("inline-block w-full text-[12px] font-normal leading-[normal] text-destructive", y),
				children: v
			})
		]
	});
}
function Fo(e) {
	if (e === "dashboard") return "block min-w-0";
}
function Io(e) {
	return e === "dashboard" ? "mb-[8px] block text-[16px] font-normal leading-[130%] text-[#404040]" : e === "auth" ? "ml-[2px] block text-[14px] font-semibold leading-[normal] text-black" : e === "auth-password" ? "inline-block w-full text-left text-[14px] font-bold leading-[normal] text-black" : "mb-2 block text-sm font-medium leading-none text-foreground";
}
function Lo(e) {
	if (e === "small") return "mb-[5px] text-[12px]";
}
function Ro(e) {
	if (e === "small") return "h-[36px] min-h-0 rounded-[8px] text-[13px]";
}
function zo(e, t) {
	return e === "dashboard" ? "flex h-[45px] w-full min-w-0 rounded-[12px] border border-[#f8f8f8] bg-[#f8f8f8] px-[14px] text-[14px] text-[#404040] shadow-none outline-none transition-[color,box-shadow] placeholder:text-[#8a8a8a] disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 focus-visible:border-[#2f80ed] focus-visible:ring-0" : e === "auth" ? J("mt-[6px] block h-[37px] w-full min-w-0 rounded-[4px] border border-solid bg-white px-[17px] py-0 text-[16px] leading-[1.15] text-black shadow-none outline-0 transition-[color,box-shadow] disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 focus-visible:border-[#456bb0] focus-visible:ring-0 md:text-[16px]", t ? "border-[#f75245]" : "border-[rgb(112_112_112_/_25%)]") : e === "auth-password" ? J("block h-[36px] w-full min-w-0 rounded-[4px] border border-solid bg-white py-0 pl-[8px] pr-[33px] text-[16px] leading-[1.15] text-black shadow-none outline-0 transition-[color,box-shadow] disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 focus-visible:border-[#456bb0] focus-visible:ring-0 md:text-[16px]", t ? "border-[#f75245]" : "border-[rgb(112_112_112_/_25%)]") : J("flex h-9 w-full min-w-0 rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none selection:bg-primary selection:text-primary-foreground placeholder:text-muted-foreground disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm", "focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50", "aria-invalid:border-destructive aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40");
}
//#endregion
//#region src/components/ui/input-collapse.tsx
function Bo({ label: t, children: n, defaultExpanded: r = !1, disabled: i = !1, disableCollapse: s = !1, className: c, headerClassName: l, contentClassName: u, toggleIcon: d }) {
	let [f, p] = e.useState(r || s), m = e.useId();
	return s ? /* @__PURE__ */ a("div", {
		className: c,
		children: n
	}) : /* @__PURE__ */ o("div", {
		className: J("input-collapse", c),
		children: [/* @__PURE__ */ o("button", {
			type: "button",
			className: J("flex min-h-[45px] w-full items-center justify-between gap-[12px] rounded-[12px] bg-transparent text-left text-[16px] font-normal leading-[130%] text-[#404040] outline-none transition-colors hover:text-[#307FF6] disabled:cursor-not-allowed disabled:opacity-60", l),
			"aria-expanded": f,
			"aria-controls": m,
			disabled: i,
			onClick: () => p((e) => !e),
			children: [/* @__PURE__ */ a("span", {
				className: "min-w-0 overflow-hidden text-ellipsis whitespace-nowrap",
				children: t
			}), d?.(f, i) ?? (f ? /* @__PURE__ */ a(Vo, {}) : /* @__PURE__ */ a(Ho, { fill: i ? "rgba(0, 0, 0, 0.26)" : "#6C6C6C" }))]
		}), f && /* @__PURE__ */ a("div", {
			id: m,
			className: J("pb-[8px]", u),
			children: n
		})]
	});
}
function Vo({ fill: e = "#6C6C6C" }) {
	return /* @__PURE__ */ a("svg", {
		width: "24",
		height: "24",
		viewBox: "0 0 24 24",
		fill: "none",
		"aria-hidden": "true",
		children: /* @__PURE__ */ a("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M22.6667 12C22.6667 17.891 17.891 22.6667 12 22.6667C6.10896 22.6667 1.33333 17.891 1.33333 12C1.33333 6.10896 6.10896 1.33333 12 1.33333C17.891 1.33333 22.6667 6.10896 22.6667 12ZM24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM6.66638 10.6661C5.93 10.6661 5.33305 11.2631 5.33305 11.9994C5.33305 12.7358 5.93 13.3328 6.66638 13.3328L17.333 13.3328C18.0694 13.3328 18.6664 12.7358 18.6664 11.9994C18.6664 11.2631 18.0694 10.6661 17.333 10.6661L6.66638 10.6661Z",
			fill: e
		})
	});
}
function Ho({ fill: e = "#6C6C6C" }) {
	return /* @__PURE__ */ a("svg", {
		width: "24",
		height: "24",
		viewBox: "0 0 24 24",
		fill: "none",
		"aria-hidden": "true",
		children: /* @__PURE__ */ a("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M22.6667 12C22.6667 17.891 17.891 22.6667 12 22.6667C6.10896 22.6667 1.33333 17.891 1.33333 12C1.33333 6.10896 6.10896 1.33333 12 1.33333C17.891 1.33333 22.6667 6.10896 22.6667 12ZM24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM11.9997 5.33594C12.5528 5.33594 13.0011 5.78431 13.0011 6.33741V11.0011L17.6649 11.0011C18.218 11.0011 18.6663 11.4495 18.6663 12.0026C18.6663 12.5557 18.218 13.0041 17.6649 13.0041L13.0011 13.0041L13.0011 17.6678C13.0011 18.2209 12.5528 18.6693 11.9997 18.6693C11.4466 18.6693 10.9982 18.2209 10.9982 17.6678L10.9982 13.0041H6.33448C5.78138 13.0041 5.33301 12.5557 5.33301 12.0026C5.33301 11.4495 5.78138 11.0011 6.33448 11.0011H10.9982V6.33741C10.9982 5.78431 11.4466 5.33594 11.9997 5.33594Z",
			fill: e
		})
	});
}
//#endregion
//#region src/components/ui/logo-uploader.tsx
var Uo = 5242880, Wo = /* @__PURE__ */ new Set([
	"image/png",
	"image/jpeg",
	"image/webp"
]);
function Go({ heading: t, name: n, currentImageUrl: r, value: i, disabled: s = !1, busy: c = !1, error: l, description: u = "PNG, JPG or WebP, up to 5 MB.", acceptedTypes: d = [...Wo], maxBytes: f = Uo, inputAccept: p = "image/png,image/jpeg,image/webp", validateImage: m = !0, uploadLabel: h = "Upload logo", replaceLabel: g = "Replace logo", removeLabel: _ = "Remove logo", cancelLabel: v = "Cancel change", dragLabel: y = "Drag an image here, or choose a file.", busyLabel: b = "Uploading logo…", className: x, previewUrl: S, renderPreview: C, onChange: w }) {
	let T = e.useRef(null), [E, D] = e.useState(null), [O, k] = e.useState(null), [A, j] = e.useState(!1), M = e.useMemo(() => new Set(d), [d]), N = e.useId();
	e.useEffect(() => {
		if (S || i.kind !== "replace") {
			D(null);
			return;
		}
		let e = URL.createObjectURL(i.file);
		return D(e), () => URL.revokeObjectURL(e);
	}, [S, i]);
	let P = async (e) => {
		if (e) {
			if (k(null), !M.has(e.type)) {
				k("Choose a PNG, JPG, or WebP image.");
				return;
			}
			if (e.size > f) {
				k("Image must be smaller than 5 MB.");
				return;
			}
			if (!m) {
				w({
					kind: "replace",
					file: e
				});
				return;
			}
			try {
				await Ko(e), w({
					kind: "replace",
					file: e
				});
			} catch {
				k("The selected file could not be read as an image.");
			}
		}
	}, F = i.kind === "replace" ? S ?? E ?? void 0 : i.kind === "remove" ? void 0 : r, I = !!r, L = i.kind !== "unchanged";
	return /* @__PURE__ */ a("section", {
		className: J("mb-[24px] rounded-[16px] border border-[#eeeff2] bg-[#fafbfc] p-[18px]", x),
		"aria-labelledby": N,
		children: /* @__PURE__ */ o("div", {
			className: "flex flex-wrap items-center gap-[18px]",
			children: [C({
				name: n || "Logo",
				imageUrl: F
			}), /* @__PURE__ */ o("div", {
				className: "min-w-[240px] flex-1",
				children: [
					/* @__PURE__ */ a("h2", {
						id: N,
						className: "text-[18px] font-medium text-[#404040]",
						children: t
					}),
					u && /* @__PURE__ */ a("p", {
						className: "mt-[4px] text-[13px] text-[#6c6c6c]",
						children: u
					}),
					/* @__PURE__ */ a("input", {
						ref: T,
						type: "file",
						className: "sr-only",
						accept: p,
						disabled: s || c,
						onChange: (e) => {
							let t = e.currentTarget.files?.[0];
							e.currentTarget.value = "", P(t);
						}
					}),
					/* @__PURE__ */ o("div", {
						className: J("mt-[12px] rounded-[12px] border border-dashed px-[14px] py-[16px] transition-colors", A ? "border-[#307FF6] bg-[#edf5ff]" : "border-[#cfd4dc] bg-white"),
						onDragEnter: (e) => {
							e.preventDefault(), !s && !c && j(!0);
						},
						onDragOver: (e) => e.preventDefault(),
						onDragLeave: () => j(!1),
						onDrop: (e) => {
							e.preventDefault(), j(!1), !s && !c && P(e.dataTransfer.files?.[0]);
						},
						children: [/* @__PURE__ */ a("p", {
							className: "text-[14px] text-[#6c6c6c]",
							children: y
						}), /* @__PURE__ */ o("div", {
							className: "mt-[10px] flex flex-wrap gap-[8px]",
							children: [
								/* @__PURE__ */ a(yn, {
									type: "button",
									size: "sm",
									disabled: s || c,
									onClick: () => T.current?.click(),
									children: F ? g : h
								}),
								L && /* @__PURE__ */ a(yn, {
									type: "button",
									size: "sm",
									variant: "outline",
									disabled: s || c,
									onClick: () => {
										k(null), w({ kind: "unchanged" });
									},
									children: v
								}),
								I && i.kind !== "remove" && /* @__PURE__ */ a(yn, {
									type: "button",
									size: "sm",
									variant: "outline",
									disabled: s || c,
									onClick: () => {
										k(null), w({ kind: "remove" });
									},
									children: _
								})
							]
						})]
					}),
					c && /* @__PURE__ */ a("p", {
						className: "mt-[10px] text-[13px] text-[#6c6c6c]",
						role: "status",
						children: b
					}),
					(O || l) && /* @__PURE__ */ a("p", {
						className: "mt-[10px] text-[13px] text-[#bf2c2c]",
						role: "alert",
						children: O ?? l
					})
				]
			})]
		})
	});
}
async function Ko(e) {
	if (typeof createImageBitmap == "function") {
		let t = await createImageBitmap(e);
		try {
			if (t.width <= 0 || t.height <= 0) throw Error("invalid dimensions");
		} finally {
			t.close();
		}
		return;
	}
	let t = URL.createObjectURL(e);
	try {
		await new Promise((e, n) => {
			let r = new Image();
			r.onload = () => r.naturalWidth > 0 && r.naturalHeight > 0 ? e() : n(/* @__PURE__ */ Error("invalid dimensions")), r.onerror = () => n(/* @__PURE__ */ Error("decode failed")), r.src = t;
		});
	} finally {
		URL.revokeObjectURL(t);
	}
}
//#endregion
//#region src/components/ui/menu.tsx
function qo({ portal: e = !1, className: t, children: n, ...r }) {
	let i = J("z-50 min-w-[188px] overflow-hidden rounded-[12px] border border-[#eeeff2] bg-white py-[6px] text-[#404040] shadow-[0_8px_22px_rgb(2_7_79_/_14%)]", t);
	return a(e ? Bt : "div", {
		"data-slot": "menu",
		role: "menu",
		className: i,
		...r,
		children: n
	});
}
function Jo({ className: e, type: t = "button", ...n }) {
	return /* @__PURE__ */ a("button", {
		"data-slot": "menu-item",
		type: t,
		role: "menuitem",
		className: J("block w-full px-[14px] py-[9px] text-left text-[14px] text-[#404040] outline-none hover:bg-[#f8fbff] hover:text-[#307FF6] focus-visible:bg-[#f8fbff] focus-visible:text-[#307FF6] disabled:pointer-events-none disabled:opacity-50", e),
		...n
	});
}
//#endregion
//#region src/components/ui/progress.tsx
function Yo({ value: e, max: t = 100, className: n, indicatorClassName: r, ...i }) {
	let o = Math.min(100, Math.max(0, t > 0 ? e / t * 100 : 0));
	return /* @__PURE__ */ a("div", {
		"data-slot": "progress",
		className: J("h-2 w-full overflow-hidden rounded-full bg-muted", n),
		role: "progressbar",
		"aria-valuemin": 0,
		"aria-valuemax": t,
		"aria-valuenow": e,
		...i,
		children: /* @__PURE__ */ a("div", {
			"data-slot": "progress-indicator",
			className: J("h-full rounded-full bg-accent transition-[width] duration-500", r),
			style: { width: `${o}%` }
		})
	});
}
//#endregion
//#region src/components/ui/radio-group.tsx
function Xo({ id: t, label: n, value: r, options: i, onValueChange: s, row: c = !0, disabled: l = !1, ariaLabel: u, className: d, labelClassName: f }) {
	let p = e.useId(), m = t ?? p, h = /* @__PURE__ */ a("div", {
		className: J("flex gap-[16px]", c ? "flex-row flex-wrap" : "flex-col"),
		role: "radiogroup",
		"aria-label": u,
		children: i.map((e) => {
			let t = `${m}-${e.value}`, n = e.value === r;
			return /* @__PURE__ */ o("label", {
				htmlFor: t,
				className: J("flex cursor-pointer items-center gap-[8px] text-[14px] text-[#404040]", l && "cursor-not-allowed opacity-50"),
				children: [/* @__PURE__ */ a("input", {
					id: t,
					type: "radio",
					name: m,
					checked: n,
					disabled: l,
					onChange: () => s(e.value),
					className: "h-[18px] w-[18px] shrink-0 cursor-pointer accent-[#307FF6] disabled:cursor-not-allowed"
				}), e.label]
			}, e.value);
		})
	});
	return n ? /* @__PURE__ */ o("div", {
		className: J("block min-w-0", d),
		children: [/* @__PURE__ */ a(Y, {
			className: J("mb-[8px] block text-[16px] font-normal leading-[130%] text-[#404040]", f),
			children: n
		}), h]
	}) : h;
}
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-separator@1.1.15_@types+react-dom@19.2.4_@types+react@19.2.18__@types+react@1_reod6nwqi26vej5ykbpwpbiu2e/node_modules/@radix-ui/react-separator/dist/index.mjs
var Zo = Object.defineProperty, Qo = (e, t) => Zo(e, "name", {
	value: t,
	configurable: !0
}), $o = "horizontal", es = ["horizontal", "vertical"], ts = /* @__PURE__ */ e.forwardRef(/* @__PURE__ */ Qo(function(e, t) {
	let { decorative: n, orientation: r = $o, ...i } = e, o = ns(r) ? r : $o, s = n ? { role: "none" } : {
		"aria-orientation": o === "vertical" ? o : void 0,
		role: "separator"
	};
	return /* @__PURE__ */ a(N.div, {
		"data-orientation": o,
		...s,
		...i,
		ref: t
	});
}, "Separator"));
function ns(e) {
	return es.includes(e);
}
Qo(ns, "isValidOrientation");
var rs = ts;
//#endregion
//#region src/components/ui/separator.tsx
function is({ className: e, orientation: t = "horizontal", decorative: n = !0, ...r }) {
	return /* @__PURE__ */ a(rs, {
		"data-slot": "separator",
		decorative: n,
		orientation: t,
		className: J("shrink-0 bg-border data-[orientation=horizontal]:h-px data-[orientation=horizontal]:w-full data-[orientation=vertical]:h-full data-[orientation=vertical]:w-px", e),
		...r
	});
}
//#endregion
//#region src/components/ui/switch.tsx
function as({ checked: e, className: t, onClick: n, onCheckedChange: r, disabled: i, ...o }) {
	return /* @__PURE__ */ a("button", {
		type: "button",
		role: "switch",
		"aria-checked": e,
		disabled: i,
		className: J("relative h-6 w-11 rounded-full transition-colors outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50", e ? "bg-accent" : "bg-input-border", t),
		onClick: (t) => {
			n?.(t), t.defaultPrevented || r?.(!e);
		},
		...o,
		children: /* @__PURE__ */ a("span", { className: J("absolute top-0.5 left-0.5 size-5 rounded-full bg-background shadow-sm transition-transform", e ? "translate-x-5" : "translate-x-0") })
	});
}
//#endregion
//#region src/components/ui/tabs.tsx
function os({ items: e, value: t, onChange: n, className: r, tabClassName: i, activeTabClassName: s, ...c }) {
	return /* @__PURE__ */ a("div", {
		role: "tablist",
		className: J("flex gap-7 border-b border-border bg-card px-5", r),
		...c,
		children: e.map((e) => {
			let r = e.value === t;
			return /* @__PURE__ */ o("button", {
				type: "button",
				role: "tab",
				"aria-selected": r,
				disabled: e.disabled,
				title: e.title,
				onClick: () => {
					e.disabled || n(e.value);
				},
				className: J("relative py-4 text-[15px] font-semibold text-muted-foreground transition-colors hover:text-[#307ff6]", r && "text-[#307ff6] after:absolute after:inset-x-0 after:bottom-0 after:h-1 after:rounded-t after:bg-[#307ff6]", i, r && s),
				children: [e.label, e.count !== void 0 && /* @__PURE__ */ a("span", {
					className: "ml-1.5 text-xs",
					children: e.count
				})]
			}, e.value);
		})
	});
}
//#endregion
//#region src/components/ui/textarea.tsx
function ss({ className: t, id: n, label: r, variant: i = "default", fieldClassName: s, labelClassName: c, invalid: l, onValueChange: u, onChange: d, ...f }) {
	let p = e.useId(), m = n ?? (r ? p : void 0), h = /* @__PURE__ */ a("textarea", {
		id: m,
		"data-slot": "textarea",
		"aria-invalid": l,
		className: J(ls(i, !!l), t),
		onChange: (e) => {
			d?.(e), u?.(e.target.value);
		},
		...f
	});
	return !r && !s ? h : /* @__PURE__ */ o("div", {
		className: J("block min-w-0", s),
		children: [r && /* @__PURE__ */ a(Y, {
			htmlFor: m,
			className: J(cs(i), c),
			children: r
		}), h]
	});
}
function cs(e) {
	return e === "dashboard" ? "mb-[8px] block text-[16px] font-normal leading-[130%] text-[#404040]" : "mb-2 block text-sm font-medium leading-none text-foreground";
}
function ls(e, t) {
	return e === "dashboard" ? J("flex min-h-[120px] w-full min-w-0 resize-y rounded-[12px] border bg-[#f8f8f8] px-[14px] py-[12px] text-[14px] text-[#404040] shadow-none outline-none transition-[color,box-shadow] placeholder:text-[#8a8a8a] disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 focus-visible:ring-0", t ? "border-[#f75245] focus-visible:border-[#f75245]" : "border-[#f8f8f8] focus-visible:border-[#2f80ed]") : "flex min-h-20 w-full min-w-0 resize-y rounded-md border border-input bg-transparent px-3 py-2 text-base shadow-xs outline-none placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm";
}
//#endregion
//#region src/lib/html.ts
function us(e) {
	return typeof window > "u" ? e.replace(/<[^>]*>/g, " ") : new DOMParser().parseFromString(e, "text/html").body.textContent ?? "";
}
function ds(e) {
	if (typeof window > "u") return e.replace(/<[^>]*>/g, "");
	let t = new DOMParser().parseFromString(e, "text/html"), n = /* @__PURE__ */ new Set([
		"P",
		"BR",
		"STRONG",
		"B",
		"EM",
		"I",
		"U",
		"UL",
		"OL",
		"LI",
		"A",
		"BLOCKQUOTE"
	]), r = /* @__PURE__ */ new Set([
		"href",
		"target",
		"rel"
	]);
	for (let e of [...t.body.querySelectorAll("*")]) {
		if (!n.has(e.tagName)) {
			e.replaceWith(t.createTextNode(e.textContent ?? ""));
			continue;
		}
		for (let t of [...e.attributes]) r.has(t.name.toLowerCase()) || e.removeAttribute(t.name);
		if (e.tagName === "A") {
			let t = e.getAttribute("href")?.trim() ?? "";
			/^(https?:|mailto:)/i.test(t) || e.removeAttribute("href"), e.setAttribute("rel", "noopener noreferrer"), e.getAttribute("target") !== "_blank" && e.removeAttribute("target");
		}
	}
	return t.body.innerHTML;
}
function fs(e) {
	return /<\/?[a-z][\s\S]*>/i.test(e) ? ds(e) : `<p>${ps(e).replace(/\n/g, "<br>")}</p>`;
}
function ps(e) {
	return e.replaceAll("&", "&amp;").replaceAll("<", "&lt;").replaceAll(">", "&gt;").replaceAll("\"", "&quot;").replaceAll("'", "&#039;");
}
//#endregion
export { Zt as Autocomplete, cn as Avatar, gn as Badge, _n as BrandLogo, yn as Button, bn as Card, wn as CardContent, Cn as CardDescription, Tn as CardFooter, xn as CardHeader, Sn as CardTitle, Vt as CheckBox, Vt as Checkbox, Gt as CheckCircleIcon, qt as CheckSquareIcon, Wt as CheckboxCircleIndicator, Ht as CheckboxIndicator, Kt as CheckedCircleIcon, Jt as CheckedSquareIcon, Uo as DEFAULT_MAX_LOGO_BYTES, Dn as DataTable, tr as DatePicker, So as Dialog, ko as DialogBody, To as DialogClose, Do as DialogContent, Mo as DialogDescription, Ao as DialogFooter, Oo as DialogHeader, Eo as DialogOverlay, wo as DialogPortal, jo as DialogTitle, Co as DialogTrigger, Ut as IndeterminateSquareIcon, Po as Input, Bo as InputCollapse, Y as Label, Go as LogoUploader, qo as Menu, Jo as MenuItem, Rn as MultiSelect, Lt as PORTAL_POPOVER_ATTRIBUTE, Bt as PortalPopover, Yo as Progress, Xo as RadioGroup, No as SearchNormal, In as Select, is as Separator, Ln as SingleSelect, En as Skeleton, as as Switch, os as Tabs, ss as Textarea, mn as badgeVariants, vn as buttonVariants, J as cn, l as containsEventTarget, an as dedupeOptions, rn as filterOptions, fs as htmlForDisplay, Rt as isInsidePortaledPopover, ds as sanitizeHtml, us as stripHtml, c as useAnchoredPosition };
